var items = {
  "block.minecraft.acacia_button": "Акаціевая кнопка",
  "block.minecraft.acacia_door": "Акаціевая дверь",
  "block.minecraft.acacia_fence": "Акаціевый заборъ",
  "block.minecraft.acacia_fence_gate": "Акаціевая калитка",
  "block.minecraft.acacia_hanging_sign": "Акаціевая подвѣсная табличка",
  "block.minecraft.acacia_leaves": "Листья акаціи",
  "block.minecraft.acacia_log": "Акаціевое бревно",
  "block.minecraft.acacia_planks": "Акаціевыя доски",
  "block.minecraft.acacia_pressure_plate": "Акаціевая нажимная плита",
  "block.minecraft.acacia_sapling": "Саженецъ акаціи",
  "block.minecraft.acacia_shelf": "Акаціевая полка",
  "block.minecraft.acacia_sign": "Акаціевая табличка",
  "block.minecraft.acacia_slab": "Акаціевая плита",
  "block.minecraft.acacia_stairs": "Акаціевыя ступеньки",
  "block.minecraft.acacia_trapdoor": "Акаціевый люкъ",
  "block.minecraft.acacia_wall_hanging_sign": "Акаціевая настѣнная подвѣсная табличка",
  "block.minecraft.acacia_wall_sign": "Акаціевая настѣнная табличка",
  "block.minecraft.acacia_wood": "Акація",
  "block.minecraft.activator_rail": "Подающіе рельсы",
  "block.minecraft.air": "Воздухъ",
  "block.minecraft.allium": "Лукъ-батунъ",
  "block.minecraft.amethyst_block": "Аметистовый блокъ",
  "block.minecraft.amethyst_cluster": "Аметистовая друза",
  "block.minecraft.ancient_debris": "Древніе обломки",
  "block.minecraft.andesite": "Андезитъ",
  "block.minecraft.andesite_slab": "Андезитовая плита",
  "block.minecraft.andesite_stairs": "Андезитовыя ступеньки",
  "block.minecraft.andesite_wall": "Андезитовая ограда",
  "block.minecraft.anvil": "Наковальня",
  "block.minecraft.attached_melon_stem": "Прикрѣплённый стебель арбуза",
  "block.minecraft.attached_pumpkin_stem": "Прикрѣплённый стебель тыквы",
  "block.minecraft.azalea": "Азалія",
  "block.minecraft.azalea_leaves": "Листья азаліи",
  "block.minecraft.azure_bluet": "Хаустонія сѣрая",
  "block.minecraft.bamboo": "Бамбукъ",
  "block.minecraft.bamboo_block": "Блокъ бамбука",
  "block.minecraft.bamboo_button": "Бамбуковая кнопка",
  "block.minecraft.bamboo_door": "Бамбуковая дверь",
  "block.minecraft.bamboo_fence": "Бамбуковый заборъ",
  "block.minecraft.bamboo_fence_gate": "Бамбуковая калитка",
  "block.minecraft.bamboo_hanging_sign": "Бамбуковая подвѣсная табличка",
  "block.minecraft.bamboo_mosaic": "Бамбуковая мозаика",
  "block.minecraft.bamboo_mosaic_slab": "Плита изъ бамбуковой мозаики",
  "block.minecraft.bamboo_mosaic_stairs": "Ступеньки изъ бамбуковой мозаики",
  "block.minecraft.bamboo_planks": "Бамбуковыя доски",
  "block.minecraft.bamboo_pressure_plate": "Бамбуковая нажимная плита",
  "block.minecraft.bamboo_sapling": "Побѣгъ бамбука",
  "block.minecraft.bamboo_shelf": "Бамбуковая полка",
  "block.minecraft.bamboo_sign": "Бамбуковая табличка",
  "block.minecraft.bamboo_slab": "Бамбуковая плита",
  "block.minecraft.bamboo_stairs": "Бамбуковыя ступеньки",
  "block.minecraft.bamboo_trapdoor": "Бамбуковый люкъ",
  "block.minecraft.bamboo_wall_hanging_sign": "Бамбуковая настѣнная подвѣсная табличка",
  "block.minecraft.bamboo_wall_sign": "Бамбуковая настѣнная табличка",
  "block.minecraft.banner.base.black": "Чёрное поле",
  "block.minecraft.banner.base.blue": "Лазурное поле",
  "block.minecraft.banner.base.brown": "Коричневое поле",
  "block.minecraft.banner.base.cyan": "Бирюзовое поле",
  "block.minecraft.banner.base.gray": "Сѣрое поле",
  "block.minecraft.banner.base.green": "Зелёное поле",
  "block.minecraft.banner.base.light_blue": "Голубое поле",
  "block.minecraft.banner.base.light_gray": "Свѣтлосѣрое поле",
  "block.minecraft.banner.base.lime": "Яркозелёное поле",
  "block.minecraft.banner.base.magenta": "Пурпурное поле",
  "block.minecraft.banner.base.orange": "Оранжевое поле",
  "block.minecraft.banner.base.pink": "Розовое поле",
  "block.minecraft.banner.base.purple": "Фіолетовое поле",
  "block.minecraft.banner.base.red": "Червонное поле",
  "block.minecraft.banner.base.white": "Бѣлое поле",
  "block.minecraft.banner.base.yellow": "Жёлтое поле",
  "block.minecraft.banner.border.black": "Чёрная кайма",
  "block.minecraft.banner.border.blue": "Лазурная кайма",
  "block.minecraft.banner.border.brown": "Коричневая кайма",
  "block.minecraft.banner.border.cyan": "Бирюзовая кайма",
  "block.minecraft.banner.border.gray": "Сѣрая кайма",
  "block.minecraft.banner.border.green": "Зелёная кайма",
  "block.minecraft.banner.border.light_blue": "Голубая кайма",
  "block.minecraft.banner.border.light_gray": "Свѣтлосѣрая кайма",
  "block.minecraft.banner.border.lime": "Яркозелёная кайма",
  "block.minecraft.banner.border.magenta": "Пурпурная кайма",
  "block.minecraft.banner.border.orange": "Оранжевая кайма",
  "block.minecraft.banner.border.pink": "Розовая кайма",
  "block.minecraft.banner.border.purple": "Фіолетовая кайма",
  "block.minecraft.banner.border.red": "Червонная кайма",
  "block.minecraft.banner.border.white": "Бѣлая кайма",
  "block.minecraft.banner.border.yellow": "Жёлтая кайма",
  "block.minecraft.banner.bricks.black": "Чёрная муровка",
  "block.minecraft.banner.bricks.blue": "Лазурная муровка",
  "block.minecraft.banner.bricks.brown": "Коричневая муровка",
  "block.minecraft.banner.bricks.cyan": "Бирюзовая муровка",
  "block.minecraft.banner.bricks.gray": "Сѣрая муровка",
  "block.minecraft.banner.bricks.green": "Зелёная муровка",
  "block.minecraft.banner.bricks.light_blue": "Голубая муровка",
  "block.minecraft.banner.bricks.light_gray": "Свѣтлосѣрая муровка",
  "block.minecraft.banner.bricks.lime": "Яркозелёная муровка",
  "block.minecraft.banner.bricks.magenta": "Пурпурная муровка",
  "block.minecraft.banner.bricks.orange": "Оранжевая муровка",
  "block.minecraft.banner.bricks.pink": "Розовая муровка",
  "block.minecraft.banner.bricks.purple": "Фіолетовая муровка",
  "block.minecraft.banner.bricks.red": "Червонная муровка",
  "block.minecraft.banner.bricks.white": "Бѣлая муровка",
  "block.minecraft.banner.bricks.yellow": "Жёлтая муровка",
  "block.minecraft.banner.circle.black": "Чёрный кругъ",
  "block.minecraft.banner.circle.blue": "Лазурный кругъ",
  "block.minecraft.banner.circle.brown": "Коричневый кругъ",
  "block.minecraft.banner.circle.cyan": "Бирюзовый кругъ",
  "block.minecraft.banner.circle.gray": "Сѣрый кругъ",
  "block.minecraft.banner.circle.green": "Зелёный кругъ",
  "block.minecraft.banner.circle.light_blue": "Голубой кругъ",
  "block.minecraft.banner.circle.light_gray": "Свѣтлосѣрый кругъ",
  "block.minecraft.banner.circle.lime": "Яркозелёный кругъ",
  "block.minecraft.banner.circle.magenta": "Пурпурный кругъ",
  "block.minecraft.banner.circle.orange": "Оранжевый кругъ",
  "block.minecraft.banner.circle.pink": "Розовый кругъ",
  "block.minecraft.banner.circle.purple": "Фіолетовый кругъ",
  "block.minecraft.banner.circle.red": "Червонный кругъ",
  "block.minecraft.banner.circle.white": "Бѣлый кругъ",
  "block.minecraft.banner.circle.yellow": "Жёлтый кругъ",
  "block.minecraft.banner.creeper.black": "Чёрный криперъ",
  "block.minecraft.banner.creeper.blue": "Лазурный криперъ",
  "block.minecraft.banner.creeper.brown": "Коричневый криперъ",
  "block.minecraft.banner.creeper.cyan": "Бирюзовый криперъ",
  "block.minecraft.banner.creeper.gray": "Сѣрый криперъ",
  "block.minecraft.banner.creeper.green": "Зелёный криперъ",
  "block.minecraft.banner.creeper.light_blue": "Голубой криперъ",
  "block.minecraft.banner.creeper.light_gray": "Свѣтлосѣрый криперъ",
  "block.minecraft.banner.creeper.lime": "Яркозелёный криперъ",
  "block.minecraft.banner.creeper.magenta": "Пурпурный криперъ",
  "block.minecraft.banner.creeper.orange": "Оранжевый криперъ",
  "block.minecraft.banner.creeper.pink": "Розовый криперъ",
  "block.minecraft.banner.creeper.purple": "Фіолетовый криперъ",
  "block.minecraft.banner.creeper.red": "Червонный криперъ",
  "block.minecraft.banner.creeper.white": "Бѣлый криперъ",
  "block.minecraft.banner.creeper.yellow": "Жёлтый криперъ",
  "block.minecraft.banner.cross.black": "Чёрный Андреевскій крестъ",
  "block.minecraft.banner.cross.blue": "Лазурный Андреевскій крестъ",
  "block.minecraft.banner.cross.brown": "Коричневый Андреевскій крестъ",
  "block.minecraft.banner.cross.cyan": "Бирюзовый Андреевскій крестъ",
  "block.minecraft.banner.cross.gray": "Сѣрый Андреевскій крестъ",
  "block.minecraft.banner.cross.green": "Зелёный Андреевскій крестъ",
  "block.minecraft.banner.cross.light_blue": "Голубой Андреевскій крестъ",
  "block.minecraft.banner.cross.light_gray": "Свѣтлосѣрый Андреевскій крестъ",
  "block.minecraft.banner.cross.lime": "Яркозелёный Андреевскій крестъ",
  "block.minecraft.banner.cross.magenta": "Пурпурный Андреевскій крестъ",
  "block.minecraft.banner.cross.orange": "Оранжевый Андреевскій крестъ",
  "block.minecraft.banner.cross.pink": "Розовый Андреевскій крестъ",
  "block.minecraft.banner.cross.purple": "Фіолетовый Андреевскій крестъ",
  "block.minecraft.banner.cross.red": "Червонный Андреевскій крестъ",
  "block.minecraft.banner.cross.white": "Бѣлый Андреевскій крестъ",
  "block.minecraft.banner.cross.yellow": "Жёлтый Андреевскій крестъ",
  "block.minecraft.banner.curly_border.black": "Чёрная зубчатая кайма",
  "block.minecraft.banner.curly_border.blue": "Лазурная зубчатая кайма",
  "block.minecraft.banner.curly_border.brown": "Коричневая зубчатая кайма",
  "block.minecraft.banner.curly_border.cyan": "Бирюзовая зубчатая кайма",
  "block.minecraft.banner.curly_border.gray": "Сѣрая зубчатая кайма",
  "block.minecraft.banner.curly_border.green": "Зелёная зубчатая кайма",
  "block.minecraft.banner.curly_border.light_blue": "Голубая зубчатая кайма",
  "block.minecraft.banner.curly_border.light_gray": "Свѣтлосѣрая зубчатая кайма",
  "block.minecraft.banner.curly_border.lime": "Яркозелёная зубчатая кайма",
  "block.minecraft.banner.curly_border.magenta": "Пурпурная зубчатая кайма",
  "block.minecraft.banner.curly_border.orange": "Оранжевая зубчатая кайма",
  "block.minecraft.banner.curly_border.pink": "Розовая зубчатая кайма",
  "block.minecraft.banner.curly_border.purple": "Фіолетовая зубчатая кайма",
  "block.minecraft.banner.curly_border.red": "Червонная зубчатая кайма",
  "block.minecraft.banner.curly_border.white": "Бѣлая зубчатая кайма",
  "block.minecraft.banner.curly_border.yellow": "Жёлтая зубчатая кайма",
  "block.minecraft.banner.diagonal_left.black": "Чёрное скошеніе слѣва",
  "block.minecraft.banner.diagonal_left.blue": "Лазурное скошеніе слѣва",
  "block.minecraft.banner.diagonal_left.brown": "Коричневое скошеніе слѣва",
  "block.minecraft.banner.diagonal_left.cyan": "Бирюзовое скошеніе слѣва",
  "block.minecraft.banner.diagonal_left.gray": "Сѣрое скошеніе слѣва",
  "block.minecraft.banner.diagonal_left.green": "Зелёное скошеніе слѣва",
  "block.minecraft.banner.diagonal_left.light_blue": "Голубое скошеніе слѣва",
  "block.minecraft.banner.diagonal_left.light_gray": "Свѣтлосѣрое скошеніе слѣва",
  "block.minecraft.banner.diagonal_left.lime": "Яркозелёное скошеніе слѣва",
  "block.minecraft.banner.diagonal_left.magenta": "Пурпурное скошеніе слѣва",
  "block.minecraft.banner.diagonal_left.orange": "Оранжевое скошеніе слѣва",
  "block.minecraft.banner.diagonal_left.pink": "Розовое скошеніе слѣва",
  "block.minecraft.banner.diagonal_left.purple": "Фіолетовое скошеніе слѣва",
  "block.minecraft.banner.diagonal_left.red": "Червонное скошеніе слѣва",
  "block.minecraft.banner.diagonal_left.white": "Бѣлое скошеніе слѣва",
  "block.minecraft.banner.diagonal_left.yellow": "Жёлтое скошеніе слѣва",
  "block.minecraft.banner.diagonal_right.black": "Чёрное скошеніе",
  "block.minecraft.banner.diagonal_right.blue": "Лазурное скошеніе",
  "block.minecraft.banner.diagonal_right.brown": "Коричневое скошеніе",
  "block.minecraft.banner.diagonal_right.cyan": "Бирюзовое скошеніе",
  "block.minecraft.banner.diagonal_right.gray": "Сѣрое скошеніе",
  "block.minecraft.banner.diagonal_right.green": "Зелёное скошеніе",
  "block.minecraft.banner.diagonal_right.light_blue": "Голубое скошеніе",
  "block.minecraft.banner.diagonal_right.light_gray": "Свѣтлосѣрое скошеніе",
  "block.minecraft.banner.diagonal_right.lime": "Яркозелёное скошеніе",
  "block.minecraft.banner.diagonal_right.magenta": "Пурпурное скошеніе",
  "block.minecraft.banner.diagonal_right.orange": "Оранжевое скошеніе",
  "block.minecraft.banner.diagonal_right.pink": "Розовое скошеніе",
  "block.minecraft.banner.diagonal_right.purple": "Фіолетовое скошеніе",
  "block.minecraft.banner.diagonal_right.red": "Червонное скошеніе",
  "block.minecraft.banner.diagonal_right.white": "Бѣлое скошеніе",
  "block.minecraft.banner.diagonal_right.yellow": "Жёлтое скошеніе",
  "block.minecraft.banner.diagonal_up_left.black": "Чёрное опрокинутое скошеніе",
  "block.minecraft.banner.diagonal_up_left.blue": "Лазурное опрокинутое скошеніе",
  "block.minecraft.banner.diagonal_up_left.brown": "Коричневое опрокинутое скошеніе",
  "block.minecraft.banner.diagonal_up_left.cyan": "Бирюзовое опрокинутое скошеніе",
  "block.minecraft.banner.diagonal_up_left.gray": "Сѣрое опрокинутое скошеніе",
  "block.minecraft.banner.diagonal_up_left.green": "Зелёное опрокинутое скошеніе",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Голубое опрокинутое скошеніе",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Свѣтлосѣрое опрокинутое скошеніе",
  "block.minecraft.banner.diagonal_up_left.lime": "Яркозелёное опрокинутое скошеніе",
  "block.minecraft.banner.diagonal_up_left.magenta": "Пурпурное опрокинутое скошеніе",
  "block.minecraft.banner.diagonal_up_left.orange": "Оранжевое опрокинутое скошеніе",
  "block.minecraft.banner.diagonal_up_left.pink": "Розовое опрокинутое скошеніе",
  "block.minecraft.banner.diagonal_up_left.purple": "Фіолетовое опрокинутое скошеніе",
  "block.minecraft.banner.diagonal_up_left.red": "Червонное опрокинутое скошеніе",
  "block.minecraft.banner.diagonal_up_left.white": "Бѣлое опрокинутое скошеніе",
  "block.minecraft.banner.diagonal_up_left.yellow": "Жёлтое опрокинутое скошеніе",
  "block.minecraft.banner.diagonal_up_right.black": "Чёрное опрокинутое скошеніе слѣва",
  "block.minecraft.banner.diagonal_up_right.blue": "Лазурное опрокинутое скошеніе слѣва",
  "block.minecraft.banner.diagonal_up_right.brown": "Коричневое опрокинутое скошеніе слѣва",
  "block.minecraft.banner.diagonal_up_right.cyan": "Бирюзовое опрокинутое скошеніе слѣва",
  "block.minecraft.banner.diagonal_up_right.gray": "Сѣрое опрокинутое скошеніе слѣва",
  "block.minecraft.banner.diagonal_up_right.green": "Зелёное опрокинутое скошеніе слѣва",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Голубое опрокинутое скошеніе слѣва",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Свѣтлосѣрое опрокинутое скошеніе слѣва",
  "block.minecraft.banner.diagonal_up_right.lime": "Яркозелёное опрокинутое скошеніе слѣва",
  "block.minecraft.banner.diagonal_up_right.magenta": "Пурпурное опрокинутое скошеніе слѣва",
  "block.minecraft.banner.diagonal_up_right.orange": "Оранжевое опрокинутое скошеніе слѣва",
  "block.minecraft.banner.diagonal_up_right.pink": "Розовое опрокинутое скошеніе слѣва",
  "block.minecraft.banner.diagonal_up_right.purple": "Фіолетовое опрокинутое скошеніе слѣва",
  "block.minecraft.banner.diagonal_up_right.red": "Червонное опрокинутое скошеніе слѣва",
  "block.minecraft.banner.diagonal_up_right.white": "Бѣлое опрокинутое скошеніе слѣва",
  "block.minecraft.banner.diagonal_up_right.yellow": "Жёлтое опрокинутое скошеніе слѣва",
  "block.minecraft.banner.flow.black": "Чёрный потокъ",
  "block.minecraft.banner.flow.blue": "Лазурный потокъ",
  "block.minecraft.banner.flow.brown": "Коричневый потокъ",
  "block.minecraft.banner.flow.cyan": "Бирюзовый потокъ",
  "block.minecraft.banner.flow.gray": "Сѣрый потокъ",
  "block.minecraft.banner.flow.green": "Зелёный потокъ",
  "block.minecraft.banner.flow.light_blue": "Голубой потокъ",
  "block.minecraft.banner.flow.light_gray": "Свѣтлосѣрый потокъ",
  "block.minecraft.banner.flow.lime": "Яркозелёный потокъ",
  "block.minecraft.banner.flow.magenta": "Пурпурный потокъ",
  "block.minecraft.banner.flow.orange": "Оранжевый потокъ",
  "block.minecraft.banner.flow.pink": "Розовый потокъ",
  "block.minecraft.banner.flow.purple": "Фіолетовый потокъ",
  "block.minecraft.banner.flow.red": "Червонный потокъ",
  "block.minecraft.banner.flow.white": "Бѣлый потокъ",
  "block.minecraft.banner.flow.yellow": "Жёлтый потокъ",
  "block.minecraft.banner.flower.black": "Чёрный цвѣтокъ",
  "block.minecraft.banner.flower.blue": "Лазурный цвѣтокъ",
  "block.minecraft.banner.flower.brown": "Коричневый цвѣтокъ",
  "block.minecraft.banner.flower.cyan": "Бирюзовый цвѣтокъ",
  "block.minecraft.banner.flower.gray": "Сѣрый цвѣтокъ",
  "block.minecraft.banner.flower.green": "Зелёный цвѣтокъ",
  "block.minecraft.banner.flower.light_blue": "Голубой цвѣтокъ",
  "block.minecraft.banner.flower.light_gray": "Свѣтлосѣрый цвѣтокъ",
  "block.minecraft.banner.flower.lime": "Яркозелёный цвѣтокъ",
  "block.minecraft.banner.flower.magenta": "Пурпурный цвѣтокъ",
  "block.minecraft.banner.flower.orange": "Оранжевый цвѣтокъ",
  "block.minecraft.banner.flower.pink": "Розовый цвѣтокъ",
  "block.minecraft.banner.flower.purple": "Фіолетовый цвѣтокъ",
  "block.minecraft.banner.flower.red": "Червонный цвѣтокъ",
  "block.minecraft.banner.flower.white": "Бѣлый цвѣтокъ",
  "block.minecraft.banner.flower.yellow": "Жёлтый цвѣтокъ",
  "block.minecraft.banner.globe.black": "Чёрный глобусъ",
  "block.minecraft.banner.globe.blue": "Лазурный глобусъ",
  "block.minecraft.banner.globe.brown": "Коричневый глобусъ",
  "block.minecraft.banner.globe.cyan": "Бирюзовый глобусъ",
  "block.minecraft.banner.globe.gray": "Сѣрый глобусъ",
  "block.minecraft.banner.globe.green": "Зелёный глобусъ",
  "block.minecraft.banner.globe.light_blue": "Голубой глобусъ",
  "block.minecraft.banner.globe.light_gray": "Свѣтлосѣрый глобусъ",
  "block.minecraft.banner.globe.lime": "Яркозелёный глобусъ",
  "block.minecraft.banner.globe.magenta": "Пурпурный глобусъ",
  "block.minecraft.banner.globe.orange": "Оранжевый глобусъ",
  "block.minecraft.banner.globe.pink": "Розовый глобусъ",
  "block.minecraft.banner.globe.purple": "Фіолетовый глобусъ",
  "block.minecraft.banner.globe.red": "Червонный глобусъ",
  "block.minecraft.banner.globe.white": "Бѣлый глобусъ",
  "block.minecraft.banner.globe.yellow": "Жёлтый глобусъ",
  "block.minecraft.banner.gradient.black": "Чёрный градіентъ",
  "block.minecraft.banner.gradient.blue": "Лазурный градіентъ",
  "block.minecraft.banner.gradient.brown": "Коричневый градіентъ",
  "block.minecraft.banner.gradient.cyan": "Бирюзовый градіентъ",
  "block.minecraft.banner.gradient.gray": "Сѣрый градіентъ",
  "block.minecraft.banner.gradient.green": "Зелёный градіентъ",
  "block.minecraft.banner.gradient.light_blue": "Голубой градіентъ",
  "block.minecraft.banner.gradient.light_gray": "Свѣтлосѣрый градіентъ",
  "block.minecraft.banner.gradient.lime": "Яркозелёный градіентъ",
  "block.minecraft.banner.gradient.magenta": "Пурпурный градіентъ",
  "block.minecraft.banner.gradient.orange": "Оранжевый градіентъ",
  "block.minecraft.banner.gradient.pink": "Розовый градіентъ",
  "block.minecraft.banner.gradient.purple": "Фіолетовый градіентъ",
  "block.minecraft.banner.gradient.red": "Червонный градіентъ",
  "block.minecraft.banner.gradient.white": "Бѣлый градіентъ",
  "block.minecraft.banner.gradient.yellow": "Жёлтый градіентъ",
  "block.minecraft.banner.gradient_up.black": "Чёрный обратный градіентъ",
  "block.minecraft.banner.gradient_up.blue": "Лазурный обратный градіентъ",
  "block.minecraft.banner.gradient_up.brown": "Коричневый обратный градіентъ",
  "block.minecraft.banner.gradient_up.cyan": "Бирюзовый обратный градіентъ",
  "block.minecraft.banner.gradient_up.gray": "Сѣрый обратный градіентъ",
  "block.minecraft.banner.gradient_up.green": "Зелёный обратный градіентъ",
  "block.minecraft.banner.gradient_up.light_blue": "Голубой обратный градіентъ",
  "block.minecraft.banner.gradient_up.light_gray": "Свѣтлосѣрый обратный градіентъ",
  "block.minecraft.banner.gradient_up.lime": "Яркозелёный обратный градіентъ",
  "block.minecraft.banner.gradient_up.magenta": "Пурпурный обратный градіентъ",
  "block.minecraft.banner.gradient_up.orange": "Оранжевый обратный градіентъ",
  "block.minecraft.banner.gradient_up.pink": "Розовый обратный градіентъ",
  "block.minecraft.banner.gradient_up.purple": "Фіолетовый обратный градіентъ",
  "block.minecraft.banner.gradient_up.red": "Червонный обратный градіентъ",
  "block.minecraft.banner.gradient_up.white": "Бѣлый обратный градіентъ",
  "block.minecraft.banner.gradient_up.yellow": "Жёлтый обратный градіентъ",
  "block.minecraft.banner.guster.black": "Чёрный вихрь",
  "block.minecraft.banner.guster.blue": "Лазурный вихрь",
  "block.minecraft.banner.guster.brown": "Коричневый вихрь",
  "block.minecraft.banner.guster.cyan": "Бирюзовый вихрь",
  "block.minecraft.banner.guster.gray": "Сѣрый вихрь",
  "block.minecraft.banner.guster.green": "Зелёный вихрь",
  "block.minecraft.banner.guster.light_blue": "Голубой вихрь",
  "block.minecraft.banner.guster.light_gray": "Свѣтлосѣрый вихрь",
  "block.minecraft.banner.guster.lime": "Яркозелёный вихрь",
  "block.minecraft.banner.guster.magenta": "Пурпурный вихрь",
  "block.minecraft.banner.guster.orange": "Оранжевый вихрь",
  "block.minecraft.banner.guster.pink": "Розовый вихрь",
  "block.minecraft.banner.guster.purple": "Фіолетовый вихрь",
  "block.minecraft.banner.guster.red": "Червонный вихрь",
  "block.minecraft.banner.guster.white": "Бѣлый вихрь",
  "block.minecraft.banner.guster.yellow": "Жёлтый вихрь",
  "block.minecraft.banner.half_horizontal.black": "Чёрная верхняя половина",
  "block.minecraft.banner.half_horizontal.blue": "Лазурная верхняя половина",
  "block.minecraft.banner.half_horizontal.brown": "Коричневая верхняя половина",
  "block.minecraft.banner.half_horizontal.cyan": "Бирюзовая верхняя половина",
  "block.minecraft.banner.half_horizontal.gray": "Сѣрая верхняя половина",
  "block.minecraft.banner.half_horizontal.green": "Зелёная верхняя половина",
  "block.minecraft.banner.half_horizontal.light_blue": "Голубая верхняя половина",
  "block.minecraft.banner.half_horizontal.light_gray": "Свѣтлосѣрая верхняя половина",
  "block.minecraft.banner.half_horizontal.lime": "Яркозелёная верхняя половина",
  "block.minecraft.banner.half_horizontal.magenta": "Пурпурная верхняя половина",
  "block.minecraft.banner.half_horizontal.orange": "Оранжевая верхняя половина",
  "block.minecraft.banner.half_horizontal.pink": "Розовая верхняя половина",
  "block.minecraft.banner.half_horizontal.purple": "Фіолетовая верхняя половина",
  "block.minecraft.banner.half_horizontal.red": "Червонная верхняя половина",
  "block.minecraft.banner.half_horizontal.white": "Бѣлая верхняя половина",
  "block.minecraft.banner.half_horizontal.yellow": "Жёлтая верхняя половина",
  "block.minecraft.banner.half_horizontal_bottom.black": "Чёрная нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Лазурная нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Коричневая нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Бирюзовая нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Сѣрая нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.green": "Зелёная нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Голубая нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Свѣтлосѣрая нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Яркозелёная нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Пурпурная нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Оранжевая нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Розовая нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Фіолетовая нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.red": "Червонная нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.white": "Бѣлая нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Жёлтая нижняя половина",
  "block.minecraft.banner.half_vertical.black": "Чёрная правая половина",
  "block.minecraft.banner.half_vertical.blue": "Лазурная правая половина",
  "block.minecraft.banner.half_vertical.brown": "Коричневая правая половина",
  "block.minecraft.banner.half_vertical.cyan": "Бирюзовая правая половина",
  "block.minecraft.banner.half_vertical.gray": "Сѣрая правая половина",
  "block.minecraft.banner.half_vertical.green": "Зелёная правая половина",
  "block.minecraft.banner.half_vertical.light_blue": "Голубая правая половина",
  "block.minecraft.banner.half_vertical.light_gray": "Свѣтлосѣрая правая половина",
  "block.minecraft.banner.half_vertical.lime": "Яркозелёная правая половина",
  "block.minecraft.banner.half_vertical.magenta": "Пурпурная правая половина",
  "block.minecraft.banner.half_vertical.orange": "Оранжевая правая половина",
  "block.minecraft.banner.half_vertical.pink": "Розовая правая половина",
  "block.minecraft.banner.half_vertical.purple": "Фіолетовая правая половина",
  "block.minecraft.banner.half_vertical.red": "Червонная правая половина",
  "block.minecraft.banner.half_vertical.white": "Бѣлая правая половина",
  "block.minecraft.banner.half_vertical.yellow": "Жёлтая правая половина",
  "block.minecraft.banner.half_vertical_right.black": "Чёрная лѣвая половина",
  "block.minecraft.banner.half_vertical_right.blue": "Лазурная лѣвая половина",
  "block.minecraft.banner.half_vertical_right.brown": "Коричневая лѣвая половина",
  "block.minecraft.banner.half_vertical_right.cyan": "Бирюзовая лѣвая половина",
  "block.minecraft.banner.half_vertical_right.gray": "Сѣрая лѣвая половина",
  "block.minecraft.banner.half_vertical_right.green": "Зелёная лѣвая половина",
  "block.minecraft.banner.half_vertical_right.light_blue": "Голубая лѣвая половина",
  "block.minecraft.banner.half_vertical_right.light_gray": "Свѣтлосѣрая лѣвая половина",
  "block.minecraft.banner.half_vertical_right.lime": "Яркозелёная лѣвая половина",
  "block.minecraft.banner.half_vertical_right.magenta": "Пурпурная лѣвая половина",
  "block.minecraft.banner.half_vertical_right.orange": "Оранжевая лѣвая половина",
  "block.minecraft.banner.half_vertical_right.pink": "Розовая лѣвая половина",
  "block.minecraft.banner.half_vertical_right.purple": "Фіолетовая лѣвая половина",
  "block.minecraft.banner.half_vertical_right.red": "Червонная лѣвая половина",
  "block.minecraft.banner.half_vertical_right.white": "Бѣлая лѣвая половина",
  "block.minecraft.banner.half_vertical_right.yellow": "Жёлтая лѣвая половина",
  "block.minecraft.banner.mojang.black": "Чёрное нѣчто",
  "block.minecraft.banner.mojang.blue": "Лазурное нѣчто",
  "block.minecraft.banner.mojang.brown": "Коричневое нѣчто",
  "block.minecraft.banner.mojang.cyan": "Бирюзовое нѣчто",
  "block.minecraft.banner.mojang.gray": "Сѣрое нѣчто",
  "block.minecraft.banner.mojang.green": "Зелёное нѣчто",
  "block.minecraft.banner.mojang.light_blue": "Голубое нѣчто",
  "block.minecraft.banner.mojang.light_gray": "Свѣтлосѣрое нѣчто",
  "block.minecraft.banner.mojang.lime": "Яркозелёное нѣчто",
  "block.minecraft.banner.mojang.magenta": "Пурпурное нѣчто",
  "block.minecraft.banner.mojang.orange": "Оранжевое нѣчто",
  "block.minecraft.banner.mojang.pink": "Розовое нѣчто",
  "block.minecraft.banner.mojang.purple": "Фіолетовое нѣчто",
  "block.minecraft.banner.mojang.red": "Червонное нѣчто",
  "block.minecraft.banner.mojang.white": "Бѣлое нѣчто",
  "block.minecraft.banner.mojang.yellow": "Жёлтое нѣчто",
  "block.minecraft.banner.piglin.black": "Чёрное рыло",
  "block.minecraft.banner.piglin.blue": "Лазурное рыло",
  "block.minecraft.banner.piglin.brown": "Коричневое рыло",
  "block.minecraft.banner.piglin.cyan": "Бирюзовое рыло",
  "block.minecraft.banner.piglin.gray": "Сѣрое рыло",
  "block.minecraft.banner.piglin.green": "Зелёное рыло",
  "block.minecraft.banner.piglin.light_blue": "Голубое рыло",
  "block.minecraft.banner.piglin.light_gray": "Свѣтлосѣрое рыло",
  "block.minecraft.banner.piglin.lime": "Яркозелёное рыло",
  "block.minecraft.banner.piglin.magenta": "Пурпурное рыло",
  "block.minecraft.banner.piglin.orange": "Оранжевое рыло",
  "block.minecraft.banner.piglin.pink": "Розовое рыло",
  "block.minecraft.banner.piglin.purple": "Фіолетовое рыло",
  "block.minecraft.banner.piglin.red": "Червонное рыло",
  "block.minecraft.banner.piglin.white": "Бѣлое рыло",
  "block.minecraft.banner.piglin.yellow": "Жёлтое рыло",
  "block.minecraft.banner.rhombus.black": "Чёрный ромбъ",
  "block.minecraft.banner.rhombus.blue": "Лазурный ромбъ",
  "block.minecraft.banner.rhombus.brown": "Коричневый ромбъ",
  "block.minecraft.banner.rhombus.cyan": "Бирюзовый ромбъ",
  "block.minecraft.banner.rhombus.gray": "Сѣрый ромбъ",
  "block.minecraft.banner.rhombus.green": "Зелёный ромбъ",
  "block.minecraft.banner.rhombus.light_blue": "Голубой ромбъ",
  "block.minecraft.banner.rhombus.light_gray": "Свѣтлосѣрый ромбъ",
  "block.minecraft.banner.rhombus.lime": "Яркозелёный ромбъ",
  "block.minecraft.banner.rhombus.magenta": "Пурпурный ромбъ",
  "block.minecraft.banner.rhombus.orange": "Оранжевый ромбъ",
  "block.minecraft.banner.rhombus.pink": "Розовый ромбъ",
  "block.minecraft.banner.rhombus.purple": "Фіолетовый ромбъ",
  "block.minecraft.banner.rhombus.red": "Червонный ромбъ",
  "block.minecraft.banner.rhombus.white": "Бѣлый ромбъ",
  "block.minecraft.banner.rhombus.yellow": "Жёлтый ромбъ",
  "block.minecraft.banner.skull.black": "Чёрный черепъ",
  "block.minecraft.banner.skull.blue": "Лазурный черепъ",
  "block.minecraft.banner.skull.brown": "Коричневый черепъ",
  "block.minecraft.banner.skull.cyan": "Бирюзовый черепъ",
  "block.minecraft.banner.skull.gray": "Сѣрый черепъ",
  "block.minecraft.banner.skull.green": "Зелёный черепъ",
  "block.minecraft.banner.skull.light_blue": "Голубой черепъ",
  "block.minecraft.banner.skull.light_gray": "Свѣтлосѣрый черепъ",
  "block.minecraft.banner.skull.lime": "Яркозелёный черепъ",
  "block.minecraft.banner.skull.magenta": "Пурпурный черепъ",
  "block.minecraft.banner.skull.orange": "Оранжевый черепъ",
  "block.minecraft.banner.skull.pink": "Розовый черепъ",
  "block.minecraft.banner.skull.purple": "Фіолетовый черепъ",
  "block.minecraft.banner.skull.red": "Червонный черепъ",
  "block.minecraft.banner.skull.white": "Бѣлый черепъ",
  "block.minecraft.banner.skull.yellow": "Жёлтый черепъ",
  "block.minecraft.banner.small_stripes.black": "Чёрные столбы",
  "block.minecraft.banner.small_stripes.blue": "Лазурные столбы",
  "block.minecraft.banner.small_stripes.brown": "Коричневые столбы",
  "block.minecraft.banner.small_stripes.cyan": "Бирюзовые столбы",
  "block.minecraft.banner.small_stripes.gray": "Сѣрые столбы",
  "block.minecraft.banner.small_stripes.green": "Зелёные столбы",
  "block.minecraft.banner.small_stripes.light_blue": "Голубые столбы",
  "block.minecraft.banner.small_stripes.light_gray": "Свѣтлосѣрые столбы",
  "block.minecraft.banner.small_stripes.lime": "Яркозелёные столбы",
  "block.minecraft.banner.small_stripes.magenta": "Пурпурные столбы",
  "block.minecraft.banner.small_stripes.orange": "Оранжевые столбы",
  "block.minecraft.banner.small_stripes.pink": "Розовые столбы",
  "block.minecraft.banner.small_stripes.purple": "Фіолетовые столбы",
  "block.minecraft.banner.small_stripes.red": "Червонные столбы",
  "block.minecraft.banner.small_stripes.white": "Бѣлые столбы",
  "block.minecraft.banner.small_stripes.yellow": "Жёлтые столбы",
  "block.minecraft.banner.square_bottom_left.black": "Чёрный нижній правый крыжъ",
  "block.minecraft.banner.square_bottom_left.blue": "Лазурный нижній правый крыжъ",
  "block.minecraft.banner.square_bottom_left.brown": "Коричневый нижній правый крыжъ",
  "block.minecraft.banner.square_bottom_left.cyan": "Бирюзовый нижній правый крыжъ",
  "block.minecraft.banner.square_bottom_left.gray": "Сѣрый нижній правый крыжъ",
  "block.minecraft.banner.square_bottom_left.green": "Зелёный нижній правый крыжъ",
  "block.minecraft.banner.square_bottom_left.light_blue": "Голубой нижній правый крыжъ",
  "block.minecraft.banner.square_bottom_left.light_gray": "Свѣтлосѣрый нижній правый крыжъ",
  "block.minecraft.banner.square_bottom_left.lime": "Яркозелёный нижній правый крыжъ",
  "block.minecraft.banner.square_bottom_left.magenta": "Пурпурный нижній правый крыжъ",
  "block.minecraft.banner.square_bottom_left.orange": "Оранжевый нижній правый крыжъ",
  "block.minecraft.banner.square_bottom_left.pink": "Розовый нижній правый крыжъ",
  "block.minecraft.banner.square_bottom_left.purple": "Фіолетовый нижній правый крыжъ",
  "block.minecraft.banner.square_bottom_left.red": "Червонный нижній правый крыжъ",
  "block.minecraft.banner.square_bottom_left.white": "Бѣлый нижній правый крыжъ",
  "block.minecraft.banner.square_bottom_left.yellow": "Жёлтый нижній правый крыжъ",
  "block.minecraft.banner.square_bottom_right.black": "Чёрный нижній лѣвый крыжъ",
  "block.minecraft.banner.square_bottom_right.blue": "Лазурный нижній лѣвый крыжъ",
  "block.minecraft.banner.square_bottom_right.brown": "Коричневый нижній лѣвый крыжъ",
  "block.minecraft.banner.square_bottom_right.cyan": "Бирюзовый нижній лѣвый крыжъ",
  "block.minecraft.banner.square_bottom_right.gray": "Сѣрый нижній лѣвый крыжъ",
  "block.minecraft.banner.square_bottom_right.green": "Зелёный нижній лѣвый крыжъ",
  "block.minecraft.banner.square_bottom_right.light_blue": "Голубой нижній лѣвый крыжъ",
  "block.minecraft.banner.square_bottom_right.light_gray": "Свѣтлосѣрый нижній лѣвый крыжъ",
  "block.minecraft.banner.square_bottom_right.lime": "Яркозелёный нижній лѣвый крыжъ",
  "block.minecraft.banner.square_bottom_right.magenta": "Пурпурный нижній лѣвый крыжъ",
  "block.minecraft.banner.square_bottom_right.orange": "Оранжевый нижній лѣвый крыжъ",
  "block.minecraft.banner.square_bottom_right.pink": "Розовый нижній лѣвый крыжъ",
  "block.minecraft.banner.square_bottom_right.purple": "Фіолетовый нижній лѣвый крыжъ",
  "block.minecraft.banner.square_bottom_right.red": "Червонный нижній лѣвый крыжъ",
  "block.minecraft.banner.square_bottom_right.white": "Бѣлый нижній лѣвый крыжъ",
  "block.minecraft.banner.square_bottom_right.yellow": "Жёлтый нижній лѣвый крыжъ",
  "block.minecraft.banner.square_top_left.black": "Чёрный верхній правый крыжъ",
  "block.minecraft.banner.square_top_left.blue": "Лазурный верхній правый крыжъ",
  "block.minecraft.banner.square_top_left.brown": "Коричневый верхній правый крыжъ",
  "block.minecraft.banner.square_top_left.cyan": "Бирюзовый верхній правый крыжъ",
  "block.minecraft.banner.square_top_left.gray": "Сѣрый верхній правый крыжъ",
  "block.minecraft.banner.square_top_left.green": "Зелёный верхній правый крыжъ",
  "block.minecraft.banner.square_top_left.light_blue": "Голубой верхній правый крыжъ",
  "block.minecraft.banner.square_top_left.light_gray": "Свѣтлосѣрый верхній правый крыжъ",
  "block.minecraft.banner.square_top_left.lime": "Яркозелёный верхній правый крыжъ",
  "block.minecraft.banner.square_top_left.magenta": "Пурпурный верхній правый крыжъ",
  "block.minecraft.banner.square_top_left.orange": "Оранжевый верхній правый крыжъ",
  "block.minecraft.banner.square_top_left.pink": "Розовый верхній правый крыжъ",
  "block.minecraft.banner.square_top_left.purple": "Фіолетовый верхній правый крыжъ",
  "block.minecraft.banner.square_top_left.red": "Червонный верхній правый крыжъ",
  "block.minecraft.banner.square_top_left.white": "Бѣлый верхній правый крыжъ",
  "block.minecraft.banner.square_top_left.yellow": "Жёлтый верхній правый крыжъ",
  "block.minecraft.banner.square_top_right.black": "Чёрный верхній лѣвый крыжъ",
  "block.minecraft.banner.square_top_right.blue": "Лазурный верхній лѣвый крыжъ",
  "block.minecraft.banner.square_top_right.brown": "Коричневый верхній лѣвый крыжъ",
  "block.minecraft.banner.square_top_right.cyan": "Бирюзовый верхній лѣвый крыжъ",
  "block.minecraft.banner.square_top_right.gray": "Сѣрый верхній лѣвый крыжъ",
  "block.minecraft.banner.square_top_right.green": "Зелёный верхній лѣвый крыжъ",
  "block.minecraft.banner.square_top_right.light_blue": "Голубой верхній лѣвый крыжъ",
  "block.minecraft.banner.square_top_right.light_gray": "Свѣтлосѣрый верхній лѣвый крыжъ",
  "block.minecraft.banner.square_top_right.lime": "Яркозелёный верхній лѣвый крыжъ",
  "block.minecraft.banner.square_top_right.magenta": "Пурпурный верхній лѣвый крыжъ",
  "block.minecraft.banner.square_top_right.orange": "Оранжевый верхній лѣвый крыжъ",
  "block.minecraft.banner.square_top_right.pink": "Розовый верхній лѣвый крыжъ",
  "block.minecraft.banner.square_top_right.purple": "Фіолетовый верхній лѣвый крыжъ",
  "block.minecraft.banner.square_top_right.red": "Червонный верхній лѣвый крыжъ",
  "block.minecraft.banner.square_top_right.white": "Бѣлый верхній лѣвый крыжъ",
  "block.minecraft.banner.square_top_right.yellow": "Жёлтый верхній лѣвый крыжъ",
  "block.minecraft.banner.straight_cross.black": "Чёрный крестъ",
  "block.minecraft.banner.straight_cross.blue": "Лазурный крестъ",
  "block.minecraft.banner.straight_cross.brown": "Коричневый крестъ",
  "block.minecraft.banner.straight_cross.cyan": "Бирюзовый крестъ",
  "block.minecraft.banner.straight_cross.gray": "Сѣрый крестъ",
  "block.minecraft.banner.straight_cross.green": "Зелёный крестъ",
  "block.minecraft.banner.straight_cross.light_blue": "Голубой крестъ",
  "block.minecraft.banner.straight_cross.light_gray": "Свѣтлосѣрый крестъ",
  "block.minecraft.banner.straight_cross.lime": "Яркозелёный крестъ",
  "block.minecraft.banner.straight_cross.magenta": "Пурпурный крестъ",
  "block.minecraft.banner.straight_cross.orange": "Оранжевый крестъ",
  "block.minecraft.banner.straight_cross.pink": "Розовый крестъ",
  "block.minecraft.banner.straight_cross.purple": "Фіолетовый крестъ",
  "block.minecraft.banner.straight_cross.red": "Червонный крестъ",
  "block.minecraft.banner.straight_cross.white": "Бѣлый крестъ",
  "block.minecraft.banner.straight_cross.yellow": "Жёлтый крестъ",
  "block.minecraft.banner.stripe_bottom.black": "Чёрное основаніе",
  "block.minecraft.banner.stripe_bottom.blue": "Лазурное основаніе",
  "block.minecraft.banner.stripe_bottom.brown": "Коричневое основаніе",
  "block.minecraft.banner.stripe_bottom.cyan": "Бирюзовое основаніе",
  "block.minecraft.banner.stripe_bottom.gray": "Сѣрое основаніе",
  "block.minecraft.banner.stripe_bottom.green": "Зелёное основаніе",
  "block.minecraft.banner.stripe_bottom.light_blue": "Голубое основаніе",
  "block.minecraft.banner.stripe_bottom.light_gray": "Свѣтлосѣрое основаніе",
  "block.minecraft.banner.stripe_bottom.lime": "Яркозелёное основаніе",
  "block.minecraft.banner.stripe_bottom.magenta": "Пурпурное основаніе",
  "block.minecraft.banner.stripe_bottom.orange": "Оранжевое основаніе",
  "block.minecraft.banner.stripe_bottom.pink": "Розовое основаніе",
  "block.minecraft.banner.stripe_bottom.purple": "Фіолетовое основаніе",
  "block.minecraft.banner.stripe_bottom.red": "Червонное основаніе",
  "block.minecraft.banner.stripe_bottom.white": "Бѣлое основаніе",
  "block.minecraft.banner.stripe_bottom.yellow": "Жёлтое основаніе",
  "block.minecraft.banner.stripe_center.black": "Чёрный столбъ",
  "block.minecraft.banner.stripe_center.blue": "Лазурный столбъ",
  "block.minecraft.banner.stripe_center.brown": "Коричневый столбъ",
  "block.minecraft.banner.stripe_center.cyan": "Бирюзовый столбъ",
  "block.minecraft.banner.stripe_center.gray": "Сѣрый столбъ",
  "block.minecraft.banner.stripe_center.green": "Зелёный столбъ",
  "block.minecraft.banner.stripe_center.light_blue": "Голубой столбъ",
  "block.minecraft.banner.stripe_center.light_gray": "Свѣтлосѣрый столбъ",
  "block.minecraft.banner.stripe_center.lime": "Яркозелёный столбъ",
  "block.minecraft.banner.stripe_center.magenta": "Пурпурный столбъ",
  "block.minecraft.banner.stripe_center.orange": "Оранжевый столбъ",
  "block.minecraft.banner.stripe_center.pink": "Розовый столбъ",
  "block.minecraft.banner.stripe_center.purple": "Фіолетовый столбъ",
  "block.minecraft.banner.stripe_center.red": "Червонный столбъ",
  "block.minecraft.banner.stripe_center.white": "Бѣлый столбъ",
  "block.minecraft.banner.stripe_center.yellow": "Жёлтый столбъ",
  "block.minecraft.banner.stripe_downleft.black": "Чёрная лѣвосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.blue": "Лазурная лѣвосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.brown": "Коричневая лѣвосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.cyan": "Бирюзовая лѣвосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.gray": "Сѣрая лѣвосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.green": "Зелёная лѣвосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.light_blue": "Голубая лѣвосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.light_gray": "Свѣтлосѣрая лѣвосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.lime": "Яркозелёная лѣвосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.magenta": "Пурпурная лѣвосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.orange": "Оранжевая лѣвосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.pink": "Розовая лѣвосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.purple": "Фіолетовая лѣвосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.red": "Червонная лѣвосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.white": "Бѣлая лѣвосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.yellow": "Жёлтая лѣвосторонняя перевязь",
  "block.minecraft.banner.stripe_downright.black": "Чёрная перевязь",
  "block.minecraft.banner.stripe_downright.blue": "Лазурная перевязь",
  "block.minecraft.banner.stripe_downright.brown": "Коричневая перевязь",
  "block.minecraft.banner.stripe_downright.cyan": "Бирюзовая перевязь",
  "block.minecraft.banner.stripe_downright.gray": "Сѣрая перевязь",
  "block.minecraft.banner.stripe_downright.green": "Зелёная перевязь",
  "block.minecraft.banner.stripe_downright.light_blue": "Голубая перевязь",
  "block.minecraft.banner.stripe_downright.light_gray": "Свѣтлосѣрая перевязь",
  "block.minecraft.banner.stripe_downright.lime": "Яркозелёная перевязь",
  "block.minecraft.banner.stripe_downright.magenta": "Пурпурная перевязь",
  "block.minecraft.banner.stripe_downright.orange": "Оранжевая перевязь",
  "block.minecraft.banner.stripe_downright.pink": "Розовая перевязь",
  "block.minecraft.banner.stripe_downright.purple": "Фіолетовая перевязь",
  "block.minecraft.banner.stripe_downright.red": "Червонная перевязь",
  "block.minecraft.banner.stripe_downright.white": "Бѣлая перевязь",
  "block.minecraft.banner.stripe_downright.yellow": "Жёлтая перевязь",
  "block.minecraft.banner.stripe_left.black": "Чёрный правосторонній столбъ",
  "block.minecraft.banner.stripe_left.blue": "Лазурный правосторонній столбъ",
  "block.minecraft.banner.stripe_left.brown": "Коричневый правосторонній столбъ",
  "block.minecraft.banner.stripe_left.cyan": "Бирюзовый правосторонній столбъ",
  "block.minecraft.banner.stripe_left.gray": "Сѣрый правосторонній столбъ",
  "block.minecraft.banner.stripe_left.green": "Зелёный правосторонній столбъ",
  "block.minecraft.banner.stripe_left.light_blue": "Голубой правосторонній столбъ",
  "block.minecraft.banner.stripe_left.light_gray": "Свѣтлосѣрый правосторонній столбъ",
  "block.minecraft.banner.stripe_left.lime": "Яркозелёный правосторонній столбъ",
  "block.minecraft.banner.stripe_left.magenta": "Пурпурный правосторонній столбъ",
  "block.minecraft.banner.stripe_left.orange": "Оранжевый правосторонній столбъ",
  "block.minecraft.banner.stripe_left.pink": "Розовый правосторонній столбъ",
  "block.minecraft.banner.stripe_left.purple": "Фіолетовый правосторонній столбъ",
  "block.minecraft.banner.stripe_left.red": "Червонный правосторонній столбъ",
  "block.minecraft.banner.stripe_left.white": "Бѣлый правосторонній столбъ",
  "block.minecraft.banner.stripe_left.yellow": "Жёлтый правосторонній столбъ",
  "block.minecraft.banner.stripe_middle.black": "Чёрный поясъ",
  "block.minecraft.banner.stripe_middle.blue": "Лазурный поясъ",
  "block.minecraft.banner.stripe_middle.brown": "Коричневый поясъ",
  "block.minecraft.banner.stripe_middle.cyan": "Бирюзовый поясъ",
  "block.minecraft.banner.stripe_middle.gray": "Сѣрый поясъ",
  "block.minecraft.banner.stripe_middle.green": "Зелёный поясъ",
  "block.minecraft.banner.stripe_middle.light_blue": "Голубой поясъ",
  "block.minecraft.banner.stripe_middle.light_gray": "Свѣтлосѣрый поясъ",
  "block.minecraft.banner.stripe_middle.lime": "Яркозелёный поясъ",
  "block.minecraft.banner.stripe_middle.magenta": "Пурпурный поясъ",
  "block.minecraft.banner.stripe_middle.orange": "Оранжевый поясъ",
  "block.minecraft.banner.stripe_middle.pink": "Розовый поясъ",
  "block.minecraft.banner.stripe_middle.purple": "Фіолетовый поясъ",
  "block.minecraft.banner.stripe_middle.red": "Червонный поясъ",
  "block.minecraft.banner.stripe_middle.white": "Бѣлый поясъ",
  "block.minecraft.banner.stripe_middle.yellow": "Жёлтый поясъ",
  "block.minecraft.banner.stripe_right.black": "Чёрный лѣвосторонній столбъ",
  "block.minecraft.banner.stripe_right.blue": "Лазурный лѣвосторонній столбъ",
  "block.minecraft.banner.stripe_right.brown": "Коричневый лѣвосторонній столбъ",
  "block.minecraft.banner.stripe_right.cyan": "Бирюзовый лѣвосторонній столбъ",
  "block.minecraft.banner.stripe_right.gray": "Сѣрый лѣвосторонній столбъ",
  "block.minecraft.banner.stripe_right.green": "Зелёный лѣвосторонній столбъ",
  "block.minecraft.banner.stripe_right.light_blue": "Голубой лѣвосторонній столбъ",
  "block.minecraft.banner.stripe_right.light_gray": "Свѣтлосѣрый лѣвосторонній столбъ",
  "block.minecraft.banner.stripe_right.lime": "Яркозелёный лѣвосторонній столбъ",
  "block.minecraft.banner.stripe_right.magenta": "Пурпурный лѣвосторонній столбъ",
  "block.minecraft.banner.stripe_right.orange": "Оранжевый лѣвосторонній столбъ",
  "block.minecraft.banner.stripe_right.pink": "Розовый лѣвосторонній столбъ",
  "block.minecraft.banner.stripe_right.purple": "Фіолетовый лѣвосторонній столбъ",
  "block.minecraft.banner.stripe_right.red": "Червонный лѣвосторонній столбъ",
  "block.minecraft.banner.stripe_right.white": "Бѣлый лѣвосторонній столбъ",
  "block.minecraft.banner.stripe_right.yellow": "Жёлтый лѣвосторонній столбъ",
  "block.minecraft.banner.stripe_top.black": "Чёрная глава",
  "block.minecraft.banner.stripe_top.blue": "Лазурная глава",
  "block.minecraft.banner.stripe_top.brown": "Коричневая глава",
  "block.minecraft.banner.stripe_top.cyan": "Бирюзовая глава",
  "block.minecraft.banner.stripe_top.gray": "Сѣрая глава",
  "block.minecraft.banner.stripe_top.green": "Зелёная глава",
  "block.minecraft.banner.stripe_top.light_blue": "Голубая глава",
  "block.minecraft.banner.stripe_top.light_gray": "Свѣтлосѣрая глава",
  "block.minecraft.banner.stripe_top.lime": "Яркозелёная глава",
  "block.minecraft.banner.stripe_top.magenta": "Пурпурная глава",
  "block.minecraft.banner.stripe_top.orange": "Оранжевая глава",
  "block.minecraft.banner.stripe_top.pink": "Розовая глава",
  "block.minecraft.banner.stripe_top.purple": "Фіолетовая глава",
  "block.minecraft.banner.stripe_top.red": "Червонная глава",
  "block.minecraft.banner.stripe_top.white": "Бѣлая глава",
  "block.minecraft.banner.stripe_top.yellow": "Жёлтая глава",
  "block.minecraft.banner.triangle_bottom.black": "Чёрное остріё",
  "block.minecraft.banner.triangle_bottom.blue": "Лазурное остріё",
  "block.minecraft.banner.triangle_bottom.brown": "Коричневое остріё",
  "block.minecraft.banner.triangle_bottom.cyan": "Бирюзовое остріё",
  "block.minecraft.banner.triangle_bottom.gray": "Сѣрое остріё",
  "block.minecraft.banner.triangle_bottom.green": "Зелёное остріё",
  "block.minecraft.banner.triangle_bottom.light_blue": "Голубое остріё",
  "block.minecraft.banner.triangle_bottom.light_gray": "Свѣтлосѣрое остріё",
  "block.minecraft.banner.triangle_bottom.lime": "Яркозелёное остріё",
  "block.minecraft.banner.triangle_bottom.magenta": "Пурпурное остріё",
  "block.minecraft.banner.triangle_bottom.orange": "Оранжевое остріё",
  "block.minecraft.banner.triangle_bottom.pink": "Розовое остріё",
  "block.minecraft.banner.triangle_bottom.purple": "Фіолетовое остріё",
  "block.minecraft.banner.triangle_bottom.red": "Червонное остріё",
  "block.minecraft.banner.triangle_bottom.white": "Бѣлое остріё",
  "block.minecraft.banner.triangle_bottom.yellow": "Жёлтое остріё",
  "block.minecraft.banner.triangle_top.black": "Чёрное опрокинутое остріё",
  "block.minecraft.banner.triangle_top.blue": "Лазурное опрокинутое остріё",
  "block.minecraft.banner.triangle_top.brown": "Коричневое опрокинутое остріё",
  "block.minecraft.banner.triangle_top.cyan": "Бирюзовое опрокинутое остріё",
  "block.minecraft.banner.triangle_top.gray": "Сѣрое опрокинутое остріё",
  "block.minecraft.banner.triangle_top.green": "Зелёное опрокинутое остріё",
  "block.minecraft.banner.triangle_top.light_blue": "Голубое опрокинутое остріё",
  "block.minecraft.banner.triangle_top.light_gray": "Свѣтлосѣрое опрокинутое остріё",
  "block.minecraft.banner.triangle_top.lime": "Яркозелёное опрокинутое остріё",
  "block.minecraft.banner.triangle_top.magenta": "Пурпурное опрокинутое остріё",
  "block.minecraft.banner.triangle_top.orange": "Оранжевое опрокинутое остріё",
  "block.minecraft.banner.triangle_top.pink": "Розовое опрокинутое остріё",
  "block.minecraft.banner.triangle_top.purple": "Фіолетовое опрокинутое остріё",
  "block.minecraft.banner.triangle_top.red": "Червонное опрокинутое остріё",
  "block.minecraft.banner.triangle_top.white": "Бѣлое опрокинутое остріё",
  "block.minecraft.banner.triangle_top.yellow": "Жёлтое опрокинутое остріё",
  "block.minecraft.banner.triangles_bottom.black": "Чёрное зубчатое основаніе",
  "block.minecraft.banner.triangles_bottom.blue": "Лазурное зубчатое основаніе",
  "block.minecraft.banner.triangles_bottom.brown": "Коричневое зубчатое основаніе",
  "block.minecraft.banner.triangles_bottom.cyan": "Бирюзовое зубчатое основаніе",
  "block.minecraft.banner.triangles_bottom.gray": "Сѣрое зубчатое основаніе",
  "block.minecraft.banner.triangles_bottom.green": "Зелёное зубчатое основаніе",
  "block.minecraft.banner.triangles_bottom.light_blue": "Голубое зубчатое основаніе",
  "block.minecraft.banner.triangles_bottom.light_gray": "Свѣтлосѣрое зубчатое основаніе",
  "block.minecraft.banner.triangles_bottom.lime": "Яркозелёное зубчатое основаніе",
  "block.minecraft.banner.triangles_bottom.magenta": "Пурпурное зубчатое основаніе",
  "block.minecraft.banner.triangles_bottom.orange": "Оранжевое зубчатое основаніе",
  "block.minecraft.banner.triangles_bottom.pink": "Розовое зубчатое основаніе",
  "block.minecraft.banner.triangles_bottom.purple": "Фіолетовое зубчатое основаніе",
  "block.minecraft.banner.triangles_bottom.red": "Червонное зубчатое основаніе",
  "block.minecraft.banner.triangles_bottom.white": "Бѣлое зубчатое основаніе",
  "block.minecraft.banner.triangles_bottom.yellow": "Жёлтое зубчатое основаніе",
  "block.minecraft.banner.triangles_top.black": "Чёрная зубчатая глава",
  "block.minecraft.banner.triangles_top.blue": "Лазурная зубчатая глава",
  "block.minecraft.banner.triangles_top.brown": "Коричневая зубчатая глава",
  "block.minecraft.banner.triangles_top.cyan": "Бирюзовая зубчатая глава",
  "block.minecraft.banner.triangles_top.gray": "Сѣрая зубчатая глава",
  "block.minecraft.banner.triangles_top.green": "Зелёная зубчатая глава",
  "block.minecraft.banner.triangles_top.light_blue": "Голубая зубчатая глава",
  "block.minecraft.banner.triangles_top.light_gray": "Свѣтлосѣрая зубчатая глава",
  "block.minecraft.banner.triangles_top.lime": "Яркозелёная зубчатая глава",
  "block.minecraft.banner.triangles_top.magenta": "Пурпурная зубчатая глава",
  "block.minecraft.banner.triangles_top.orange": "Оранжевая зубчатая глава",
  "block.minecraft.banner.triangles_top.pink": "Розовая зубчатая глава",
  "block.minecraft.banner.triangles_top.purple": "Фіолетовая зубчатая глава",
  "block.minecraft.banner.triangles_top.red": "Червонная зубчатая глава",
  "block.minecraft.banner.triangles_top.white": "Бѣлая зубчатая глава",
  "block.minecraft.banner.triangles_top.yellow": "Жёлтая зубчатая глава",
  "block.minecraft.barrel": "Бочка",
  "block.minecraft.barrier": "Барьеръ",
  "block.minecraft.basalt": "Базальтъ",
  "block.minecraft.beacon": "Маякъ",
  "block.minecraft.beacon.primary": "Основной эффектъ",
  "block.minecraft.beacon.secondary": "Вторичный эффектъ",
  "block.minecraft.bed.no_sleep": "Вы можете почивать только ночью или въ грозу",
  "block.minecraft.bed.not_safe": "Вы не можете уснуть, покуда рядомъ бродятъ твари",
  "block.minecraft.bed.obstructed": "Сія постель загромождена",
  "block.minecraft.bed.occupied": "Сія постель занята",
  "block.minecraft.bed.too_far_away": "Что-съ, и до постели не дойдёте?",
  "block.minecraft.bedrock": "Коренная порода",
  "block.minecraft.bee_nest": "Пчелиное гнѣздо",
  "block.minecraft.beehive": "Пасѣка",
  "block.minecraft.beetroots": "Свёкла",
  "block.minecraft.bell": "Колоколъ",
  "block.minecraft.big_dripleaf": "Большая бросянка",
  "block.minecraft.big_dripleaf_stem": "Стебель большой бросянки",
  "block.minecraft.birch_button": "Берёзовая кнопка",
  "block.minecraft.birch_door": "Берёзовая дверь",
  "block.minecraft.birch_fence": "Берёзовый заборъ",
  "block.minecraft.birch_fence_gate": "Берёзовая калитка",
  "block.minecraft.birch_hanging_sign": "Берёзовая подвѣсная табличка",
  "block.minecraft.birch_leaves": "Берёзовые листья",
  "block.minecraft.birch_log": "Берёзовое бревно",
  "block.minecraft.birch_planks": "Берёзовыя доски",
  "block.minecraft.birch_pressure_plate": "Берёзовая нажимная плита",
  "block.minecraft.birch_sapling": "Саженецъ берёзы",
  "block.minecraft.birch_shelf": "Берёзовая полка",
  "block.minecraft.birch_sign": "Берёзовая табличка",
  "block.minecraft.birch_slab": "Берёзовая плита",
  "block.minecraft.birch_stairs": "Берёзовыя ступеньки",
  "block.minecraft.birch_trapdoor": "Берёзовый люкъ",
  "block.minecraft.birch_wall_hanging_sign": "Берёзовая настѣнная подвѣсная табличка",
  "block.minecraft.birch_wall_sign": "Берёзовая настѣнная табличка",
  "block.minecraft.birch_wood": "Берёза",
  "block.minecraft.black_banner": "Чёрный флагъ",
  "block.minecraft.black_bed": "Чёрная постель",
  "block.minecraft.black_candle": "Чёрная свѣча",
  "block.minecraft.black_candle_cake": "Тортъ съ чёрной свѣчой",
  "block.minecraft.black_carpet": "Чёрный ковёръ",
  "block.minecraft.black_concrete": "Чёрный бетонъ",
  "block.minecraft.black_concrete_powder": "Чёрный сухой бетонъ",
  "block.minecraft.black_glazed_terracotta": "Чёрная глазурованная керамика",
  "block.minecraft.black_shulker_box": "Чёрный шалкеровый ящикъ",
  "block.minecraft.black_stained_glass": "Чёрное стекло",
  "block.minecraft.black_stained_glass_pane": "Чёрная стеклянная панель",
  "block.minecraft.black_terracotta": "Чёрная керамика",
  "block.minecraft.black_wool": "Чёрная шерсть",
  "block.minecraft.blackstone": "Чернокамень",
  "block.minecraft.blackstone_slab": "Чернокаменная плита",
  "block.minecraft.blackstone_stairs": "Чернокаменныя ступеньки",
  "block.minecraft.blackstone_wall": "Чернокаменная ограда",
  "block.minecraft.blast_furnace": "Сыродутный горнъ",
  "block.minecraft.blue_banner": "Лазурный флагъ",
  "block.minecraft.blue_bed": "Лазурная постель",
  "block.minecraft.blue_candle": "Лазурная свѣча",
  "block.minecraft.blue_candle_cake": "Тортъ съ лазурной свѣчой",
  "block.minecraft.blue_carpet": "Лазурный ковёръ",
  "block.minecraft.blue_concrete": "Лазурный бетонъ",
  "block.minecraft.blue_concrete_powder": "Лазурный сухой бетонъ",
  "block.minecraft.blue_glazed_terracotta": "Лазурная глазурованная керамика",
  "block.minecraft.blue_ice": "Синій лёдъ",
  "block.minecraft.blue_orchid": "Синяя орхидея",
  "block.minecraft.blue_shulker_box": "Лазурный шалкеровый ящикъ",
  "block.minecraft.blue_stained_glass": "Лазурное стекло",
  "block.minecraft.blue_stained_glass_pane": "Лазурная стеклянная панель",
  "block.minecraft.blue_terracotta": "Лазурная керамика",
  "block.minecraft.blue_wool": "Лазурная шерсть",
  "block.minecraft.bone_block": "Костный блокъ",
  "block.minecraft.bookshelf": "Книжная полка",
  "block.minecraft.brain_coral": "Кораллъ-мозговикъ",
  "block.minecraft.brain_coral_block": "Блокъ коралла-мозговика",
  "block.minecraft.brain_coral_fan": "Вѣерный кораллъ-мозговикъ",
  "block.minecraft.brain_coral_wall_fan": "Горизонтальный вѣерный кораллъ-мозговикъ",
  "block.minecraft.brewing_stand": "Зельеварка",
  "block.minecraft.brick_slab": "Кирпичная плита",
  "block.minecraft.brick_stairs": "Кирпичныя ступеньки",
  "block.minecraft.brick_wall": "Кирпичная ограда",
  "block.minecraft.bricks": "Кирпичи",
  "block.minecraft.brown_banner": "Коричневый флагъ",
  "block.minecraft.brown_bed": "Коричневая постель",
  "block.minecraft.brown_candle": "Коричневая свѣча",
  "block.minecraft.brown_candle_cake": "Тортъ съ коричневой свѣчой",
  "block.minecraft.brown_carpet": "Коричневый ковёръ",
  "block.minecraft.brown_concrete": "Коричневый бетонъ",
  "block.minecraft.brown_concrete_powder": "Коричневый сухой бетонъ",
  "block.minecraft.brown_glazed_terracotta": "Коричневая глазурованная керамика",
  "block.minecraft.brown_mushroom": "Моховикъ",
  "block.minecraft.brown_mushroom_block": "Блокъ моховика",
  "block.minecraft.brown_shulker_box": "Коричневый шалкеровый ящикъ",
  "block.minecraft.brown_stained_glass": "Коричневое стекло",
  "block.minecraft.brown_stained_glass_pane": "Коричневая стеклянная панель",
  "block.minecraft.brown_terracotta": "Коричневая керамика",
  "block.minecraft.brown_wool": "Коричневая шерсть",
  "block.minecraft.bubble_column": "Колонна пузырей",
  "block.minecraft.bubble_coral": "Пузырчатый кораллъ",
  "block.minecraft.bubble_coral_block": "Блокъ пузырчатаго коралла",
  "block.minecraft.bubble_coral_fan": "Вѣерный пузырчатый кораллъ",
  "block.minecraft.bubble_coral_wall_fan": "Горизонтальный вѣерный пузырчатый кораллъ",
  "block.minecraft.budding_amethyst": "Цвѣтущій аметистъ",
  "block.minecraft.bush": "Кустъ",
  "block.minecraft.cactus": "Кактусъ",
  "block.minecraft.cactus_flower": "Цвѣтокъ кактуса",
  "block.minecraft.cake": "Тортъ",
  "block.minecraft.calcite": "Кальцитъ",
  "block.minecraft.calibrated_sculk_sensor": "Откалиброванный скалкъ-датчикъ",
  "block.minecraft.campfire": "Костёръ",
  "block.minecraft.candle": "Свѣча",
  "block.minecraft.candle_cake": "Тортъ со свѣчой",
  "block.minecraft.carrots": "Морковь",
  "block.minecraft.cartography_table": "Столъ картографа",
  "block.minecraft.carved_pumpkin": "Вырѣзанная тыква",
  "block.minecraft.cauldron": "Котёлъ",
  "block.minecraft.cave_air": "Пещерный воздухъ",
  "block.minecraft.cave_vines": "Пещерная лоза",
  "block.minecraft.cave_vines_plant": "Стебель пещерной лозы",
  "block.minecraft.chain": "Цѣпь",
  "block.minecraft.chain_command_block": "Послѣдовательный ариѳмометръ",
  "block.minecraft.cherry_button": "Вишнёвая кнопка",
  "block.minecraft.cherry_door": "Вишнёвая дверь",
  "block.minecraft.cherry_fence": "Вишнёвый заборъ",
  "block.minecraft.cherry_fence_gate": "Вишнёвая калитка",
  "block.minecraft.cherry_hanging_sign": "Вишнёвая подвѣсная табличка",
  "block.minecraft.cherry_leaves": "Вишнёвые листья",
  "block.minecraft.cherry_log": "Вишнёвое бревно",
  "block.minecraft.cherry_planks": "Вишнёвыя доски",
  "block.minecraft.cherry_pressure_plate": "Вишнёвая нажимная плита",
  "block.minecraft.cherry_sapling": "Саженецъ вишни",
  "block.minecraft.cherry_shelf": "Вишнёвая полка",
  "block.minecraft.cherry_sign": "Вишнёвая табличка",
  "block.minecraft.cherry_slab": "Вишнёвая плита",
  "block.minecraft.cherry_stairs": "Вишнёвыя ступеньки",
  "block.minecraft.cherry_trapdoor": "Вишнёвый люкъ",
  "block.minecraft.cherry_wall_hanging_sign": "Вишнёвая настѣнная подвѣсная табличка",
  "block.minecraft.cherry_wall_sign": "Вишнёвая настѣнная табличка",
  "block.minecraft.cherry_wood": "Вишня",
  "block.minecraft.chest": "Сундукъ",
  "block.minecraft.chipped_anvil": "Повреждённая наковальня",
  "block.minecraft.chiseled_bookshelf": "Рѣзная книжная полка",
  "block.minecraft.chiseled_copper": "Точёный мѣдный блокъ",
  "block.minecraft.chiseled_deepslate": "Рѣзной глубинный сланецъ",
  "block.minecraft.chiseled_nether_bricks": "Рѣзные нѣдрскіе кирпичи",
  "block.minecraft.chiseled_polished_blackstone": "Рѣзной полированный чернокамень",
  "block.minecraft.chiseled_quartz_block": "Рѣзной кварцевый блокъ",
  "block.minecraft.chiseled_red_sandstone": "Рѣзной червонный песчаникъ",
  "block.minecraft.chiseled_resin_bricks": "Рѣзные смоляные кирпичи",
  "block.minecraft.chiseled_sandstone": "Рѣзной песчаникъ",
  "block.minecraft.chiseled_stone_bricks": "Рѣзные каменные кирпичи",
  "block.minecraft.chiseled_tuff": "Рѣзной туфъ",
  "block.minecraft.chiseled_tuff_bricks": "Рѣзные туфовые кирпичи",
  "block.minecraft.chorus_flower": "Цвѣтокъ хоруса",
  "block.minecraft.chorus_plant": "Хорусъ",
  "block.minecraft.clay": "Глина",
  "block.minecraft.closed_eyeblossom": "Закрытый очецвѣтъ",
  "block.minecraft.coal_block": "Угольный блокъ",
  "block.minecraft.coal_ore": "Угольная руда",
  "block.minecraft.coarse_dirt": "Каменистая земля",
  "block.minecraft.cobbled_deepslate": "Колотый глубинный сланецъ",
  "block.minecraft.cobbled_deepslate_slab": "Плита изъ колотаго глубиннаго сланца",
  "block.minecraft.cobbled_deepslate_stairs": "Ступеньки изъ колотаго глубиннаго сланца",
  "block.minecraft.cobbled_deepslate_wall": "Ограда изъ колотаго глубиннаго сланца",
  "block.minecraft.cobblestone": "Булыжникъ",
  "block.minecraft.cobblestone_slab": "Булыжная плита",
  "block.minecraft.cobblestone_stairs": "Булыжныя ступеньки",
  "block.minecraft.cobblestone_wall": "Булыжная ограда",
  "block.minecraft.cobweb": "Паутина",
  "block.minecraft.cocoa": "Какао",
  "block.minecraft.command_block": "Ариѳмометръ",
  "block.minecraft.comparator": "Редстоуновый сравниватель",
  "block.minecraft.composter": "Компостница",
  "block.minecraft.conduit": "Морской источникъ",
  "block.minecraft.copper_bars": "Мѣдные прутья",
  "block.minecraft.copper_block": "Мѣдный блокъ",
  "block.minecraft.copper_bulb": "Мѣдная лампа",
  "block.minecraft.copper_chain": "Мѣдная цѣпь",
  "block.minecraft.copper_chest": "Мѣдный сундукъ",
  "block.minecraft.copper_door": "Мѣдная дверь",
  "block.minecraft.copper_golem_statue": "Статуя мѣднаго домовёнка",
  "block.minecraft.copper_grate": "Мѣдная рѣшётка",
  "block.minecraft.copper_lantern": "Мѣдный фонарь",
  "block.minecraft.copper_ore": "Мѣдная руда",
  "block.minecraft.copper_torch": "Мѣдный факелъ",
  "block.minecraft.copper_trapdoor": "Мѣдный люкъ",
  "block.minecraft.copper_wall_torch": "Настѣнный мѣдный факелъ",
  "block.minecraft.cornflower": "Синій василёкъ",
  "block.minecraft.cracked_deepslate_bricks": "Потрескавшіеся глубинносланцевые кирпичи",
  "block.minecraft.cracked_deepslate_tiles": "Потрескавшійся глубинносланцевый плитнякъ",
  "block.minecraft.cracked_nether_bricks": "Потрескавшіеся нѣдрскіе кирпичи",
  "block.minecraft.cracked_polished_blackstone_bricks": "Потрескавшіеся полированно-чернокаменные кирпичи",
  "block.minecraft.cracked_stone_bricks": "Потрескавшіеся каменные кирпичи",
  "block.minecraft.crafter": "Сборщикъ",
  "block.minecraft.crafting_table": "Верстакъ",
  "block.minecraft.creaking_heart": "Скрипцевина",
  "block.minecraft.creeper_head": "Голова крипера",
  "block.minecraft.creeper_wall_head": "Настѣнная голова крипера",
  "block.minecraft.crimson_button": "Багровая кнопка",
  "block.minecraft.crimson_door": "Багровая дверь",
  "block.minecraft.crimson_fence": "Багровый заборъ",
  "block.minecraft.crimson_fence_gate": "Багровая калитка",
  "block.minecraft.crimson_fungus": "Багровый грибъ",
  "block.minecraft.crimson_hanging_sign": "Багровая подвѣсная табличка",
  "block.minecraft.crimson_hyphae": "Багровые гифы",
  "block.minecraft.crimson_nylium": "Багровый нилій",
  "block.minecraft.crimson_planks": "Багровыя доски",
  "block.minecraft.crimson_pressure_plate": "Багровая нажимная плита",
  "block.minecraft.crimson_roots": "Багровые корни",
  "block.minecraft.crimson_shelf": "Багровая полка",
  "block.minecraft.crimson_sign": "Багровая табличка",
  "block.minecraft.crimson_slab": "Багровая плита",
  "block.minecraft.crimson_stairs": "Багровыя ступеньки",
  "block.minecraft.crimson_stem": "Багровый стебель",
  "block.minecraft.crimson_trapdoor": "Багровый люкъ",
  "block.minecraft.crimson_wall_hanging_sign": "Багровая настѣнная подвѣсная табличка",
  "block.minecraft.crimson_wall_sign": "Багровая настѣнная табличка",
  "block.minecraft.crying_obsidian": "Плачущій обсидіанъ",
  "block.minecraft.cut_copper": "Рѣзной мѣдный блокъ",
  "block.minecraft.cut_copper_slab": "Рѣзная мѣдная плита",
  "block.minecraft.cut_copper_stairs": "Рѣзныя мѣдныя ступеньки",
  "block.minecraft.cut_red_sandstone": "Пиленый червонный песчаникъ",
  "block.minecraft.cut_red_sandstone_slab": "Плита изъ пиленаго червоннаго песчаника",
  "block.minecraft.cut_sandstone": "Пиленый песчаникъ",
  "block.minecraft.cut_sandstone_slab": "Плита изъ пиленаго песчаника",
  "block.minecraft.cyan_banner": "Бирюзовый флагъ",
  "block.minecraft.cyan_bed": "Бирюзовая постель",
  "block.minecraft.cyan_candle": "Бирюзовая свѣча",
  "block.minecraft.cyan_candle_cake": "Тортъ съ бирюзовой свѣчой",
  "block.minecraft.cyan_carpet": "Бирюзовый ковёръ",
  "block.minecraft.cyan_concrete": "Бирюзовый бетонъ",
  "block.minecraft.cyan_concrete_powder": "Бирюзовый сухой бетонъ",
  "block.minecraft.cyan_glazed_terracotta": "Бирюзовая глазурованная керамика",
  "block.minecraft.cyan_shulker_box": "Бирюзовый шалкеровый ящикъ",
  "block.minecraft.cyan_stained_glass": "Бирюзовое стекло",
  "block.minecraft.cyan_stained_glass_pane": "Бирюзовая стеклянная панель",
  "block.minecraft.cyan_terracotta": "Бирюзовая керамика",
  "block.minecraft.cyan_wool": "Бирюзовая шерсть",
  "block.minecraft.damaged_anvil": "Разбитая наковальня",
  "block.minecraft.dandelion": "Одуванчикъ",
  "block.minecraft.dark_oak_button": "Кнопка изъ тёмнаго дуба",
  "block.minecraft.dark_oak_door": "Дверь изъ тёмнаго дуба",
  "block.minecraft.dark_oak_fence": "Заборъ изъ тёмнаго дуба",
  "block.minecraft.dark_oak_fence_gate": "Калитка изъ тёмнаго дуба",
  "block.minecraft.dark_oak_hanging_sign": "Подвѣсная табличка изъ тёмнаго дуба",
  "block.minecraft.dark_oak_leaves": "Листья тёмнаго дуба",
  "block.minecraft.dark_oak_log": "Бревно тёмнаго дуба",
  "block.minecraft.dark_oak_planks": "Доски изъ тёмнаго дуба",
  "block.minecraft.dark_oak_pressure_plate": "Нажимная плита изъ тёмнаго дуба",
  "block.minecraft.dark_oak_sapling": "Саженецъ тёмнаго дуба",
  "block.minecraft.dark_oak_shelf": "Полка изъ тёмнаго дуба",
  "block.minecraft.dark_oak_sign": "Табличка изъ тёмнаго дуба",
  "block.minecraft.dark_oak_slab": "Плита изъ тёмнаго дуба",
  "block.minecraft.dark_oak_stairs": "Ступеньки изъ тёмнаго дуба",
  "block.minecraft.dark_oak_trapdoor": "Люкъ изъ тёмнаго дуба",
  "block.minecraft.dark_oak_wall_hanging_sign": "Настѣнная подвѣсная табличка изъ тёмнаго дуба",
  "block.minecraft.dark_oak_wall_sign": "Настѣнная табличка изъ тёмнаго дуба",
  "block.minecraft.dark_oak_wood": "Тёмный дубъ",
  "block.minecraft.dark_prismarine": "Тёмный призмаринъ",
  "block.minecraft.dark_prismarine_slab": "Плита изъ тёмнаго призмарина",
  "block.minecraft.dark_prismarine_stairs": "Ступеньки изъ тёмнаго призмарина",
  "block.minecraft.daylight_detector": "Датчикъ дневного свѣта",
  "block.minecraft.dead_brain_coral": "Мёртвый кораллъ-мозговикъ",
  "block.minecraft.dead_brain_coral_block": "Блокъ мёртваго коралла-мозговика",
  "block.minecraft.dead_brain_coral_fan": "Мёртвый вѣерный кораллъ-мозговикъ",
  "block.minecraft.dead_brain_coral_wall_fan": "Мёртвый горизонтальный вѣерный кораллъ-мозговикъ",
  "block.minecraft.dead_bubble_coral": "Мёртвый пузырчатый кораллъ",
  "block.minecraft.dead_bubble_coral_block": "Блокъ мёртваго пузырчатаго коралла",
  "block.minecraft.dead_bubble_coral_fan": "Мёртвый вѣерный пузырчатый кораллъ",
  "block.minecraft.dead_bubble_coral_wall_fan": "Мёртвый горизонтальный вѣерный пузырчатый кораллъ",
  "block.minecraft.dead_bush": "Мёртвый кустъ",
  "block.minecraft.dead_fire_coral": "Мёртвый огненный кораллъ",
  "block.minecraft.dead_fire_coral_block": "Блокъ мёртваго огненнаго коралла",
  "block.minecraft.dead_fire_coral_fan": "Мёртвый вѣерный огненный кораллъ",
  "block.minecraft.dead_fire_coral_wall_fan": "Мёртвый горизонтальный вѣерный огненный кораллъ",
  "block.minecraft.dead_horn_coral": "Мёртвый роговый кораллъ",
  "block.minecraft.dead_horn_coral_block": "Блокъ мёртваго рогового коралла",
  "block.minecraft.dead_horn_coral_fan": "Мёртвый вѣерный роговый кораллъ",
  "block.minecraft.dead_horn_coral_wall_fan": "Мёртвый горизонтальный вѣерный роговый кораллъ",
  "block.minecraft.dead_tube_coral": "Мёртвый трубчатый кораллъ",
  "block.minecraft.dead_tube_coral_block": "Блокъ мёртваго трубчатаго коралла",
  "block.minecraft.dead_tube_coral_fan": "Мёртвый вѣерный трубчатый кораллъ",
  "block.minecraft.dead_tube_coral_wall_fan": "Мёртвый горизонтальный вѣерный трубчатый кораллъ",
  "block.minecraft.decorated_pot": "Узорчатая ваза",
  "block.minecraft.deepslate": "Глубинный сланецъ",
  "block.minecraft.deepslate_brick_slab": "Плита изъ глубинносланцеваго кирпича",
  "block.minecraft.deepslate_brick_stairs": "Ступеньки изъ глубинносланцеваго кирпича",
  "block.minecraft.deepslate_brick_wall": "Ограда изъ глубинносланцеваго кирпича",
  "block.minecraft.deepslate_bricks": "Глубинносланцевые кирпичи",
  "block.minecraft.deepslate_coal_ore": "Угленосный глубинный сланецъ",
  "block.minecraft.deepslate_copper_ore": "Мѣденосный глубинный сланецъ",
  "block.minecraft.deepslate_diamond_ore": "Діамантоносный глубинный сланецъ",
  "block.minecraft.deepslate_emerald_ore": "Смарагдоносный глубинный сланецъ",
  "block.minecraft.deepslate_gold_ore": "Золотоносный глубинный сланецъ",
  "block.minecraft.deepslate_iron_ore": "Желѣзоносный глубинный сланецъ",
  "block.minecraft.deepslate_lapis_ore": "Лазуриконосный глубинный сланецъ",
  "block.minecraft.deepslate_redstone_ore": "Редстоуноносный глубинный сланецъ",
  "block.minecraft.deepslate_tile_slab": "Плита изъ глубинносланцеваго плитняка",
  "block.minecraft.deepslate_tile_stairs": "Ступеньки изъ глубинносланцеваго плитняка",
  "block.minecraft.deepslate_tile_wall": "Ограда изъ глубинносланцеваго плитняка",
  "block.minecraft.deepslate_tiles": "Глубинносланцевый плитнякъ",
  "block.minecraft.detector_rail": "Сигнальные рельсы",
  "block.minecraft.diamond_block": "Діамантовый блокъ",
  "block.minecraft.diamond_ore": "Діамантовая руда",
  "block.minecraft.diorite": "Діоритъ",
  "block.minecraft.diorite_slab": "Діоритовая плита",
  "block.minecraft.diorite_stairs": "Діоритовыя ступеньки",
  "block.minecraft.diorite_wall": "Діоритовая ограда",
  "block.minecraft.dirt": "Земля",
  "block.minecraft.dirt_path": "Тропинка",
  "block.minecraft.dispenser": "Раздатчикъ",
  "block.minecraft.dragon_egg": "Яйцо змѣя",
  "block.minecraft.dragon_head": "Голова змѣя",
  "block.minecraft.dragon_wall_head": "Настѣнная голова змѣя",
  "block.minecraft.dried_ghast": "Изсохшiй гастъ",
  "block.minecraft.dried_kelp_block": "Блокъ сушёной ламинаріи",
  "block.minecraft.dripstone_block": "Натёчный камень",
  "block.minecraft.dropper": "Выбрасыватель",
  "block.minecraft.emerald_block": "Смарагдовый блокъ",
  "block.minecraft.emerald_ore": "Смарагдовая руда",
  "block.minecraft.enchanting_table": "Чародѣйскій алтарь",
  "block.minecraft.end_gateway": "Врата Энда",
  "block.minecraft.end_portal": "Порталъ Энда",
  "block.minecraft.end_portal_frame": "Рамка портала Энда",
  "block.minecraft.end_rod": "Стержень Энда",
  "block.minecraft.end_stone": "Эндернякъ",
  "block.minecraft.end_stone_brick_slab": "Плита изъ эндерняковаго кирпича",
  "block.minecraft.end_stone_brick_stairs": "Ступеньки изъ эндерняковаго кирпича",
  "block.minecraft.end_stone_brick_wall": "Ограда изъ эндерняковаго кирпича",
  "block.minecraft.end_stone_bricks": "Эндерняковые кирпичи",
  "block.minecraft.ender_chest": "Эндеръ-ларецъ",
  "block.minecraft.exposed_chiseled_copper": "Патиновый точёный мѣдный блокъ",
  "block.minecraft.exposed_copper": "Патиновый мѣдный блокъ",
  "block.minecraft.exposed_copper_bars": "Патиновые мѣдные прутья",
  "block.minecraft.exposed_copper_bulb": "Патиновая мѣдная лампа",
  "block.minecraft.exposed_copper_chain": "Патиновая мѣдная цѣпь",
  "block.minecraft.exposed_copper_chest": "Патиновый мѣдный сундукъ",
  "block.minecraft.exposed_copper_door": "Патиновая мѣдная дверь",
  "block.minecraft.exposed_copper_golem_statue": "Патиновая статуя мѣднаго домовёнка",
  "block.minecraft.exposed_copper_grate": "Патиновая мѣдная рѣшётка",
  "block.minecraft.exposed_copper_lantern": "Патиновый мѣдный фонарь",
  "block.minecraft.exposed_copper_trapdoor": "Патиновый мѣдный люкъ",
  "block.minecraft.exposed_cut_copper": "Патиновый рѣзной мѣдный блокъ",
  "block.minecraft.exposed_cut_copper_slab": "Патиновая рѣзная мѣдная плита",
  "block.minecraft.exposed_cut_copper_stairs": "Патиновыя рѣзныя мѣдныя ступеньки",
  "block.minecraft.exposed_lightning_rod": "Патиновый громоотводъ",
  "block.minecraft.farmland": "Пашня",
  "block.minecraft.fern": "Папоротникъ",
  "block.minecraft.fire": "Огонь",
  "block.minecraft.fire_coral": "Огненный кораллъ",
  "block.minecraft.fire_coral_block": "Блокъ огненнаго коралла",
  "block.minecraft.fire_coral_fan": "Вѣерный огненный кораллъ",
  "block.minecraft.fire_coral_wall_fan": "Горизонтальный вѣерный огненный кораллъ",
  "block.minecraft.firefly_bush": "Кустъ со свѣтлячками",
  "block.minecraft.fletching_table": "Столъ лучника",
  "block.minecraft.flower_pot": "Цвѣточный горшокъ",
  "block.minecraft.flowering_azalea": "Цвѣтущая азалія",
  "block.minecraft.flowering_azalea_leaves": "Листья цвѣтущей азаліи",
  "block.minecraft.frogspawn": "Лягушачья икра",
  "block.minecraft.frosted_ice": "Талый лёдъ",
  "block.minecraft.furnace": "Печь",
  "block.minecraft.gilded_blackstone": "Золочёный чернокамень",
  "block.minecraft.glass": "Стекло",
  "block.minecraft.glass_pane": "Стеклянная панель",
  "block.minecraft.glow_lichen": "Свѣтящійся лишайникъ",
  "block.minecraft.glowstone": "Свѣтокамень",
  "block.minecraft.gold_block": "Золотой блокъ",
  "block.minecraft.gold_ore": "Золотая руда",
  "block.minecraft.golden_dandelion": "Золотой одуванчикъ",
  "block.minecraft.granite": "Гранитъ",
  "block.minecraft.granite_slab": "Гранитная плита",
  "block.minecraft.granite_stairs": "Гранитныя ступеньки",
  "block.minecraft.granite_wall": "Гранитная ограда",
  "block.minecraft.grass": "Трава",
  "block.minecraft.grass_block": "Дернина",
  "block.minecraft.gravel": "Гравій",
  "block.minecraft.gray_banner": "Сѣрый флагъ",
  "block.minecraft.gray_bed": "Сѣрая постель",
  "block.minecraft.gray_candle": "Сѣрая свѣча",
  "block.minecraft.gray_candle_cake": "Тортъ съ сѣрой свѣчой",
  "block.minecraft.gray_carpet": "Сѣрый ковёръ",
  "block.minecraft.gray_concrete": "Сѣрый бетонъ",
  "block.minecraft.gray_concrete_powder": "Сѣрый сухой бетонъ",
  "block.minecraft.gray_glazed_terracotta": "Сѣрая глазурованная керамика",
  "block.minecraft.gray_shulker_box": "Сѣрый шалкеровый ящикъ",
  "block.minecraft.gray_stained_glass": "Сѣрое стекло",
  "block.minecraft.gray_stained_glass_pane": "Сѣрая стеклянная панель",
  "block.minecraft.gray_terracotta": "Сѣрая керамика",
  "block.minecraft.gray_wool": "Сѣрая шерсть",
  "block.minecraft.green_banner": "Зелёный флагъ",
  "block.minecraft.green_bed": "Зелёная постель",
  "block.minecraft.green_candle": "Зелёная свѣча",
  "block.minecraft.green_candle_cake": "Тортъ съ зелёной свѣчой",
  "block.minecraft.green_carpet": "Зелёный ковёръ",
  "block.minecraft.green_concrete": "Зелёный бетонъ",
  "block.minecraft.green_concrete_powder": "Зелёный сухой бетонъ",
  "block.minecraft.green_glazed_terracotta": "Зелёная глазурованная керамика",
  "block.minecraft.green_shulker_box": "Зелёный шалкеровый ящикъ",
  "block.minecraft.green_stained_glass": "Зелёное стекло",
  "block.minecraft.green_stained_glass_pane": "Зелёная стеклянная панель",
  "block.minecraft.green_terracotta": "Зелёная керамика",
  "block.minecraft.green_wool": "Зелёная шерсть",
  "block.minecraft.grindstone": "Точило",
  "block.minecraft.hanging_roots": "Свисающіе корни",
  "block.minecraft.hay_block": "Снопъ сѣна",
  "block.minecraft.heavy_core": "Навершіе булавы",
  "block.minecraft.heavy_weighted_pressure_plate": "Большегрузная вѣсовая пластина",
  "block.minecraft.honey_block": "Блокъ мёда",
  "block.minecraft.honeycomb_block": "Блокъ пчелиныхъ сотъ",
  "block.minecraft.hopper": "Пріёмная воронка",
  "block.minecraft.horn_coral": "Роговой кораллъ",
  "block.minecraft.horn_coral_block": "Блокъ рогового коралла",
  "block.minecraft.horn_coral_fan": "Вѣерный роговый кораллъ",
  "block.minecraft.horn_coral_wall_fan": "Горизонтальный вѣерный роговый кораллъ",
  "block.minecraft.ice": "Лёдъ",
  "block.minecraft.infested_chiseled_stone_bricks": "Заражённые рѣзные каменные кирпичи",
  "block.minecraft.infested_cobblestone": "Заражённый булыжникъ",
  "block.minecraft.infested_cracked_stone_bricks": "Заражённые потрескавшіеся каменные кирпичи",
  "block.minecraft.infested_deepslate": "Заражённый глубинный сланецъ",
  "block.minecraft.infested_mossy_stone_bricks": "Заражённые мшистые каменные кирпичи",
  "block.minecraft.infested_stone": "Заражённый камень",
  "block.minecraft.infested_stone_bricks": "Заражённые каменные кирпичи",
  "block.minecraft.iron_bars": "Желѣзные прутья",
  "block.minecraft.iron_block": "Желѣзный блокъ",
  "block.minecraft.iron_chain": "Желѣзная цѣпь",
  "block.minecraft.iron_door": "Желѣзная дверь",
  "block.minecraft.iron_ore": "Желѣзная руда",
  "block.minecraft.iron_trapdoor": "Желѣзный люкъ",
  "block.minecraft.jack_o_lantern": "Свѣтильникъ Джека",
  "block.minecraft.jigsaw": "Пазлъ",
  "block.minecraft.jukebox": "Патефонъ",
  "block.minecraft.jungle_button": "Кнопка изъ тропическаго дерева",
  "block.minecraft.jungle_door": "Дверь изъ тропическаго дерева",
  "block.minecraft.jungle_fence": "Заборъ изъ тропическаго дерева",
  "block.minecraft.jungle_fence_gate": "Калитка изъ тропическаго дерева",
  "block.minecraft.jungle_hanging_sign": "Подвѣсная табличка изъ тропическаго дерева",
  "block.minecraft.jungle_leaves": "Листья тропическаго дерева",
  "block.minecraft.jungle_log": "Бревно тропическаго дерева",
  "block.minecraft.jungle_planks": "Доски изъ тропическаго дерева",
  "block.minecraft.jungle_pressure_plate": "Нажимная плита изъ тропическаго дерева",
  "block.minecraft.jungle_sapling": "Саженецъ тропическаго дерева",
  "block.minecraft.jungle_shelf": "Полка изъ тропическаго дерева",
  "block.minecraft.jungle_sign": "Табличка изъ тропическаго дерева",
  "block.minecraft.jungle_slab": "Плита изъ тропическаго дерева",
  "block.minecraft.jungle_stairs": "Ступеньки изъ тропическаго дерева",
  "block.minecraft.jungle_trapdoor": "Люкъ изъ тропическаго дерева",
  "block.minecraft.jungle_wall_hanging_sign": "Настѣнная подвѣсная табличка изъ тропическаго дерева",
  "block.minecraft.jungle_wall_sign": "Настѣнная табличка изъ тропическаго дерева",
  "block.minecraft.jungle_wood": "Тропическое дерево",
  "block.minecraft.kelp": "Ламинарія",
  "block.minecraft.kelp_plant": "Стебель ламинаріи",
  "block.minecraft.ladder": "Лѣстница",
  "block.minecraft.lantern": "Фонарь",
  "block.minecraft.lapis_block": "Лазуриковый блокъ",
  "block.minecraft.lapis_ore": "Лазуриковая руда",
  "block.minecraft.large_amethyst_bud": "Большой аметистовый бутонъ",
  "block.minecraft.large_fern": "Раскидистый папоротникъ",
  "block.minecraft.lava": "Лава",
  "block.minecraft.lava_cauldron": "Котёлъ съ лавой",
  "block.minecraft.leaf_litter": "Сухіе листья",
  "block.minecraft.lectern": "Каѳедра",
  "block.minecraft.lever": "Рычагъ",
  "block.minecraft.light": "Свѣтъ",
  "block.minecraft.light_blue_banner": "Голубой флагъ",
  "block.minecraft.light_blue_bed": "Голубая постель",
  "block.minecraft.light_blue_candle": "Голубая свѣча",
  "block.minecraft.light_blue_candle_cake": "Тортъ съ голубой свѣчой",
  "block.minecraft.light_blue_carpet": "Голубой ковёръ",
  "block.minecraft.light_blue_concrete": "Голубой бетонъ",
  "block.minecraft.light_blue_concrete_powder": "Голубой сухой бетонъ",
  "block.minecraft.light_blue_glazed_terracotta": "Голубая глазурованная керамика",
  "block.minecraft.light_blue_shulker_box": "Голубой шалкеровый ящикъ",
  "block.minecraft.light_blue_stained_glass": "Голубое стекло",
  "block.minecraft.light_blue_stained_glass_pane": "Голубая стеклянная панель",
  "block.minecraft.light_blue_terracotta": "Голубая керамика",
  "block.minecraft.light_blue_wool": "Голубая шерсть",
  "block.minecraft.light_gray_banner": "Свѣтлосѣрый флагъ",
  "block.minecraft.light_gray_bed": "Свѣтлосѣрая постель",
  "block.minecraft.light_gray_candle": "Свѣтлосѣрая свѣча",
  "block.minecraft.light_gray_candle_cake": "Тортъ со свѣтлосѣрой свѣчой",
  "block.minecraft.light_gray_carpet": "Свѣтлосѣрый ковёръ",
  "block.minecraft.light_gray_concrete": "Свѣтлосѣрый бетонъ",
  "block.minecraft.light_gray_concrete_powder": "Свѣтлосѣрый сухой бетонъ",
  "block.minecraft.light_gray_glazed_terracotta": "Свѣтлосѣрая глазурованная керамика",
  "block.minecraft.light_gray_shulker_box": "Свѣтлосѣрый шалкеровый ящикъ",
  "block.minecraft.light_gray_stained_glass": "Свѣтлосѣрое стекло",
  "block.minecraft.light_gray_stained_glass_pane": "Свѣтлосѣрая стеклянная панель",
  "block.minecraft.light_gray_terracotta": "Свѣтлосѣрая керамика",
  "block.minecraft.light_gray_wool": "Свѣтлосѣрая шерсть",
  "block.minecraft.light_weighted_pressure_plate": "Вѣсовая пластина",
  "block.minecraft.lightning_rod": "Громоотводъ",
  "block.minecraft.lilac": "Сирень",
  "block.minecraft.lily_of_the_valley": "Ландышъ",
  "block.minecraft.lily_pad": "Кувшинка",
  "block.minecraft.lime_banner": "Яркозелёный флагъ",
  "block.minecraft.lime_bed": "Яркозелёная постель",
  "block.minecraft.lime_candle": "Яркозелёная свѣча",
  "block.minecraft.lime_candle_cake": "Тортъ съ яркозелёной свѣчой",
  "block.minecraft.lime_carpet": "Яркозелёный ковёръ",
  "block.minecraft.lime_concrete": "Яркозелёный бетонъ",
  "block.minecraft.lime_concrete_powder": "Яркозелёный сухой бетонъ",
  "block.minecraft.lime_glazed_terracotta": "Яркозелёная глазурованная керамика",
  "block.minecraft.lime_shulker_box": "Яркозелёный шалкеровый ящикъ",
  "block.minecraft.lime_stained_glass": "Яркозелёное стекло",
  "block.minecraft.lime_stained_glass_pane": "Яркозелёная стеклянная панель",
  "block.minecraft.lime_terracotta": "Яркозелёная керамика",
  "block.minecraft.lime_wool": "Яркозелёная шерсть",
  "block.minecraft.lodestone": "Магнетитъ",
  "block.minecraft.loom": "Ткацкій станокъ",
  "block.minecraft.magenta_banner": "Пурпурный флагъ",
  "block.minecraft.magenta_bed": "Пурпурная постель",
  "block.minecraft.magenta_candle": "Пурпурная свѣча",
  "block.minecraft.magenta_candle_cake": "Тортъ съ пурпурной свѣчой",
  "block.minecraft.magenta_carpet": "Пурпурный ковёръ",
  "block.minecraft.magenta_concrete": "Пурпурный бетонъ",
  "block.minecraft.magenta_concrete_powder": "Пурпурный сухой бетонъ",
  "block.minecraft.magenta_glazed_terracotta": "Пурпурная глазурованная керамика",
  "block.minecraft.magenta_shulker_box": "Пурпурный шалкеровый ящикъ",
  "block.minecraft.magenta_stained_glass": "Пурпурное стекло",
  "block.minecraft.magenta_stained_glass_pane": "Пурпурная стеклянная панель",
  "block.minecraft.magenta_terracotta": "Пурпурная керамика",
  "block.minecraft.magenta_wool": "Пурпурная шерсть",
  "block.minecraft.magma_block": "Магма",
  "block.minecraft.mangrove_button": "Мангровая кнопка",
  "block.minecraft.mangrove_door": "Мангровая дверь",
  "block.minecraft.mangrove_fence": "Мангровый заборъ",
  "block.minecraft.mangrove_fence_gate": "Мангровая калитка",
  "block.minecraft.mangrove_hanging_sign": "Мангровая подвѣсная табличка",
  "block.minecraft.mangrove_leaves": "Мангровые листья",
  "block.minecraft.mangrove_log": "Мангровое бревно",
  "block.minecraft.mangrove_planks": "Мангровыя доски",
  "block.minecraft.mangrove_pressure_plate": "Мангровая нажимная плита",
  "block.minecraft.mangrove_propagule": "Мангровый отростокъ",
  "block.minecraft.mangrove_roots": "Мангровые корни",
  "block.minecraft.mangrove_shelf": "Мангровая полка",
  "block.minecraft.mangrove_sign": "Мангровая табличка",
  "block.minecraft.mangrove_slab": "Мангровая плита",
  "block.minecraft.mangrove_stairs": "Мангровыя ступеньки",
  "block.minecraft.mangrove_trapdoor": "Мангровый люкъ",
  "block.minecraft.mangrove_wall_hanging_sign": "Мангровая настѣнная подвѣсная табличка",
  "block.minecraft.mangrove_wall_sign": "Мангровая настѣнная табличка",
  "block.minecraft.mangrove_wood": "Мангровое дерево",
  "block.minecraft.medium_amethyst_bud": "Средній аметистовый бутонъ",
  "block.minecraft.melon": "Арбузъ",
  "block.minecraft.melon_stem": "Стебель арбуза",
  "block.minecraft.moss_block": "Блокъ мха",
  "block.minecraft.moss_carpet": "Моховой ковёръ",
  "block.minecraft.mossy_cobblestone": "Мшистый булыжникъ",
  "block.minecraft.mossy_cobblestone_slab": "Мшистая булыжная плита",
  "block.minecraft.mossy_cobblestone_stairs": "Мшистыя булыжныя ступеньки",
  "block.minecraft.mossy_cobblestone_wall": "Мшистая булыжная ограда",
  "block.minecraft.mossy_stone_brick_slab": "Плита изъ мшистаго каменнаго кирпича",
  "block.minecraft.mossy_stone_brick_stairs": "Ступеньки изъ мшистаго каменнаго кирпича",
  "block.minecraft.mossy_stone_brick_wall": "Ограда изъ мшистаго каменнаго кирпича",
  "block.minecraft.mossy_stone_bricks": "Мшистые каменные кирпичи",
  "block.minecraft.moving_piston": "Движущійся поршень",
  "block.minecraft.mud": "Грязь",
  "block.minecraft.mud_brick_slab": "Саманная плита",
  "block.minecraft.mud_brick_stairs": "Саманныя ступеньки",
  "block.minecraft.mud_brick_wall": "Саманная ограда",
  "block.minecraft.mud_bricks": "Саманные кирпичи",
  "block.minecraft.muddy_mangrove_roots": "Грязные мангровые корни",
  "block.minecraft.mushroom_stem": "Ножка гриба",
  "block.minecraft.mycelium": "Мицелій",
  "block.minecraft.nether_brick_fence": "Заборъ изъ нѣдрскаго кирпича",
  "block.minecraft.nether_brick_slab": "Плита изъ нѣдрскаго кирпича",
  "block.minecraft.nether_brick_stairs": "Ступеньки изъ нѣдрскаго кирпича",
  "block.minecraft.nether_brick_wall": "Ограда изъ нѣдрскаго кирпича",
  "block.minecraft.nether_bricks": "Нѣдрскіе кирпичи",
  "block.minecraft.nether_gold_ore": "Нѣдрская золотая руда",
  "block.minecraft.nether_portal": "Порталъ Нѣдра",
  "block.minecraft.nether_quartz_ore": "Руда нѣдрскаго кварца",
  "block.minecraft.nether_sprouts": "Нѣдрскіе ростки",
  "block.minecraft.nether_wart": "Нѣдрскій наростъ",
  "block.minecraft.nether_wart_block": "Блокъ нѣдрскаго нароста",
  "block.minecraft.netherite_block": "Нѣдритовый блокъ",
  "block.minecraft.netherrack": "Нѣдракъ",
  "block.minecraft.note_block": "Музыкальный блокъ",
  "block.minecraft.oak_button": "Дубовая кнопка",
  "block.minecraft.oak_door": "Дубовая дверь",
  "block.minecraft.oak_fence": "Дубовый заборъ",
  "block.minecraft.oak_fence_gate": "Дубовая калитка",
  "block.minecraft.oak_hanging_sign": "Дубовая подвѣсная табличка",
  "block.minecraft.oak_leaves": "Дубовые листья",
  "block.minecraft.oak_log": "Дубовое бревно",
  "block.minecraft.oak_planks": "Дубовыя доски",
  "block.minecraft.oak_pressure_plate": "Дубовая нажимная плита",
  "block.minecraft.oak_sapling": "Саженецъ дуба",
  "block.minecraft.oak_shelf": "Дубовая полка",
  "block.minecraft.oak_sign": "Дубовая табличка",
  "block.minecraft.oak_slab": "Дубовая плита",
  "block.minecraft.oak_stairs": "Дубовыя ступеньки",
  "block.minecraft.oak_trapdoor": "Дубовый люкъ",
  "block.minecraft.oak_wall_hanging_sign": "Дубовая настѣнная подвѣсная табличка",
  "block.minecraft.oak_wall_sign": "Дубовая настѣнная табличка",
  "block.minecraft.oak_wood": "Дубъ",
  "block.minecraft.observer": "Смотритель",
  "block.minecraft.obsidian": "Обсидіанъ",
  "block.minecraft.ochre_froglight": "Охристая квампа",
  "block.minecraft.ominous_banner": "Зловѣщій флагъ",
  "block.minecraft.open_eyeblossom": "Раскрытый очецвѣтъ",
  "block.minecraft.orange_banner": "Оранжевый флагъ",
  "block.minecraft.orange_bed": "Оранжевая постель",
  "block.minecraft.orange_candle": "Оранжевая свѣча",
  "block.minecraft.orange_candle_cake": "Тортъ съ оранжевой свѣчой",
  "block.minecraft.orange_carpet": "Оранжевый ковёръ",
  "block.minecraft.orange_concrete": "Оранжевый бетонъ",
  "block.minecraft.orange_concrete_powder": "Оранжевый сухой бетонъ",
  "block.minecraft.orange_glazed_terracotta": "Оранжевая глазурованная керамика",
  "block.minecraft.orange_shulker_box": "Оранжевый шалкеровый ящикъ",
  "block.minecraft.orange_stained_glass": "Оранжевое стекло",
  "block.minecraft.orange_stained_glass_pane": "Оранжевая стеклянная панель",
  "block.minecraft.orange_terracotta": "Оранжевая керамика",
  "block.minecraft.orange_tulip": "Оранжевый тюльпанъ",
  "block.minecraft.orange_wool": "Оранжевая шерсть",
  "block.minecraft.oxeye_daisy": "Ромашка",
  "block.minecraft.oxidized_chiseled_copper": "Окисленный точёный мѣдный блокъ",
  "block.minecraft.oxidized_copper": "Окисленный мѣдный блокъ",
  "block.minecraft.oxidized_copper_bars": "Окисленные мѣдные прутья",
  "block.minecraft.oxidized_copper_bulb": "Окисленная мѣдная лампа",
  "block.minecraft.oxidized_copper_chain": "Окисленная мѣдная цѣпь",
  "block.minecraft.oxidized_copper_chest": "Окисленный мѣдный сундукъ",
  "block.minecraft.oxidized_copper_door": "Окисленная мѣдная дверь",
  "block.minecraft.oxidized_copper_golem_statue": "Окисленная статуя мѣднаго домовёнка",
  "block.minecraft.oxidized_copper_grate": "Окисленная мѣдная рѣшётка",
  "block.minecraft.oxidized_copper_lantern": "Окисленный мѣдный фонарь",
  "block.minecraft.oxidized_copper_trapdoor": "Окисленный мѣдный люкъ",
  "block.minecraft.oxidized_cut_copper": "Окисленный рѣзной мѣдный блокъ",
  "block.minecraft.oxidized_cut_copper_slab": "Окисленная рѣзная мѣдная плита",
  "block.minecraft.oxidized_cut_copper_stairs": "Окисленныя рѣзныя мѣдныя ступеньки",
  "block.minecraft.oxidized_lightning_rod": "Окисленный громоотводъ",
  "block.minecraft.packed_ice": "Плотный лёдъ",
  "block.minecraft.packed_mud": "Плотная грязь",
  "block.minecraft.pale_hanging_moss": "Свисающій блѣдный мохъ",
  "block.minecraft.pale_moss_block": "Блокъ блѣднаго мха",
  "block.minecraft.pale_moss_carpet": "Блѣдный моховой ковёръ",
  "block.minecraft.pale_oak_button": "Кнопка изъ блѣднаго дуба",
  "block.minecraft.pale_oak_door": "Дверь изъ блѣднаго дуба",
  "block.minecraft.pale_oak_fence": "Заборъ изъ блѣднаго дуба",
  "block.minecraft.pale_oak_fence_gate": "Калитка изъ блѣднаго дуба",
  "block.minecraft.pale_oak_hanging_sign": "Подвѣсная табличка изъ блѣднаго дуба",
  "block.minecraft.pale_oak_leaves": "Листья блѣднаго дуба",
  "block.minecraft.pale_oak_log": "Бревно блѣднаго дуба",
  "block.minecraft.pale_oak_planks": "Доски изъ блѣднаго дуба",
  "block.minecraft.pale_oak_pressure_plate": "Нажимная плита изъ блѣднаго дуба",
  "block.minecraft.pale_oak_sapling": "Саженецъ блѣднаго дуба",
  "block.minecraft.pale_oak_shelf": "Полка изъ блѣднаго дуба",
  "block.minecraft.pale_oak_sign": "Табличка изъ блѣднаго дуба",
  "block.minecraft.pale_oak_slab": "Плита изъ блѣднаго дуба",
  "block.minecraft.pale_oak_stairs": "Ступеньки изъ блѣднаго дуба",
  "block.minecraft.pale_oak_trapdoor": "Люкъ изъ блѣднаго дуба",
  "block.minecraft.pale_oak_wall_hanging_sign": "Настѣнная подвѣсная табличка изъ блѣднаго дуба",
  "block.minecraft.pale_oak_wall_sign": "Настѣнная табличка изъ блѣднаго дуба",
  "block.minecraft.pale_oak_wood": "Блѣдный дубъ",
  "block.minecraft.pearlescent_froglight": "Перламутровая квампа",
  "block.minecraft.peony": "Піонъ",
  "block.minecraft.petrified_oak_slab": "Окаменѣвшая дубовая плита",
  "block.minecraft.piglin_head": "Голова пиглина",
  "block.minecraft.piglin_wall_head": "Настѣнная голова пиглина",
  "block.minecraft.pink_banner": "Розовый флагъ",
  "block.minecraft.pink_bed": "Розовая постель",
  "block.minecraft.pink_candle": "Розовая свѣча",
  "block.minecraft.pink_candle_cake": "Тортъ съ розовой свѣчой",
  "block.minecraft.pink_carpet": "Розовый ковёръ",
  "block.minecraft.pink_concrete": "Розовый бетонъ",
  "block.minecraft.pink_concrete_powder": "Розовый сухой бетонъ",
  "block.minecraft.pink_glazed_terracotta": "Розовая глазурованная керамика",
  "block.minecraft.pink_petals": "Розовые лепестки",
  "block.minecraft.pink_shulker_box": "Розовый шалкеровый ящикъ",
  "block.minecraft.pink_stained_glass": "Розовое стекло",
  "block.minecraft.pink_stained_glass_pane": "Розовая стеклянная панель",
  "block.minecraft.pink_terracotta": "Розовая керамика",
  "block.minecraft.pink_tulip": "Розовый тюльпанъ",
  "block.minecraft.pink_wool": "Розовая шерсть",
  "block.minecraft.piston": "Поршень",
  "block.minecraft.piston_head": "Головка поршня",
  "block.minecraft.pitcher_crop": "Ростокъ кувшинницы",
  "block.minecraft.pitcher_plant": "Кувшинница",
  "block.minecraft.player_head": "Голова игрока",
  "block.minecraft.player_head.named": "Голова %s",
  "block.minecraft.player_wall_head": "Настѣнная голова игрока",
  "block.minecraft.podzol": "Подзолъ",
  "block.minecraft.pointed_dripstone": "Капельникъ",
  "block.minecraft.polished_andesite": "Полированный андезитъ",
  "block.minecraft.polished_andesite_slab": "Плита изъ полированнаго андезита",
  "block.minecraft.polished_andesite_stairs": "Ступеньки изъ полированнаго андезита",
  "block.minecraft.polished_basalt": "Полированный базальтъ",
  "block.minecraft.polished_blackstone": "Полированный чернокамень",
  "block.minecraft.polished_blackstone_brick_slab": "Плита изъ полированно-чернокаменнаго кирпича",
  "block.minecraft.polished_blackstone_brick_stairs": "Ступеньки изъ полированно-чернокаменнаго кирпича",
  "block.minecraft.polished_blackstone_brick_wall": "Ограда изъ полированно-чернокаменнаго кирпича",
  "block.minecraft.polished_blackstone_bricks": "Полированно-чернокаменные кирпичи",
  "block.minecraft.polished_blackstone_button": "Кнопка изъ полированнаго чернокамня",
  "block.minecraft.polished_blackstone_pressure_plate": "Нажимная плита изъ полированнаго чернокамня",
  "block.minecraft.polished_blackstone_slab": "Плита изъ полированнаго чернокамня",
  "block.minecraft.polished_blackstone_stairs": "Ступеньки изъ полированнаго чернокамня",
  "block.minecraft.polished_blackstone_wall": "Ограда изъ полированнаго чернокамня",
  "block.minecraft.polished_deepslate": "Полированный глубинный сланецъ",
  "block.minecraft.polished_deepslate_slab": "Плита изъ полированнаго глубиннаго сланца",
  "block.minecraft.polished_deepslate_stairs": "Ступеньки изъ полированнаго глубиннаго сланца",
  "block.minecraft.polished_deepslate_wall": "Ограда изъ полированнаго глубиннаго сланца",
  "block.minecraft.polished_diorite": "Полированный діоритъ",
  "block.minecraft.polished_diorite_slab": "Плита изъ полированнаго діорита",
  "block.minecraft.polished_diorite_stairs": "Ступеньки изъ полированнаго діорита",
  "block.minecraft.polished_granite": "Полированный гранитъ",
  "block.minecraft.polished_granite_slab": "Плита изъ полированнаго гранита",
  "block.minecraft.polished_granite_stairs": "Ступеньки изъ полированнаго гранита",
  "block.minecraft.polished_tuff": "Полированный туфъ",
  "block.minecraft.polished_tuff_slab": "Плита изъ полированнаго туфа",
  "block.minecraft.polished_tuff_stairs": "Ступеньки изъ полированнаго туфа",
  "block.minecraft.polished_tuff_wall": "Ограда изъ полированнаго туфа",
  "block.minecraft.poppy": "Макъ",
  "block.minecraft.potatoes": "Картофель",
  "block.minecraft.potted_acacia_sapling": "Саженецъ акаціи въ горшкѣ",
  "block.minecraft.potted_allium": "Лукъ-батунъ въ горшкѣ",
  "block.minecraft.potted_azalea_bush": "Азалія въ горшкѣ",
  "block.minecraft.potted_azure_bluet": "Хаустонія сѣрая въ горшкѣ",
  "block.minecraft.potted_bamboo": "Бамбукъ въ горшкѣ",
  "block.minecraft.potted_birch_sapling": "Саженецъ берёзы въ горшкѣ",
  "block.minecraft.potted_blue_orchid": "Синяя орхидея въ горшкѣ",
  "block.minecraft.potted_brown_mushroom": "Моховикъ въ горшкѣ",
  "block.minecraft.potted_cactus": "Кактусъ въ горшкѣ",
  "block.minecraft.potted_cherry_sapling": "Саженецъ вишни въ горшкѣ",
  "block.minecraft.potted_closed_eyeblossom": "Закрытый очецвѣтъ въ горшкѣ",
  "block.minecraft.potted_cornflower": "Синій василёкъ въ горшкѣ",
  "block.minecraft.potted_crimson_fungus": "Багровый грибъ въ горшкѣ",
  "block.minecraft.potted_crimson_roots": "Багровые корни въ горшкѣ",
  "block.minecraft.potted_dandelion": "Одуванчикъ въ горшкѣ",
  "block.minecraft.potted_dark_oak_sapling": "Саженецъ тёмнаго дуба въ горшкѣ",
  "block.minecraft.potted_dead_bush": "Мёртвый кустъ въ горшкѣ",
  "block.minecraft.potted_fern": "Папоротникъ въ горшкѣ",
  "block.minecraft.potted_flowering_azalea_bush": "Цвѣтущая азалія въ горшкѣ",
  "block.minecraft.potted_golden_dandelion": "Золотой одуванчикъ въ горшкѣ",
  "block.minecraft.potted_jungle_sapling": "Саженецъ тропическаго дерева въ горшкѣ",
  "block.minecraft.potted_lily_of_the_valley": "Ландышъ въ горшкѣ",
  "block.minecraft.potted_mangrove_propagule": "Мангровый отростокъ въ горшкѣ",
  "block.minecraft.potted_oak_sapling": "Саженецъ дуба въ горшкѣ",
  "block.minecraft.potted_open_eyeblossom": "Раскрытый очецвѣтъ въ горшкѣ",
  "block.minecraft.potted_orange_tulip": "Оранжевый тюльпанъ въ горшкѣ",
  "block.minecraft.potted_oxeye_daisy": "Ромашка въ горшкѣ",
  "block.minecraft.potted_pale_oak_sapling": "Саженецъ блѣднаго дуба въ горшкѣ",
  "block.minecraft.potted_pink_tulip": "Розовый тюльпанъ въ горшкѣ",
  "block.minecraft.potted_poppy": "Макъ въ горшкѣ",
  "block.minecraft.potted_red_mushroom": "Мухоморъ въ горшкѣ",
  "block.minecraft.potted_red_tulip": "Красный тюльпанъ въ горшкѣ",
  "block.minecraft.potted_spruce_sapling": "Саженецъ ели въ горшкѣ",
  "block.minecraft.potted_torchflower": "Факелоцвѣтъ въ горшкѣ",
  "block.minecraft.potted_warped_fungus": "Искажённый грибъ въ горшкѣ",
  "block.minecraft.potted_warped_roots": "Искажённые корни въ горшкѣ",
  "block.minecraft.potted_white_tulip": "Бѣлый тюльпанъ въ горшкѣ",
  "block.minecraft.potted_wither_rose": "Роза визера въ горшкѣ",
  "block.minecraft.powder_snow": "Рыхлый снѣгъ",
  "block.minecraft.powder_snow_cauldron": "Котёлъ съ рыхлымъ снѣгомъ",
  "block.minecraft.powered_rail": "Запитанные рельсы",
  "block.minecraft.prismarine": "Призмаринъ",
  "block.minecraft.prismarine_brick_slab": "Плита изъ призмариноваго кирпича",
  "block.minecraft.prismarine_brick_stairs": "Ступеньки изъ призмариноваго кирпича",
  "block.minecraft.prismarine_bricks": "Призмариновые кирпичи",
  "block.minecraft.prismarine_slab": "Призмариновая плита",
  "block.minecraft.prismarine_stairs": "Призмариновыя ступеньки",
  "block.minecraft.prismarine_wall": "Призмариновая ограда",
  "block.minecraft.pumpkin": "Тыква",
  "block.minecraft.pumpkin_stem": "Стебель тыквы",
  "block.minecraft.purple_banner": "Фіолетовый флагъ",
  "block.minecraft.purple_bed": "Фіолетовая постель",
  "block.minecraft.purple_candle": "Фіолетовая свѣча",
  "block.minecraft.purple_candle_cake": "Тортъ съ фіолетовой свѣчой",
  "block.minecraft.purple_carpet": "Фіолетовый ковёръ",
  "block.minecraft.purple_concrete": "Фіолетовый бетонъ",
  "block.minecraft.purple_concrete_powder": "Фіолетовый сухой бетонъ",
  "block.minecraft.purple_glazed_terracotta": "Фіолетовая глазурованная керамика",
  "block.minecraft.purple_shulker_box": "Фіолетовый шалкеровый ящикъ",
  "block.minecraft.purple_stained_glass": "Фіолетовое стекло",
  "block.minecraft.purple_stained_glass_pane": "Фіолетовая стеклянная панель",
  "block.minecraft.purple_terracotta": "Фіолетовая керамика",
  "block.minecraft.purple_wool": "Фіолетовая шерсть",
  "block.minecraft.purpur_block": "Пурпуръ",
  "block.minecraft.purpur_pillar": "Пурпуровый пилонъ",
  "block.minecraft.purpur_slab": "Пурпуровая плита",
  "block.minecraft.purpur_stairs": "Пурпуровыя ступеньки",
  "block.minecraft.quartz_block": "Кварцевый блокъ",
  "block.minecraft.quartz_bricks": "Кварцевые кирпичи",
  "block.minecraft.quartz_pillar": "Кварцевая колонна",
  "block.minecraft.quartz_slab": "Кварцевая плита",
  "block.minecraft.quartz_stairs": "Кварцевыя ступеньки",
  "block.minecraft.rail": "Рельсы",
  "block.minecraft.raw_copper_block": "Блокъ рудной мѣди",
  "block.minecraft.raw_gold_block": "Блокъ руднаго золота",
  "block.minecraft.raw_iron_block": "Блокъ руднаго желѣза",
  "block.minecraft.red_banner": "Червонный флагъ",
  "block.minecraft.red_bed": "Червонная постель",
  "block.minecraft.red_candle": "Червонная свѣча",
  "block.minecraft.red_candle_cake": "Тортъ съ червонной свѣчой",
  "block.minecraft.red_carpet": "Червонный ковёръ",
  "block.minecraft.red_concrete": "Червонный бетонъ",
  "block.minecraft.red_concrete_powder": "Червонный сухой бетонъ",
  "block.minecraft.red_glazed_terracotta": "Червонная глазурованная керамика",
  "block.minecraft.red_mushroom": "Мухоморъ",
  "block.minecraft.red_mushroom_block": "Блокъ мухомора",
  "block.minecraft.red_nether_brick_slab": "Плита изъ червоннаго нѣдрскаго кирпича",
  "block.minecraft.red_nether_brick_stairs": "Ступеньки изъ червоннаго нѣдрскаго кирпича",
  "block.minecraft.red_nether_brick_wall": "Ограда изъ червоннаго нѣдрскаго кирпича",
  "block.minecraft.red_nether_bricks": "Червонные нѣдрскіе кирпичи",
  "block.minecraft.red_sand": "Червонный песокъ",
  "block.minecraft.red_sandstone": "Червонный песчаникъ",
  "block.minecraft.red_sandstone_slab": "Плита изъ червоннаго песчаника",
  "block.minecraft.red_sandstone_stairs": "Ступеньки изъ червоннаго песчаника",
  "block.minecraft.red_sandstone_wall": "Ограда изъ червоннаго песчаника",
  "block.minecraft.red_shulker_box": "Червонный шалкеровый ящикъ",
  "block.minecraft.red_stained_glass": "Червонное стекло",
  "block.minecraft.red_stained_glass_pane": "Червонная стеклянная панель",
  "block.minecraft.red_terracotta": "Червонная керамика",
  "block.minecraft.red_tulip": "Красный тюльпанъ",
  "block.minecraft.red_wool": "Червонная шерсть",
  "block.minecraft.redstone_block": "Редстоуновый блокъ",
  "block.minecraft.redstone_lamp": "Редстоуновый фонарь",
  "block.minecraft.redstone_ore": "Редстоуновая руда",
  "block.minecraft.redstone_torch": "Редстоуновый факелъ",
  "block.minecraft.redstone_wall_torch": "Настѣнный редстоуновый факелъ",
  "block.minecraft.redstone_wire": "Редстоуновый проводъ",
  "block.minecraft.reinforced_deepslate": "Укрѣплённый глубинный сланецъ",
  "block.minecraft.repeater": "Редстоуновый повторитель",
  "block.minecraft.repeating_command_block": "Повторяющій ариѳмометръ",
  "block.minecraft.resin_block": "Смоляной блокъ",
  "block.minecraft.resin_brick_slab": "Плита изъ смоляного кирпича",
  "block.minecraft.resin_brick_stairs": "Ступеньки изъ смоляного кирпича",
  "block.minecraft.resin_brick_wall": "Ограда изъ смоляного кирпича",
  "block.minecraft.resin_bricks": "Смоляные кирпичи",
  "block.minecraft.resin_clump": "Сгустокъ смолы",
  "block.minecraft.respawn_anchor": "Якорь возрожденія",
  "block.minecraft.rooted_dirt": "Корнистая земля",
  "block.minecraft.rose_bush": "Розовый кустъ",
  "block.minecraft.sand": "Песокъ",
  "block.minecraft.sandstone": "Песчаникъ",
  "block.minecraft.sandstone_slab": "Песчаниковая плита",
  "block.minecraft.sandstone_stairs": "Песчаниковыя ступеньки",
  "block.minecraft.sandstone_wall": "Песчаниковая ограда",
  "block.minecraft.scaffolding": "Подмостки",
  "block.minecraft.sculk": "Скалкъ",
  "block.minecraft.sculk_catalyst": "Скалковый катализаторъ",
  "block.minecraft.sculk_sensor": "Скалкъ-датчикъ",
  "block.minecraft.sculk_shrieker": "Скалковый крикунъ",
  "block.minecraft.sculk_vein": "Скалковая жила",
  "block.minecraft.sea_lantern": "Морской фонарь",
  "block.minecraft.sea_pickle": "Морской огурецъ",
  "block.minecraft.seagrass": "Морская трава",
  "block.minecraft.set_spawn": "Точка возрожденія установлена",
  "block.minecraft.short_dry_grass": "Низкая сухая трава",
  "block.minecraft.short_grass": "Низкая трава",
  "block.minecraft.shroomlight": "Грибосвѣтъ",
  "block.minecraft.shulker_box": "Шалкеровый ящикъ",
  "block.minecraft.skeleton_skull": "Черепъ",
  "block.minecraft.skeleton_wall_skull": "Настѣнный черепъ",
  "block.minecraft.slime_block": "Блокъ слизи",
  "block.minecraft.small_amethyst_bud": "Малый аметистовый бутонъ",
  "block.minecraft.small_dripleaf": "Маленькая бросянка",
  "block.minecraft.smithing_table": "Столъ кузнеца",
  "block.minecraft.smoker": "Коптильня",
  "block.minecraft.smooth_basalt": "Гладкій базальтъ",
  "block.minecraft.smooth_quartz": "Гладкій кварцъ",
  "block.minecraft.smooth_quartz_slab": "Плита изъ гладкаго кварца",
  "block.minecraft.smooth_quartz_stairs": "Ступеньки изъ гладкаго кварца",
  "block.minecraft.smooth_red_sandstone": "Гладкій червонный песчаникъ",
  "block.minecraft.smooth_red_sandstone_slab": "Плита изъ гладкаго червоннаго песчаника",
  "block.minecraft.smooth_red_sandstone_stairs": "Ступеньки изъ гладкаго червоннаго песчаника",
  "block.minecraft.smooth_sandstone": "Гладкій песчаникъ",
  "block.minecraft.smooth_sandstone_slab": "Плита изъ гладкаго песчаника",
  "block.minecraft.smooth_sandstone_stairs": "Ступеньки изъ гладкаго песчаника",
  "block.minecraft.smooth_stone": "Гладкій камень",
  "block.minecraft.smooth_stone_slab": "Плита изъ гладкаго камня",
  "block.minecraft.sniffer_egg": "Яйцо нюхача",
  "block.minecraft.snow": "Снѣгъ",
  "block.minecraft.snow_block": "Блокъ снѣга",
  "block.minecraft.soul_campfire": "Костёръ душъ",
  "block.minecraft.soul_fire": "Огонь душъ",
  "block.minecraft.soul_lantern": "Фонарь душъ",
  "block.minecraft.soul_sand": "Песокъ душъ",
  "block.minecraft.soul_soil": "Почва душъ",
  "block.minecraft.soul_torch": "Факелъ душъ",
  "block.minecraft.soul_wall_torch": "Настѣнный факелъ душъ",
  "block.minecraft.spawn.not_valid": "У васъ нѣтъ постели или заряженнаго якоря возрожденія, либо доступъ къ нимъ затруднёнъ",
  "block.minecraft.spawner": "Разсадникъ тварей",
  "block.minecraft.spawner.desc1": "Взаимодѣйствіе съ яйцомъ призыва:",
  "block.minecraft.spawner.desc2": "опредѣляетъ типъ твари",
  "block.minecraft.sponge": "Губка",
  "block.minecraft.spore_blossom": "Спороцвѣтъ",
  "block.minecraft.spruce_button": "Еловая кнопка",
  "block.minecraft.spruce_door": "Еловая дверь",
  "block.minecraft.spruce_fence": "Еловый заборъ",
  "block.minecraft.spruce_fence_gate": "Еловая калитка",
  "block.minecraft.spruce_hanging_sign": "Еловая подвѣсная табличка",
  "block.minecraft.spruce_leaves": "Хвоя",
  "block.minecraft.spruce_log": "Еловое бревно",
  "block.minecraft.spruce_planks": "Еловыя доски",
  "block.minecraft.spruce_pressure_plate": "Еловая нажимная плита",
  "block.minecraft.spruce_sapling": "Саженецъ ели",
  "block.minecraft.spruce_shelf": "Еловая полка",
  "block.minecraft.spruce_sign": "Еловая табличка",
  "block.minecraft.spruce_slab": "Еловая плита",
  "block.minecraft.spruce_stairs": "Еловыя ступеньки",
  "block.minecraft.spruce_trapdoor": "Еловый люкъ",
  "block.minecraft.spruce_wall_hanging_sign": "Еловая настѣнная подвѣсная табличка",
  "block.minecraft.spruce_wall_sign": "Еловая настѣнная табличка",
  "block.minecraft.spruce_wood": "Ель",
  "block.minecraft.sticky_piston": "Липкій поршень",
  "block.minecraft.stone": "Камень",
  "block.minecraft.stone_brick_slab": "Плита изъ каменнаго кирпича",
  "block.minecraft.stone_brick_stairs": "Ступеньки изъ каменнаго кирпича",
  "block.minecraft.stone_brick_wall": "Ограда изъ каменнаго кирпича",
  "block.minecraft.stone_bricks": "Каменные кирпичи",
  "block.minecraft.stone_button": "Каменная кнопка",
  "block.minecraft.stone_pressure_plate": "Каменная нажимная плита",
  "block.minecraft.stone_slab": "Каменная плита",
  "block.minecraft.stone_stairs": "Каменныя ступеньки",
  "block.minecraft.stonecutter": "Камнерѣзъ",
  "block.minecraft.stripped_acacia_log": "Обтёсанное акаціевое бревно",
  "block.minecraft.stripped_acacia_wood": "Обтёсанная акаціевая древесина",
  "block.minecraft.stripped_bamboo_block": "Блокъ обтёсаннаго бамбука",
  "block.minecraft.stripped_birch_log": "Обтёсанное берёзовое бревно",
  "block.minecraft.stripped_birch_wood": "Обтёсанная берёзовая древесина",
  "block.minecraft.stripped_cherry_log": "Обтёсанное вишнёвое бревно",
  "block.minecraft.stripped_cherry_wood": "Обтёсанная вишнёвая древесина",
  "block.minecraft.stripped_crimson_hyphae": "Очищенные багровые гифы",
  "block.minecraft.stripped_crimson_stem": "Очищенный багровый стебель",
  "block.minecraft.stripped_dark_oak_log": "Обтёсанное бревно тёмнаго дуба",
  "block.minecraft.stripped_dark_oak_wood": "Обтёсанная древесина тёмнаго дуба",
  "block.minecraft.stripped_jungle_log": "Обтёсанное бревно тропическаго дерева",
  "block.minecraft.stripped_jungle_wood": "Обтёсанная тропическая древесина",
  "block.minecraft.stripped_mangrove_log": "Обтёсанное мангровое бревно",
  "block.minecraft.stripped_mangrove_wood": "Обтёсанная мангровая древесина",
  "block.minecraft.stripped_oak_log": "Обтёсанное дубовое бревно",
  "block.minecraft.stripped_oak_wood": "Обтёсанная дубовая древесина",
  "block.minecraft.stripped_pale_oak_log": "Обтёсанное бревно блѣднаго дуба",
  "block.minecraft.stripped_pale_oak_wood": "Обтёсанная древесина блѣднаго дуба",
  "block.minecraft.stripped_spruce_log": "Обтёсанное еловое бревно",
  "block.minecraft.stripped_spruce_wood": "Обтёсанная еловая древесина",
  "block.minecraft.stripped_warped_hyphae": "Очищенные искажённые гифы",
  "block.minecraft.stripped_warped_stem": "Очищенный искажённый стебель",
  "block.minecraft.structure_block": "Блокъ-конструкторъ",
  "block.minecraft.structure_void": "Пустой блокъ",
  "block.minecraft.sugar_cane": "Сахарный тростникъ",
  "block.minecraft.sunflower": "Подсолнухъ",
  "block.minecraft.suspicious_gravel": "Подозрительный гравій",
  "block.minecraft.suspicious_sand": "Подозрительный песокъ",
  "block.minecraft.sweet_berry_bush": "Кустъ сладкихъ ягодъ",
  "block.minecraft.tall_dry_grass": "Высокая сухая трава",
  "block.minecraft.tall_grass": "Высокая трава",
  "block.minecraft.tall_seagrass": "Высокая морская трава",
  "block.minecraft.target": "Мишень",
  "block.minecraft.terracotta": "Терракота",
  "block.minecraft.test_block": "Блокъ отладки",
  "block.minecraft.test_instance_block": "Блокъ отладки экземпляра",
  "block.minecraft.tinted_glass": "Затемнённое стекло",
  "block.minecraft.tnt": "Динамитъ",
  "block.minecraft.tnt.disabled": "Взрывы динамита отключены",
  "block.minecraft.torch": "Факелъ",
  "block.minecraft.torchflower": "Факелоцвѣтъ",
  "block.minecraft.torchflower_crop": "Ростокъ факелоцвѣта",
  "block.minecraft.trapped_chest": "Сундукъ-ловушка",
  "block.minecraft.trial_spawner": "Разсадникъ испытаній",
  "block.minecraft.tripwire": "Растяжка",
  "block.minecraft.tripwire_hook": "Крюкъ",
  "block.minecraft.tube_coral": "Трубчатый кораллъ",
  "block.minecraft.tube_coral_block": "Блокъ трубчатаго коралла",
  "block.minecraft.tube_coral_fan": "Вѣерный трубчатый кораллъ",
  "block.minecraft.tube_coral_wall_fan": "Горизонтальный вѣерный трубчатый кораллъ",
  "block.minecraft.tuff": "Туфъ",
  "block.minecraft.tuff_brick_slab": "Плита изъ туфоваго кирпича",
  "block.minecraft.tuff_brick_stairs": "Ступеньки изъ туфоваго кирпича",
  "block.minecraft.tuff_brick_wall": "Ограда изъ туфоваго кирпича",
  "block.minecraft.tuff_bricks": "Туфовые кирпичи",
  "block.minecraft.tuff_slab": "Туфовая плита",
  "block.minecraft.tuff_stairs": "Туфовыя ступеньки",
  "block.minecraft.tuff_wall": "Туфовая ограда",
  "block.minecraft.turtle_egg": "Черепашье яйцо",
  "block.minecraft.twisting_vines": "Вьющаяся лоза",
  "block.minecraft.twisting_vines_plant": "Стебель вьющейся лозы",
  "block.minecraft.vault": "Хранилище",
  "block.minecraft.verdant_froglight": "Малахитовая квампа",
  "block.minecraft.vine": "Ліаны",
  "block.minecraft.void_air": "Вакуумъ",
  "block.minecraft.wall_torch": "Настѣнный факелъ",
  "block.minecraft.warped_button": "Искажённая кнопка",
  "block.minecraft.warped_door": "Искажённая дверь",
  "block.minecraft.warped_fence": "Искажённый заборъ",
  "block.minecraft.warped_fence_gate": "Искажённая калитка",
  "block.minecraft.warped_fungus": "Искажённый грибъ",
  "block.minecraft.warped_hanging_sign": "Искажённая подвѣсная табличка",
  "block.minecraft.warped_hyphae": "Искажённые гифы",
  "block.minecraft.warped_nylium": "Искажённый нилій",
  "block.minecraft.warped_planks": "Искажённыя доски",
  "block.minecraft.warped_pressure_plate": "Искажённая нажимная плита",
  "block.minecraft.warped_roots": "Искажённые корни",
  "block.minecraft.warped_shelf": "Искажённая полка",
  "block.minecraft.warped_sign": "Искажённая табличка",
  "block.minecraft.warped_slab": "Искажённая плита",
  "block.minecraft.warped_stairs": "Искажённыя ступеньки",
  "block.minecraft.warped_stem": "Искажённый стебель",
  "block.minecraft.warped_trapdoor": "Искажённый люкъ",
  "block.minecraft.warped_wall_hanging_sign": "Искажённая настѣнная подвѣсная табличка",
  "block.minecraft.warped_wall_sign": "Искажённая настѣнная табличка",
  "block.minecraft.warped_wart_block": "Блокъ искажённаго нароста",
  "block.minecraft.water": "Вода",
  "block.minecraft.water_cauldron": "Котёлъ съ водой",
  "block.minecraft.waxed_chiseled_copper": "Вощёный точёный мѣдный блокъ",
  "block.minecraft.waxed_copper_bars": "Вощёные мѣдные прутья",
  "block.minecraft.waxed_copper_block": "Вощёный мѣдный блокъ",
  "block.minecraft.waxed_copper_bulb": "Вощёная мѣдная лампа",
  "block.minecraft.waxed_copper_chain": "Вощёная мѣдная цѣпь",
  "block.minecraft.waxed_copper_chest": "Вощёный мѣдный сундукъ",
  "block.minecraft.waxed_copper_door": "Вощёная мѣдная дверь",
  "block.minecraft.waxed_copper_golem_statue": "Вощёная статуя мѣднаго домовёнка",
  "block.minecraft.waxed_copper_grate": "Вощёная мѣдная рѣшётка",
  "block.minecraft.waxed_copper_lantern": "Вощёный мѣдный фонарь",
  "block.minecraft.waxed_copper_trapdoor": "Вощёный мѣдный люкъ",
  "block.minecraft.waxed_cut_copper": "Вощёный рѣзной мѣдный блокъ",
  "block.minecraft.waxed_cut_copper_slab": "Вощёная рѣзная мѣдная плита",
  "block.minecraft.waxed_cut_copper_stairs": "Вощёныя рѣзныя мѣдныя ступеньки",
  "block.minecraft.waxed_exposed_chiseled_copper": "Вощёный патиновый точёный мѣдный блокъ",
  "block.minecraft.waxed_exposed_copper": "Вощёный патиновый мѣдный блокъ",
  "block.minecraft.waxed_exposed_copper_bars": "Вощёные патиновые мѣдные прутья",
  "block.minecraft.waxed_exposed_copper_bulb": "Вощёная патиновая мѣдная лампа",
  "block.minecraft.waxed_exposed_copper_chain": "Вощёная патиновая мѣдная цѣпь",
  "block.minecraft.waxed_exposed_copper_chest": "Вощёный патиновый мѣдный сундукъ",
  "block.minecraft.waxed_exposed_copper_door": "Вощёная патиновая мѣдная дверь",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Вощёная патиновая статуя мѣднаго домовёнка",
  "block.minecraft.waxed_exposed_copper_grate": "Вощёная патиновая мѣдная рѣшётка",
  "block.minecraft.waxed_exposed_copper_lantern": "Вощёный патиновый мѣдный фонарь",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Вощёный патиновый мѣдный люкъ",
  "block.minecraft.waxed_exposed_cut_copper": "Вощёный патиновый рѣзной мѣдный блокъ",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Вощёная патиновая рѣзная мѣдная плита",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Вощёныя патиновыя рѣзныя мѣдныя ступеньки",
  "block.minecraft.waxed_exposed_lightning_rod": "Вощёный патиновый громоотводъ",
  "block.minecraft.waxed_lightning_rod": "Вощёный громоотводъ",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Вощёный окисленный точёный мѣдный блокъ",
  "block.minecraft.waxed_oxidized_copper": "Вощёный окисленный мѣдный блокъ",
  "block.minecraft.waxed_oxidized_copper_bars": "Вощёные окисленные мѣдные прутья",
  "block.minecraft.waxed_oxidized_copper_bulb": "Вощёная окисленная мѣдная лампа",
  "block.minecraft.waxed_oxidized_copper_chain": "Вощёная окисленная мѣдная цѣпь",
  "block.minecraft.waxed_oxidized_copper_chest": "Вощёный окисленный мѣдный сундукъ",
  "block.minecraft.waxed_oxidized_copper_door": "Вощёная окисленная мѣдная дверь",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Вощёная окисленная статуя мѣднаго домовёнка",
  "block.minecraft.waxed_oxidized_copper_grate": "Вощёная окисленная мѣдная рѣшётка",
  "block.minecraft.waxed_oxidized_copper_lantern": "Вощёный окисленный мѣдный фонарь",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Вощёный окисленный мѣдный люкъ",
  "block.minecraft.waxed_oxidized_cut_copper": "Вощёный окисленный рѣзной мѣдный блокъ",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Вощёная окисленная рѣзная мѣдная плита",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Вощёныя окисленныя рѣзныя мѣдныя ступеньки",
  "block.minecraft.waxed_oxidized_lightning_rod": "Вощёный окисленный громоотводъ",
  "block.minecraft.waxed_weathered_chiseled_copper": "Вощёный состаренный точёный мѣдный блокъ",
  "block.minecraft.waxed_weathered_copper": "Вощёный состаренный мѣдный блокъ",
  "block.minecraft.waxed_weathered_copper_bars": "Вощёные состаренные мѣдные прутья",
  "block.minecraft.waxed_weathered_copper_bulb": "Вощёная состаренная мѣдная лампа",
  "block.minecraft.waxed_weathered_copper_chain": "Вощёная состаренная мѣдная цѣпь",
  "block.minecraft.waxed_weathered_copper_chest": "Вощёный состаренный мѣдный сундукъ",
  "block.minecraft.waxed_weathered_copper_door": "Вощёная состаренная мѣдная дверь",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Вощёная состаренная статуя мѣднаго домовёнка",
  "block.minecraft.waxed_weathered_copper_grate": "Вощёная состаренная мѣдная рѣшётка",
  "block.minecraft.waxed_weathered_copper_lantern": "Вощёный состаренный мѣдный фонарь",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Вощёный состаренный мѣдный люкъ",
  "block.minecraft.waxed_weathered_cut_copper": "Вощёный состаренный рѣзной мѣдный блокъ",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Вощёная состаренная рѣзная мѣдная плита",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Вощёныя состаренныя рѣзныя мѣдныя ступеньки",
  "block.minecraft.waxed_weathered_lightning_rod": "Вощёный состаренный громоотводъ",
  "block.minecraft.weathered_chiseled_copper": "Состаренный точёный мѣдный блокъ",
  "block.minecraft.weathered_copper": "Состаренный мѣдный блокъ",
  "block.minecraft.weathered_copper_bars": "Состаренные мѣдные прутья",
  "block.minecraft.weathered_copper_bulb": "Состаренная мѣдная лампа",
  "block.minecraft.weathered_copper_chain": "Состаренная мѣдная цѣпь",
  "block.minecraft.weathered_copper_chest": "Состаренный мѣдный сундукъ",
  "block.minecraft.weathered_copper_door": "Состаренная мѣдная дверь",
  "block.minecraft.weathered_copper_golem_statue": "Состаренная статуя мѣднаго домовёнка",
  "block.minecraft.weathered_copper_grate": "Состаренная мѣдная рѣшётка",
  "block.minecraft.weathered_copper_lantern": "Состаренный мѣдный фонарь",
  "block.minecraft.weathered_copper_trapdoor": "Состаренный мѣдный люкъ",
  "block.minecraft.weathered_cut_copper": "Состаренный рѣзной мѣдный блокъ",
  "block.minecraft.weathered_cut_copper_slab": "Состаренная рѣзная мѣдная плита",
  "block.minecraft.weathered_cut_copper_stairs": "Состаренныя рѣзныя мѣдныя ступеньки",
  "block.minecraft.weathered_lightning_rod": "Состаренный громоотводъ",
  "block.minecraft.weeping_vines": "Плакучая лоза",
  "block.minecraft.weeping_vines_plant": "Стебель плакучей лозы",
  "block.minecraft.wet_sponge": "Мокрая губка",
  "block.minecraft.wheat": "Ростки пшеницы",
  "block.minecraft.white_banner": "Бѣлый флагъ",
  "block.minecraft.white_bed": "Бѣлая постель",
  "block.minecraft.white_candle": "Бѣлая свѣча",
  "block.minecraft.white_candle_cake": "Тортъ съ бѣлой свѣчой",
  "block.minecraft.white_carpet": "Бѣлый ковёръ",
  "block.minecraft.white_concrete": "Бѣлый бетонъ",
  "block.minecraft.white_concrete_powder": "Бѣлый сухой бетонъ",
  "block.minecraft.white_glazed_terracotta": "Бѣлая глазированная керамика",
  "block.minecraft.white_shulker_box": "Бѣлый шалкеровый ящикъ",
  "block.minecraft.white_stained_glass": "Бѣлое стекло",
  "block.minecraft.white_stained_glass_pane": "Бѣлая стеклянная панель",
  "block.minecraft.white_terracotta": "Бѣлая керамика",
  "block.minecraft.white_tulip": "Бѣлый тюльпанъ",
  "block.minecraft.white_wool": "Бѣлая шерсть",
  "block.minecraft.wildflowers": "Полевые цвѣты",
  "block.minecraft.wither_rose": "Роза визера",
  "block.minecraft.wither_skeleton_skull": "Черепъ визеръ-скелета",
  "block.minecraft.wither_skeleton_wall_skull": "Настѣнный черепъ визеръ-скелета",
  "block.minecraft.yellow_banner": "Жёлтый флагъ",
  "block.minecraft.yellow_bed": "Жёлтая постель",
  "block.minecraft.yellow_candle": "Жёлтая свѣча",
  "block.minecraft.yellow_candle_cake": "Тортъ съ жёлтой свѣчой",
  "block.minecraft.yellow_carpet": "Жёлтый ковёръ",
  "block.minecraft.yellow_concrete": "Жёлтый бетонъ",
  "block.minecraft.yellow_concrete_powder": "Жёлтый сухой бетонъ",
  "block.minecraft.yellow_glazed_terracotta": "Жёлтая глазурованная керамика",
  "block.minecraft.yellow_shulker_box": "Жёлтый шалкеровый ящикъ",
  "block.minecraft.yellow_stained_glass": "Жёлтое стекло",
  "block.minecraft.yellow_stained_glass_pane": "Жёлтая стеклянная панель",
  "block.minecraft.yellow_terracotta": "Жёлтая керамика",
  "block.minecraft.yellow_wool": "Жёлтая шерсть",
  "block.minecraft.zombie_head": "Голова мертвеца",
  "block.minecraft.zombie_wall_head": "Настѣнная голова мертвеца",
  "item.minecraft.acacia_boat": "Акаціевая лодка",
  "item.minecraft.acacia_chest_boat": "Акаціевая грузовая лодка",
  "item.minecraft.allay_spawn_egg": "Яйцо призыва угодника",
  "item.minecraft.amethyst_shard": "Осколокъ аметиста",
  "item.minecraft.angler_pottery_shard": "Глиняный черепокъ «Рыбарь»",
  "item.minecraft.angler_pottery_sherd": "Глиняный черепокъ «Рыбарь»",
  "item.minecraft.apple": "Яблоко",
  "item.minecraft.archer_pottery_shard": "Глиняный черепокъ «Стрѣлецъ»",
  "item.minecraft.archer_pottery_sherd": "Глиняный черепокъ «Стрѣлецъ»",
  "item.minecraft.armadillo_scute": "Щитокъ броненосца",
  "item.minecraft.armadillo_spawn_egg": "Яйцо призыва броненосца",
  "item.minecraft.armor_stand": "Стойка для брони",
  "item.minecraft.arms_up_pottery_shard": "Глиняный черепокъ «Руки вверхъ»",
  "item.minecraft.arms_up_pottery_sherd": "Глиняный черепокъ «Руки вверхъ»",
  "item.minecraft.arrow": "Стрѣла",
  "item.minecraft.axolotl_bucket": "Аксолотль въ ведрѣ",
  "item.minecraft.axolotl_spawn_egg": "Яйцо призыва аксолотля",
  "item.minecraft.baked_potato": "Печёный картофель",
  "item.minecraft.bamboo_chest_raft": "Грузовой бамбуковый плотъ",
  "item.minecraft.bamboo_raft": "Бамбуковый плотъ",
  "item.minecraft.bat_spawn_egg": "Яйцо призыва летучей мыши",
  "item.minecraft.bee_spawn_egg": "Яйцо призыва пчелы",
  "item.minecraft.beef": "Сырая говядина",
  "item.minecraft.beetroot": "Свёкла",
  "item.minecraft.beetroot_seeds": "Сѣмена свёклы",
  "item.minecraft.beetroot_soup": "Свекольный супъ",
  "item.minecraft.birch_boat": "Берёзовая лодка",
  "item.minecraft.birch_chest_boat": "Берёзовая грузовая лодка",
  "item.minecraft.black_bundle": "Чёрный мѣшокъ",
  "item.minecraft.black_dye": "Чёрный краситель",
  "item.minecraft.black_harness": "Чёрная упряжь",
  "item.minecraft.blade_pottery_shard": "Глиняный черепокъ «Клинокъ»",
  "item.minecraft.blade_pottery_sherd": "Глиняный черепокъ «Клинокъ»",
  "item.minecraft.blaze_powder": "Огненный порошокъ",
  "item.minecraft.blaze_rod": "Огненный жезлъ",
  "item.minecraft.blaze_spawn_egg": "Яйцо призыва пламеня",
  "item.minecraft.blue_bundle": "Лазурный мѣшокъ",
  "item.minecraft.blue_dye": "Лазурный краситель",
  "item.minecraft.blue_egg": "Голубое яйцо",
  "item.minecraft.blue_harness": "Лазурная упряжь",
  "item.minecraft.bogged_spawn_egg": "Яйцо призыва болотника",
  "item.minecraft.bolt_armor_trim_smithing_template": "Кузнечное лекало",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Отдѣлка «Ось»",
  "item.minecraft.bone": "Кость",
  "item.minecraft.bone_meal": "Костная мука",
  "item.minecraft.book": "Книга",
  "item.minecraft.bordure_indented_banner_pattern": "Узоръ флага «Зубчатая кайма»",
  "item.minecraft.bow": "Лукъ",
  "item.minecraft.bowl": "Миска",
  "item.minecraft.bread": "Хлѣбъ",
  "item.minecraft.breeze_rod": "Вихревой жезлъ",
  "item.minecraft.breeze_spawn_egg": "Яйцо призыва вихря",
  "item.minecraft.brewer_pottery_shard": "Глиняный черепокъ «Зельеваръ»",
  "item.minecraft.brewer_pottery_sherd": "Глиняный черепокъ «Зельеваръ»",
  "item.minecraft.brewing_stand": "Зельеварка",
  "item.minecraft.brick": "Кирпичъ",
  "item.minecraft.brown_bundle": "Коричневый мѣшокъ",
  "item.minecraft.brown_dye": "Коричневый краситель",
  "item.minecraft.brown_egg": "Коричневое яйцо",
  "item.minecraft.brown_harness": "Коричневая упряжь",
  "item.minecraft.brush": "Кисть",
  "item.minecraft.bucket": "Ведро",
  "item.minecraft.bundle": "Мѣшокъ",
  "item.minecraft.bundle.empty": "Пустой",
  "item.minecraft.bundle.empty.description": "Вмѣщаетъ стопку разныхъ вещей",
  "item.minecraft.bundle.full": "Полный",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Глиняный черепокъ «Пламя»",
  "item.minecraft.burn_pottery_sherd": "Глиняный черепокъ «Пламя»",
  "item.minecraft.camel_husk_spawn_egg": "Яйцо призыва верблюда-кадавра",
  "item.minecraft.camel_spawn_egg": "Яйцо призыва верблюда",
  "item.minecraft.carrot": "Морковь",
  "item.minecraft.carrot_on_a_stick": "Удочка съ морковкой",
  "item.minecraft.cat_spawn_egg": "Яйцо призыва кошки",
  "item.minecraft.cauldron": "Котёлъ",
  "item.minecraft.cave_spider_spawn_egg": "Яйцо призыва мизгиря",
  "item.minecraft.chainmail_boots": "Кольчужные ботинки",
  "item.minecraft.chainmail_chestplate": "Кольчуга",
  "item.minecraft.chainmail_helmet": "Койфъ",
  "item.minecraft.chainmail_leggings": "Кольчужные поножи",
  "item.minecraft.charcoal": "Древесный уголь",
  "item.minecraft.cherry_boat": "Вишнёвая лодка",
  "item.minecraft.cherry_chest_boat": "Вишнёвая грузовая лодка",
  "item.minecraft.chest_minecart": "Грузовая вагонетка",
  "item.minecraft.chicken": "Курятина",
  "item.minecraft.chicken_spawn_egg": "Яйцо призыва курицы",
  "item.minecraft.chorus_fruit": "Плодъ хоруса",
  "item.minecraft.clay_ball": "Комокъ глины",
  "item.minecraft.clock": "Часы",
  "item.minecraft.coal": "Уголь",
  "item.minecraft.coast_armor_trim_smithing_template": "Кузнечное лекало",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Отдѣлка «Берегъ»",
  "item.minecraft.cocoa_beans": "Какао-бобы",
  "item.minecraft.cod": "Сырая треска",
  "item.minecraft.cod_bucket": "Треска въ ведрѣ",
  "item.minecraft.cod_spawn_egg": "Яйцо призыва трески",
  "item.minecraft.command_block_minecart": "Вагонетка съ ариѳмометромъ",
  "item.minecraft.compass": "Компасъ",
  "item.minecraft.cooked_beef": "Бифстексъ",
  "item.minecraft.cooked_chicken": "Жареная курица",
  "item.minecraft.cooked_cod": "Жареная треска",
  "item.minecraft.cooked_mutton": "Жареная баранина",
  "item.minecraft.cooked_porkchop": "Жареная свинина",
  "item.minecraft.cooked_rabbit": "Жареная крольчатина",
  "item.minecraft.cooked_salmon": "Жареный лосось",
  "item.minecraft.cookie": "Печенье",
  "item.minecraft.copper_axe": "Мѣдный топоръ",
  "item.minecraft.copper_boots": "Мѣдные ботинки",
  "item.minecraft.copper_chestplate": "Мѣдный нагрудникъ",
  "item.minecraft.copper_golem_spawn_egg": "Яйцо призыва мѣднаго витязя",
  "item.minecraft.copper_helmet": "Мѣдный шлемъ",
  "item.minecraft.copper_hoe": "Мѣдная мотыга",
  "item.minecraft.copper_horse_armor": "Мѣдная конская броня",
  "item.minecraft.copper_ingot": "Мѣдный слитокъ",
  "item.minecraft.copper_leggings": "Мѣдные поножи",
  "item.minecraft.copper_nautilus_armor": "Мѣдная броня наутилуса",
  "item.minecraft.copper_nugget": "Кусочекъ мѣди",
  "item.minecraft.copper_pickaxe": "Мѣдная кирка",
  "item.minecraft.copper_shovel": "Мѣдная лопата",
  "item.minecraft.copper_spear": "Мѣдное копьё",
  "item.minecraft.copper_sword": "Мѣдный мечъ",
  "item.minecraft.cow_spawn_egg": "Яйцо призыва коровы",
  "item.minecraft.creaking_spawn_egg": "Яйцо призыва скрипуна",
  "item.minecraft.creeper_banner_pattern": "Узоръ флага",
  "item.minecraft.creeper_banner_pattern.desc": "Криперъ",
  "item.minecraft.creeper_banner_pattern.new": "Узоръ флага «Криперъ»",
  "item.minecraft.creeper_spawn_egg": "Яйцо призыва крипера",
  "item.minecraft.crossbow": "Самострѣлъ",
  "item.minecraft.crossbow.projectile": "Снарядъ:",
  "item.minecraft.crossbow.projectile.multiple": "Снарядъ: %s × %s",
  "item.minecraft.crossbow.projectile.single": "Снарядъ: %s",
  "item.minecraft.cyan_bundle": "Бирюзовый мѣшокъ",
  "item.minecraft.cyan_dye": "Бирюзовый краситель",
  "item.minecraft.cyan_harness": "Бирюзовая упряжь",
  "item.minecraft.danger_pottery_shard": "Глиняный черепокъ «Угроза»",
  "item.minecraft.danger_pottery_sherd": "Глиняный черепокъ «Угроза»",
  "item.minecraft.dark_oak_boat": "Лодка изъ тёмнаго дуба",
  "item.minecraft.dark_oak_chest_boat": "Грузовая лодка изъ тёмнаго дуба",
  "item.minecraft.debug_stick": "Палочка отладки",
  "item.minecraft.debug_stick.empty": "Свойства объекта %s не заданы",
  "item.minecraft.debug_stick.select": "выбрано «%s» (%s)",
  "item.minecraft.debug_stick.update": "«%s»: %s",
  "item.minecraft.diamond": "Діамантъ",
  "item.minecraft.diamond_axe": "Діамантовый топоръ",
  "item.minecraft.diamond_boots": "Діамантовые ботинки",
  "item.minecraft.diamond_chestplate": "Діамантовый нагрудникъ",
  "item.minecraft.diamond_helmet": "Діамантовый шлемъ",
  "item.minecraft.diamond_hoe": "Діамантовая мотыга",
  "item.minecraft.diamond_horse_armor": "Діамантовая конская броня",
  "item.minecraft.diamond_leggings": "Діамантовые поножи",
  "item.minecraft.diamond_nautilus_armor": "Діамантовая броня наутилуса",
  "item.minecraft.diamond_pickaxe": "Діамантовая кирка",
  "item.minecraft.diamond_shovel": "Діамантовая лопата",
  "item.minecraft.diamond_spear": "Діамантовое копьё",
  "item.minecraft.diamond_sword": "Діамантовый мечъ",
  "item.minecraft.disc_fragment_5": "Осколокъ пластинки",
  "item.minecraft.disc_fragment_5.desc": "Пластинка — 5",
  "item.minecraft.dolphin_spawn_egg": "Яйцо призыва дельфина",
  "item.minecraft.donkey_spawn_egg": "Яйцо призыва осла",
  "item.minecraft.dragon_breath": "Дыханіе змѣя",
  "item.minecraft.dried_kelp": "Сушёная ламинарія",
  "item.minecraft.drowned_spawn_egg": "Яйцо призыва утопленника",
  "item.minecraft.dune_armor_trim_smithing_template": "Кузнечное лекало",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Отдѣлка «Дюна»",
  "item.minecraft.echo_shard": "Осколокъ эха",
  "item.minecraft.egg": "Яйцо",
  "item.minecraft.elder_guardian_spawn_egg": "Яйцо призыва старѣйшаго сторожа",
  "item.minecraft.elytra": "Надкрылья",
  "item.minecraft.emerald": "Смарагдъ",
  "item.minecraft.enchanted_book": "Чародѣйская книга",
  "item.minecraft.enchanted_golden_apple": "Молодильное яблоко",
  "item.minecraft.end_crystal": "Кристаллъ Энда",
  "item.minecraft.ender_dragon_spawn_egg": "Яйцо призыва Эндеръ-змѣя",
  "item.minecraft.ender_eye": "Око Эндера",
  "item.minecraft.ender_pearl": "Эндеръ-жемчугъ",
  "item.minecraft.enderman_spawn_egg": "Яйцо призыва эндермана",
  "item.minecraft.endermite_spawn_egg": "Яйцо призыва эндермита",
  "item.minecraft.evoker_spawn_egg": "Яйцо призыва чародѣя",
  "item.minecraft.experience_bottle": "Бутылочка мудрости",
  "item.minecraft.explorer_pottery_shard": "Глиняный черепокъ «Изслѣдователь»",
  "item.minecraft.explorer_pottery_sherd": "Глиняный черепокъ «Изслѣдователь»",
  "item.minecraft.eye_armor_trim_smithing_template": "Кузнечное лекало",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Отдѣлка «Око»",
  "item.minecraft.feather": "Перо",
  "item.minecraft.fermented_spider_eye": "Засоленное паучье око",
  "item.minecraft.field_masoned_banner_pattern": "Узоръ флага «Муровка»",
  "item.minecraft.filled_map": "Карта",
  "item.minecraft.fire_charge": "Огненный зарядъ",
  "item.minecraft.firework_rocket": "Фейерверкъ",
  "item.minecraft.firework_rocket.flight": "Длительность полёта:",
  "item.minecraft.firework_rocket.multiple_stars": "%s × %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Пиротехническая звѣзда",
  "item.minecraft.firework_star.black": "Чёрный",
  "item.minecraft.firework_star.blue": "Лазурный",
  "item.minecraft.firework_star.brown": "Коричневый",
  "item.minecraft.firework_star.custom_color": "Пользовательскій",
  "item.minecraft.firework_star.cyan": "Бирюзовый",
  "item.minecraft.firework_star.fade_to": "Затуханіе въ",
  "item.minecraft.firework_star.flicker": "Мерцаніе",
  "item.minecraft.firework_star.gray": "Сѣрый",
  "item.minecraft.firework_star.green": "Зелёный",
  "item.minecraft.firework_star.light_blue": "Голубой",
  "item.minecraft.firework_star.light_gray": "Свѣтлосѣрый",
  "item.minecraft.firework_star.lime": "Яркозелёный",
  "item.minecraft.firework_star.magenta": "Пурпурный",
  "item.minecraft.firework_star.orange": "Оранжевый",
  "item.minecraft.firework_star.pink": "Розовый",
  "item.minecraft.firework_star.purple": "Фіолетовый",
  "item.minecraft.firework_star.red": "Червонный",
  "item.minecraft.firework_star.shape": "Неизвѣстная форма",
  "item.minecraft.firework_star.shape.burst": "Всплескъ",
  "item.minecraft.firework_star.shape.creeper": "Криперообразный",
  "item.minecraft.firework_star.shape.large_ball": "Большой шаръ",
  "item.minecraft.firework_star.shape.small_ball": "Малый шаръ",
  "item.minecraft.firework_star.shape.star": "Звѣздообразный",
  "item.minecraft.firework_star.trail": "Слѣдъ",
  "item.minecraft.firework_star.white": "Бѣлый",
  "item.minecraft.firework_star.yellow": "Жёлтый",
  "item.minecraft.fishing_rod": "Удочка",
  "item.minecraft.flint": "Кремень",
  "item.minecraft.flint_and_steel": "Огниво",
  "item.minecraft.flow_armor_trim_smithing_template": "Кузнечное лекало",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Отдѣлка «Потокъ»",
  "item.minecraft.flow_banner_pattern": "Узоръ флага",
  "item.minecraft.flow_banner_pattern.desc": "Потокъ",
  "item.minecraft.flow_banner_pattern.new": "Узоръ флага «Потокъ»",
  "item.minecraft.flow_pottery_sherd": "Глиняный черепокъ «Потокъ»",
  "item.minecraft.flower_banner_pattern": "Узоръ флага",
  "item.minecraft.flower_banner_pattern.desc": "Цвѣтокъ",
  "item.minecraft.flower_banner_pattern.new": "Узоръ флага «Цвѣтокъ»",
  "item.minecraft.flower_pot": "Цвѣточный горшокъ",
  "item.minecraft.fox_spawn_egg": "Яйцо призыва лисицы",
  "item.minecraft.friend_pottery_shard": "Глиняный черепокъ «Другъ»",
  "item.minecraft.friend_pottery_sherd": "Глиняный черепокъ «Другъ»",
  "item.minecraft.frog_spawn_egg": "Яйцо призыва лягушки",
  "item.minecraft.furnace_minecart": "Самоходная вагонетка",
  "item.minecraft.ghast_spawn_egg": "Яйцо призыва гаста",
  "item.minecraft.ghast_tear": "Слеза гаста",
  "item.minecraft.glass_bottle": "Бутылочка",
  "item.minecraft.glistering_melon_slice": "Сверкающій ломтикъ арбуза",
  "item.minecraft.globe_banner_pattern": "Узоръ флага",
  "item.minecraft.globe_banner_pattern.desc": "Глобусъ",
  "item.minecraft.globe_banner_pattern.new": "Узоръ флага «Глобусъ»",
  "item.minecraft.glow_berries": "Свѣтящіяся ягоды",
  "item.minecraft.glow_ink_sac": "Сіяющій чернильный мѣшокъ",
  "item.minecraft.glow_item_frame": "Сіяющая рамка",
  "item.minecraft.glow_squid_spawn_egg": "Яйцо призыва сіяющаго осьминога",
  "item.minecraft.glowstone_dust": "Свѣтокаменная пыль",
  "item.minecraft.goat_horn": "Козій рогъ",
  "item.minecraft.goat_spawn_egg": "Яйцо призыва козы",
  "item.minecraft.gold_ingot": "Золотой слитокъ",
  "item.minecraft.gold_nugget": "Кусочекъ золота",
  "item.minecraft.golden_apple": "Золотое яблоко",
  "item.minecraft.golden_axe": "Золотой топоръ",
  "item.minecraft.golden_boots": "Золотые ботинки",
  "item.minecraft.golden_carrot": "Золотая морковь",
  "item.minecraft.golden_chestplate": "Золотой нагрудникъ",
  "item.minecraft.golden_helmet": "Золотой шлемъ",
  "item.minecraft.golden_hoe": "Золотая мотыга",
  "item.minecraft.golden_horse_armor": "Золотая конская броня",
  "item.minecraft.golden_leggings": "Золотые поножи",
  "item.minecraft.golden_nautilus_armor": "Золотая броня наутилуса",
  "item.minecraft.golden_pickaxe": "Золотая кирка",
  "item.minecraft.golden_shovel": "Золотая лопата",
  "item.minecraft.golden_spear": "Золотое копьё",
  "item.minecraft.golden_sword": "Золотой мечъ",
  "item.minecraft.gray_bundle": "Сѣрый мѣшокъ",
  "item.minecraft.gray_dye": "Сѣрый краситель",
  "item.minecraft.gray_harness": "Сѣрая упряжь",
  "item.minecraft.green_bundle": "Зелёный мѣшокъ",
  "item.minecraft.green_dye": "Зелёный краситель",
  "item.minecraft.green_harness": "Зелёная упряжь",
  "item.minecraft.guardian_spawn_egg": "Яйцо призыва сторожа",
  "item.minecraft.gunpowder": "Порохъ",
  "item.minecraft.guster_banner_pattern": "Узоръ флага",
  "item.minecraft.guster_banner_pattern.desc": "Вихрь",
  "item.minecraft.guster_banner_pattern.new": "Узоръ флага «Вихрь»",
  "item.minecraft.guster_pottery_sherd": "Глиняный черепокъ «Вихрь»",
  "item.minecraft.happy_ghast_spawn_egg": "Яйцо призыва счастливаго гаста",
  "item.minecraft.harness": "Упряжь",
  "item.minecraft.heart_of_the_sea": "Сердце моря",
  "item.minecraft.heart_pottery_shard": "Глиняный черепокъ «Сердце»",
  "item.minecraft.heart_pottery_sherd": "Глиняный черепокъ «Сердце»",
  "item.minecraft.heartbreak_pottery_shard": "Глиняный черепокъ «Разбитое сердце»",
  "item.minecraft.heartbreak_pottery_sherd": "Глиняный черепокъ «Разбитое сердце»",
  "item.minecraft.hoglin_spawn_egg": "Яйцо призыва хоглина",
  "item.minecraft.honey_bottle": "Бутылочка мёда",
  "item.minecraft.honeycomb": "Пчелиныя соты",
  "item.minecraft.hopper_minecart": "Загрузочная вагонетка",
  "item.minecraft.horse_spawn_egg": "Яйцо призыва лошади",
  "item.minecraft.host_armor_trim_smithing_template": "Кузнечное лекало",
  "item.minecraft.host_armor_trim_smithing_template.new": "Отдѣлка «Вождь»",
  "item.minecraft.howl_pottery_shard": "Глиняный черепокъ «Вой»",
  "item.minecraft.howl_pottery_sherd": "Глиняный черепокъ «Вой»",
  "item.minecraft.husk_spawn_egg": "Яйцо призыва кадавра",
  "item.minecraft.ink_sac": "Чернильный мѣшокъ",
  "item.minecraft.iron_axe": "Желѣзный топоръ",
  "item.minecraft.iron_boots": "Желѣзные ботинки",
  "item.minecraft.iron_chestplate": "Желѣзный нагрудникъ",
  "item.minecraft.iron_golem_spawn_egg": "Яйцо призыва желѣзнаго витязя",
  "item.minecraft.iron_helmet": "Желѣзный шлемъ",
  "item.minecraft.iron_hoe": "Желѣзная мотыга",
  "item.minecraft.iron_horse_armor": "Желѣзная конская броня",
  "item.minecraft.iron_ingot": "Желѣзный слитокъ",
  "item.minecraft.iron_leggings": "Желѣзные поножи",
  "item.minecraft.iron_nautilus_armor": "Желѣзная броня наутилуса",
  "item.minecraft.iron_nugget": "Кусочекъ желѣза",
  "item.minecraft.iron_pickaxe": "Желѣзная кирка",
  "item.minecraft.iron_shovel": "Желѣзная лопата",
  "item.minecraft.iron_spear": "Желѣзное копьё",
  "item.minecraft.iron_sword": "Желѣзный мечъ",
  "item.minecraft.item_frame": "Рамка",
  "item.minecraft.jungle_boat": "Лодка изъ тропическаго дерева",
  "item.minecraft.jungle_chest_boat": "Грузовая лодка изъ тропическаго дерева",
  "item.minecraft.knowledge_book": "Книга знаній",
  "item.minecraft.lapis_lazuli": "Лазурикъ",
  "item.minecraft.lava_bucket": "Ведро лавы",
  "item.minecraft.lead": "Поводокъ",
  "item.minecraft.leather": "Кожа",
  "item.minecraft.leather_boots": "Кожаные ботинки",
  "item.minecraft.leather_chestplate": "Кожаная куртка",
  "item.minecraft.leather_helmet": "Кожаный шлемъ",
  "item.minecraft.leather_horse_armor": "Кожаная конская броня",
  "item.minecraft.leather_leggings": "Кожаные штаны",
  "item.minecraft.light_blue_bundle": "Голубой мѣшокъ",
  "item.minecraft.light_blue_dye": "Голубой краситель",
  "item.minecraft.light_blue_harness": "Голубая упряжь",
  "item.minecraft.light_gray_bundle": "Свѣтлосѣрый мѣшокъ",
  "item.minecraft.light_gray_dye": "Свѣтлосѣрый краситель",
  "item.minecraft.light_gray_harness": "Свѣтлосѣрая упряжь",
  "item.minecraft.lime_bundle": "Яркозелёный мѣшокъ",
  "item.minecraft.lime_dye": "Яркозелёный краситель",
  "item.minecraft.lime_harness": "Яркозелёная упряжь",
  "item.minecraft.lingering_potion": "Туманное снадобье",
  "item.minecraft.lingering_potion.effect.awkward": "Мутное туманное снадобье",
  "item.minecraft.lingering_potion.effect.empty": "Несоздаваемое туманное снадобье",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Туманное снадобье огнестойкости",
  "item.minecraft.lingering_potion.effect.harming": "Туманное снадобье вреда",
  "item.minecraft.lingering_potion.effect.healing": "Туманное снадобье исцѣленія",
  "item.minecraft.lingering_potion.effect.infested": "Туманное снадобье зараженія",
  "item.minecraft.lingering_potion.effect.invisibility": "Туманное снадобье незримости",
  "item.minecraft.lingering_potion.effect.leaping": "Туманное снадобье прыгучести",
  "item.minecraft.lingering_potion.effect.levitation": "Туманное снадобье воздухоплаванія",
  "item.minecraft.lingering_potion.effect.luck": "Туманное снадобье везенія",
  "item.minecraft.lingering_potion.effect.mundane": "Заурядное туманное снадобье",
  "item.minecraft.lingering_potion.effect.night_vision": "Туманное снадобье ночного зрѣнія",
  "item.minecraft.lingering_potion.effect.oozing": "Туманное снадобье слизистости",
  "item.minecraft.lingering_potion.effect.poison": "Туманное снадобье отравленія",
  "item.minecraft.lingering_potion.effect.regeneration": "Туманное снадобье возстановленія",
  "item.minecraft.lingering_potion.effect.slow_falling": "Туманное снадобье плавнаго паденія",
  "item.minecraft.lingering_potion.effect.slowness": "Туманное снадобье замедленія",
  "item.minecraft.lingering_potion.effect.strength": "Туманное снадобье силы",
  "item.minecraft.lingering_potion.effect.swiftness": "Туманное снадобье рѣзвости",
  "item.minecraft.lingering_potion.effect.thick": "Густое туманное снадобье",
  "item.minecraft.lingering_potion.effect.turtle_master": "Туманное снадобье черепашьей мощи",
  "item.minecraft.lingering_potion.effect.water": "Бутылочка съ водяной взвѣсью",
  "item.minecraft.lingering_potion.effect.water_breathing": "Туманное снадобье воднаго дыханія",
  "item.minecraft.lingering_potion.effect.weakness": "Туманное снадобье слабости",
  "item.minecraft.lingering_potion.effect.weaving": "Туманное снадобье плетенія",
  "item.minecraft.lingering_potion.effect.wind_charged": "Туманное снадобье вѣтрового заряда",
  "item.minecraft.llama_spawn_egg": "Яйцо призыва ламы",
  "item.minecraft.lodestone_compass": "Намагниченный компасъ",
  "item.minecraft.mace": "Булава",
  "item.minecraft.magenta_bundle": "Пурпурный мѣшокъ",
  "item.minecraft.magenta_dye": "Пурпурный краситель",
  "item.minecraft.magenta_harness": "Пурпурная упряжь",
  "item.minecraft.magma_cream": "Сгустокъ магмы",
  "item.minecraft.magma_cube_spawn_egg": "Яйцо призыва магмоваго куба",
  "item.minecraft.mangrove_boat": "Мангровая лодка",
  "item.minecraft.mangrove_chest_boat": "Мангровая грузовая лодка",
  "item.minecraft.map": "Чистая карта",
  "item.minecraft.melon_seeds": "Сѣмена арбуза",
  "item.minecraft.melon_slice": "Ломтикъ арбуза",
  "item.minecraft.milk_bucket": "Ведро молока",
  "item.minecraft.minecart": "Вагонетка",
  "item.minecraft.miner_pottery_shard": "Глиняный черепокъ «Шахтёръ»",
  "item.minecraft.miner_pottery_sherd": "Глиняный черепокъ «Шахтёръ»",
  "item.minecraft.mojang_banner_pattern": "Узоръ флага",
  "item.minecraft.mojang_banner_pattern.desc": "Нѣчто",
  "item.minecraft.mojang_banner_pattern.new": "Узоръ флага «Нѣчто»",
  "item.minecraft.mooshroom_spawn_egg": "Яйцо призыва муушрума",
  "item.minecraft.mourner_pottery_shard": "Глиняный черепокъ «Скорбь»",
  "item.minecraft.mourner_pottery_sherd": "Глиняный черепокъ «Скорбь»",
  "item.minecraft.mule_spawn_egg": "Яйцо призыва мула",
  "item.minecraft.mushroom_stew": "Тушёные грибы",
  "item.minecraft.music_disc_11": "Пластинка",
  "item.minecraft.music_disc_11.desc": "C418 — 11",
  "item.minecraft.music_disc_13": "Пластинка",
  "item.minecraft.music_disc_13.desc": "C418 — 13",
  "item.minecraft.music_disc_5": "Пластинка",
  "item.minecraft.music_disc_5.desc": "Самуель Обергъ — 5",
  "item.minecraft.music_disc_blocks": "Пластинка",
  "item.minecraft.music_disc_blocks.desc": "C418 — blocks",
  "item.minecraft.music_disc_cat": "Пластинка",
  "item.minecraft.music_disc_cat.desc": "C418 — cat",
  "item.minecraft.music_disc_chirp": "Пластинка",
  "item.minecraft.music_disc_chirp.desc": "C418 — chirp",
  "item.minecraft.music_disc_creator": "Пластинка",
  "item.minecraft.music_disc_creator.desc": "Лена Рейнъ — Creator",
  "item.minecraft.music_disc_creator_music_box": "Пластинка",
  "item.minecraft.music_disc_creator_music_box.desc": "Лена Рейнъ — Creator (Музыкальная шкатулка)",
  "item.minecraft.music_disc_far": "Пластинка",
  "item.minecraft.music_disc_far.desc": "C418 — far",
  "item.minecraft.music_disc_lava_chicken": "Пластинка",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions — Lava Chicken",
  "item.minecraft.music_disc_mall": "Пластинка",
  "item.minecraft.music_disc_mall.desc": "C418 — mall",
  "item.minecraft.music_disc_mellohi": "Пластинка",
  "item.minecraft.music_disc_mellohi.desc": "C418 — mellohi",
  "item.minecraft.music_disc_otherside": "Пластинка",
  "item.minecraft.music_disc_otherside.desc": "Лена Рейнъ — otherside",
  "item.minecraft.music_disc_pigstep": "Пластинка",
  "item.minecraft.music_disc_pigstep.desc": "Лена Рейнъ — Pigstep",
  "item.minecraft.music_disc_precipice": "Пластинка",
  "item.minecraft.music_disc_precipice.desc": "Ааронъ Шерофъ — Precipice",
  "item.minecraft.music_disc_relic": "Пластинка",
  "item.minecraft.music_disc_relic.desc": "Ааронъ Шерофъ — Relic",
  "item.minecraft.music_disc_stal": "Пластинка",
  "item.minecraft.music_disc_stal.desc": "C418 — stal",
  "item.minecraft.music_disc_strad": "Пластинка",
  "item.minecraft.music_disc_strad.desc": "C418 — strad",
  "item.minecraft.music_disc_tears": "Пластинка",
  "item.minecraft.music_disc_tears.desc": "Эймосъ Родди — Tears",
  "item.minecraft.music_disc_wait": "Пластинка",
  "item.minecraft.music_disc_wait.desc": "C418 — wait",
  "item.minecraft.music_disc_ward": "Пластинка",
  "item.minecraft.music_disc_ward.desc": "C418 — ward",
  "item.minecraft.mutton": "Сырая баранина",
  "item.minecraft.name_tag": "Ярлыкъ",
  "item.minecraft.nautilus_shell": "Раковина наутилуса",
  "item.minecraft.nautilus_spawn_egg": "Яйцо призыва наутилуса",
  "item.minecraft.nether_brick": "Нѣдрскій кирпичъ",
  "item.minecraft.nether_star": "Звѣзда Нѣдра",
  "item.minecraft.nether_wart": "Нѣдрскій наростъ",
  "item.minecraft.netherite_axe": "Нѣдритовый топоръ",
  "item.minecraft.netherite_boots": "Нѣдритовые ботинки",
  "item.minecraft.netherite_chestplate": "Нѣдритовый нагрудникъ",
  "item.minecraft.netherite_helmet": "Нѣдритовый шлемъ",
  "item.minecraft.netherite_hoe": "Нѣдритовая мотыга",
  "item.minecraft.netherite_horse_armor": "Нѣдритовая конская броня",
  "item.minecraft.netherite_ingot": "Нѣдритовый слитокъ",
  "item.minecraft.netherite_leggings": "Нѣдритовые поножи",
  "item.minecraft.netherite_nautilus_armor": "Нѣдритовая броня наутилуса",
  "item.minecraft.netherite_pickaxe": "Нѣдритовая кирка",
  "item.minecraft.netherite_scrap": "Нѣдритовый ломъ",
  "item.minecraft.netherite_shovel": "Нѣдритовая лопата",
  "item.minecraft.netherite_spear": "Нѣдритовое копьё",
  "item.minecraft.netherite_sword": "Нѣдритовый мечъ",
  "item.minecraft.netherite_upgrade_smithing_template": "Кузнечное лекало",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Нѣдритовое улучшеніе",
  "item.minecraft.oak_boat": "Дубовая лодка",
  "item.minecraft.oak_chest_boat": "Дубовая грузовая лодка",
  "item.minecraft.ocelot_spawn_egg": "Яйцо призыва оцелота",
  "item.minecraft.ominous_bottle": "Зловѣщая бутылочка",
  "item.minecraft.ominous_trial_key": "Зловѣщій ключъ испытаній",
  "item.minecraft.orange_bundle": "Оранжевый мѣшокъ",
  "item.minecraft.orange_dye": "Оранжевый краситель",
  "item.minecraft.orange_harness": "Оранжевая упряжь",
  "item.minecraft.painting": "Картина",
  "item.minecraft.pale_oak_boat": "Лодка изъ блѣднаго дуба",
  "item.minecraft.pale_oak_chest_boat": "Грузовая лодка изъ блѣднаго дуба",
  "item.minecraft.panda_spawn_egg": "Яйцо призыва панды",
  "item.minecraft.paper": "Бумага",
  "item.minecraft.parched_spawn_egg": "Яйцо призыва пустынника",
  "item.minecraft.parrot_spawn_egg": "Яйцо призыва попугая",
  "item.minecraft.phantom_membrane": "Мембрана фантома",
  "item.minecraft.phantom_spawn_egg": "Яйцо призыва фантома",
  "item.minecraft.pig_spawn_egg": "Яйцо призыва свиньи",
  "item.minecraft.piglin_banner_pattern": "Узоръ флага",
  "item.minecraft.piglin_banner_pattern.desc": "Рыло",
  "item.minecraft.piglin_banner_pattern.new": "Узоръ флага «Рыло»",
  "item.minecraft.piglin_brute_spawn_egg": "Яйцо призыва брутальнаго пиглина",
  "item.minecraft.piglin_spawn_egg": "Яйцо призыва пиглина",
  "item.minecraft.pillager_spawn_egg": "Яйцо призыва разбойника",
  "item.minecraft.pink_bundle": "Розовый мѣшокъ",
  "item.minecraft.pink_dye": "Розовый краситель",
  "item.minecraft.pink_harness": "Розовая упряжь",
  "item.minecraft.pitcher_plant": "Кувшинница",
  "item.minecraft.pitcher_pod": "Стручокъ кувшинницы",
  "item.minecraft.plenty_pottery_shard": "Глиняный черепокъ «Изобиліе»",
  "item.minecraft.plenty_pottery_sherd": "Глиняный черепокъ «Изобиліе»",
  "item.minecraft.poisonous_potato": "Ядовитый картофель",
  "item.minecraft.polar_bear_spawn_egg": "Яйцо призыва бѣлаго медвѣдя",
  "item.minecraft.popped_chorus_fruit": "Прожаренный плодъ хоруса",
  "item.minecraft.porkchop": "Сырая свинина",
  "item.minecraft.potato": "Картофель",
  "item.minecraft.potion": "Снадобье",
  "item.minecraft.potion.effect.awkward": "Мутное снадобье",
  "item.minecraft.potion.effect.empty": "Несоздаваемое снадобье",
  "item.minecraft.potion.effect.fire_resistance": "Снадобье огнестойкости",
  "item.minecraft.potion.effect.harming": "Снадобье вреда",
  "item.minecraft.potion.effect.healing": "Снадобье исцѣленія",
  "item.minecraft.potion.effect.infested": "Снадобье зараженія",
  "item.minecraft.potion.effect.invisibility": "Снадобье незримости",
  "item.minecraft.potion.effect.leaping": "Снадобье прыгучести",
  "item.minecraft.potion.effect.levitation": "Снадобье воздухоплаванія",
  "item.minecraft.potion.effect.luck": "Снадобье везенія",
  "item.minecraft.potion.effect.mundane": "Заурядное снадобье",
  "item.minecraft.potion.effect.night_vision": "Снадобье ночного зрѣнія",
  "item.minecraft.potion.effect.oozing": "Снадобье слизистости",
  "item.minecraft.potion.effect.poison": "Снадобье отравленія",
  "item.minecraft.potion.effect.regeneration": "Снадобье возстановленія",
  "item.minecraft.potion.effect.slow_falling": "Снадобье плавнаго паденія",
  "item.minecraft.potion.effect.slowness": "Снадобье замедленія",
  "item.minecraft.potion.effect.strength": "Снадобье силы",
  "item.minecraft.potion.effect.swiftness": "Снадобье рѣзвости",
  "item.minecraft.potion.effect.thick": "Густое снадобье",
  "item.minecraft.potion.effect.turtle_master": "Снадобье черепашьей мощи",
  "item.minecraft.potion.effect.water": "Бутылочка воды",
  "item.minecraft.potion.effect.water_breathing": "Снадобье воднаго дыханія",
  "item.minecraft.potion.effect.weakness": "Снадобье слабости",
  "item.minecraft.potion.effect.weaving": "Снадобье плетенія",
  "item.minecraft.potion.effect.wind_charged": "Снадобье вѣтрового заряда",
  "item.minecraft.pottery_shard_archer": "Глиняный черепокъ «Стрѣлецъ»",
  "item.minecraft.pottery_shard_arms_up": "Глиняный черепокъ «Руки вверхъ»",
  "item.minecraft.pottery_shard_prize": "Глиняный черепокъ «Награда»",
  "item.minecraft.pottery_shard_skull": "Глиняный черепокъ «Черепъ»",
  "item.minecraft.powder_snow_bucket": "Ведро съ рыхлымъ снѣгомъ",
  "item.minecraft.prismarine_crystals": "Кристаллъ призмарина",
  "item.minecraft.prismarine_shard": "Осколокъ призмарина",
  "item.minecraft.prize_pottery_shard": "Глиняный черепокъ «Награда»",
  "item.minecraft.prize_pottery_sherd": "Глиняный черепокъ «Награда»",
  "item.minecraft.pufferfish": "Иглобрюхъ",
  "item.minecraft.pufferfish_bucket": "Иглобрюхъ въ ведрѣ",
  "item.minecraft.pufferfish_spawn_egg": "Яйцо призыва иглобрюха",
  "item.minecraft.pumpkin_pie": "Тыквенный пирогъ",
  "item.minecraft.pumpkin_seeds": "Сѣмена тыквы",
  "item.minecraft.purple_bundle": "Фіолетовый мѣшокъ",
  "item.minecraft.purple_dye": "Фіолетовый краситель",
  "item.minecraft.purple_harness": "Фіолетовая упряжь",
  "item.minecraft.quartz": "Нѣдрскій кварцъ",
  "item.minecraft.rabbit": "Сырая крольчатина",
  "item.minecraft.rabbit_foot": "Кроличья лапка",
  "item.minecraft.rabbit_hide": "Кроличья шкурка",
  "item.minecraft.rabbit_spawn_egg": "Яйцо призыва кролика",
  "item.minecraft.rabbit_stew": "Тушёный кроликъ",
  "item.minecraft.raiser_armor_trim_smithing_template": "Кузнечное лекало",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Отдѣлка «Собиратель»",
  "item.minecraft.ravager_spawn_egg": "Яйцо призыва разорителя",
  "item.minecraft.raw_copper": "Рудная мѣдь",
  "item.minecraft.raw_gold": "Рудное золото",
  "item.minecraft.raw_iron": "Рудное желѣзо",
  "item.minecraft.recovery_compass": "Возвратный компасъ",
  "item.minecraft.red_bundle": "Червонный мѣшокъ",
  "item.minecraft.red_dye": "Червонный краситель",
  "item.minecraft.red_harness": "Червонная упряжь",
  "item.minecraft.redstone": "Редстоуновая пыль",
  "item.minecraft.resin_brick": "Смоляной кирпичъ",
  "item.minecraft.resin_clump": "Сгустокъ смолы",
  "item.minecraft.rib_armor_trim_smithing_template": "Кузнечное лекало",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Отдѣлка «Ребро»",
  "item.minecraft.rotten_flesh": "Прѣлая плоть",
  "item.minecraft.saddle": "Сѣдло",
  "item.minecraft.salmon": "Сырой лосось",
  "item.minecraft.salmon_bucket": "Лосось въ ведрѣ",
  "item.minecraft.salmon_spawn_egg": "Яйцо призыва лосося",
  "item.minecraft.scrape_pottery_sherd": "Глиняный черепокъ «Обтёсываніе»",
  "item.minecraft.scute": "Щитокъ",
  "item.minecraft.sentry_armor_trim_smithing_template": "Кузнечное лекало",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Отдѣлка «Стражъ»",
  "item.minecraft.shaper_armor_trim_smithing_template": "Кузнечное лекало",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Отдѣлка «Скульпторъ»",
  "item.minecraft.sheaf_pottery_shard": "Глиняный черепокъ «Снопъ»",
  "item.minecraft.sheaf_pottery_sherd": "Глиняный черепокъ «Снопъ»",
  "item.minecraft.shears": "Ножницы",
  "item.minecraft.sheep_spawn_egg": "Яйцо призыва овцы",
  "item.minecraft.shelter_pottery_shard": "Глиняный черепокъ «Укрытіе»",
  "item.minecraft.shelter_pottery_sherd": "Глиняный черепокъ «Укрытіе»",
  "item.minecraft.shield": "Щитъ",
  "item.minecraft.shield.black": "Чёрный щитъ",
  "item.minecraft.shield.blue": "Лазурный щитъ",
  "item.minecraft.shield.brown": "Коричневый щитъ",
  "item.minecraft.shield.cyan": "Бирюзовый щитъ",
  "item.minecraft.shield.gray": "Сѣрый щитъ",
  "item.minecraft.shield.green": "Зелёный щитъ",
  "item.minecraft.shield.light_blue": "Голубой щитъ",
  "item.minecraft.shield.light_gray": "Свѣтлосѣрый щитъ",
  "item.minecraft.shield.lime": "Яркозелёный щитъ",
  "item.minecraft.shield.magenta": "Пурпурный щитъ",
  "item.minecraft.shield.orange": "Оранжевый щитъ",
  "item.minecraft.shield.pink": "Розовый щитъ",
  "item.minecraft.shield.purple": "Фіолетовый щитъ",
  "item.minecraft.shield.red": "Червонный щитъ",
  "item.minecraft.shield.white": "Бѣлый щитъ",
  "item.minecraft.shield.yellow": "Жёлтый щитъ",
  "item.minecraft.shulker_shell": "Панцырь шалкера",
  "item.minecraft.shulker_spawn_egg": "Яйцо призыва шалкера",
  "item.minecraft.sign": "Табличка",
  "item.minecraft.silence_armor_trim_smithing_template": "Кузнечное лекало",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Отдѣлка «Тишина»",
  "item.minecraft.silverfish_spawn_egg": "Яйцо призыва чешуйницы",
  "item.minecraft.skeleton_horse_spawn_egg": "Яйцо призыва лошади-скелета",
  "item.minecraft.skeleton_spawn_egg": "Яйцо призыва скелета",
  "item.minecraft.skull_banner_pattern": "Узоръ флага",
  "item.minecraft.skull_banner_pattern.desc": "Черепъ",
  "item.minecraft.skull_banner_pattern.new": "Узоръ флага «Черепъ»",
  "item.minecraft.skull_pottery_shard": "Глиняный черепокъ «Черепъ»",
  "item.minecraft.skull_pottery_sherd": "Глиняный черепокъ «Черепъ»",
  "item.minecraft.slime_ball": "Сгустокъ слизи",
  "item.minecraft.slime_spawn_egg": "Яйцо призыва слизня",
  "item.minecraft.smithing_template": "Кузнечное лекало",
  "item.minecraft.smithing_template.applies_to": "Примѣняется къ:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Помѣстите слитокъ или кристаллъ",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Доспѣхамъ",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Помѣстите элементъ брони",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Слитки и кристаллы",
  "item.minecraft.smithing_template.ingredients": "Матеріалы:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Помѣстите нѣдритовый слитокъ",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Діамантовому снаряженію",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Помѣстите діамантовый доспѣхъ, инструментъ или оружіе",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Нѣдритовый слитокъ",
  "item.minecraft.smithing_template.upgrade": "Улучшеніе: ",
  "item.minecraft.sniffer_spawn_egg": "Яйцо призыва нюхача",
  "item.minecraft.snort_pottery_shard": "Глиняный черепокъ «Шмыгъ»",
  "item.minecraft.snort_pottery_sherd": "Глиняный черепокъ «Шмыгъ»",
  "item.minecraft.snout_armor_trim_smithing_template": "Кузнечное лекало",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Отдѣлка «Рыло»",
  "item.minecraft.snow_golem_spawn_egg": "Яйцо призыва снѣжной бабы",
  "item.minecraft.snowball": "Снѣжокъ",
  "item.minecraft.spectral_arrow": "Стрѣла наблюденія",
  "item.minecraft.spider_eye": "Паучье око",
  "item.minecraft.spider_spawn_egg": "Яйцо призыва паука",
  "item.minecraft.spire_armor_trim_smithing_template": "Кузнечное лекало",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Отдѣлка «Шпиль»",
  "item.minecraft.splash_potion": "Взрывное снадобье",
  "item.minecraft.splash_potion.effect.awkward": "Мутное взрывное снадобье",
  "item.minecraft.splash_potion.effect.empty": "Несоздаваемое взрывное снадобье",
  "item.minecraft.splash_potion.effect.fire_resistance": "Взрывное снадобье огнестойкости",
  "item.minecraft.splash_potion.effect.harming": "Взрывное снадобье вреда",
  "item.minecraft.splash_potion.effect.healing": "Взрывное снадобье исцѣленія",
  "item.minecraft.splash_potion.effect.infested": "Взрывное снадобье зараженія",
  "item.minecraft.splash_potion.effect.invisibility": "Взрывное снадобье незримости",
  "item.minecraft.splash_potion.effect.leaping": "Взрывное снадобье прыгучести",
  "item.minecraft.splash_potion.effect.levitation": "Взрывное снадобье воздухоплаванія",
  "item.minecraft.splash_potion.effect.luck": "Взрывное снадобье везенія",
  "item.minecraft.splash_potion.effect.mundane": "Заурядное взрывное снадобье",
  "item.minecraft.splash_potion.effect.night_vision": "Взрывное снадобье ночного зрѣнія",
  "item.minecraft.splash_potion.effect.oozing": "Взрывное снадобье слизистости",
  "item.minecraft.splash_potion.effect.poison": "Взрывное снадобье отравленія",
  "item.minecraft.splash_potion.effect.regeneration": "Взрывное снадобье возстановленія",
  "item.minecraft.splash_potion.effect.slow_falling": "Взрывное снадобье плавнаго паденія",
  "item.minecraft.splash_potion.effect.slowness": "Взрывное снадобье замедленія",
  "item.minecraft.splash_potion.effect.strength": "Взрывное снадобье силы",
  "item.minecraft.splash_potion.effect.swiftness": "Взрывное снадобье рѣзвости",
  "item.minecraft.splash_potion.effect.thick": "Густое взрывное снадобье",
  "item.minecraft.splash_potion.effect.turtle_master": "Взрывное снадобье черепашьей мощи",
  "item.minecraft.splash_potion.effect.water": "Взрывная бутылочка воды",
  "item.minecraft.splash_potion.effect.water_breathing": "Взрывное снадобье воднаго дыханія",
  "item.minecraft.splash_potion.effect.weakness": "Взрывное снадобье слабости",
  "item.minecraft.splash_potion.effect.weaving": "Взрывное снадобье плетенія",
  "item.minecraft.splash_potion.effect.wind_charged": "Взрывное снадобье вѣтрового заряда",
  "item.minecraft.spruce_boat": "Еловая лодка",
  "item.minecraft.spruce_chest_boat": "Еловая грузовая лодка",
  "item.minecraft.spyglass": "Подзорная труба",
  "item.minecraft.squid_spawn_egg": "Яйцо призыва осьминога",
  "item.minecraft.stick": "Палка",
  "item.minecraft.stone_axe": "Каменный топоръ",
  "item.minecraft.stone_hoe": "Каменная мотыга",
  "item.minecraft.stone_pickaxe": "Каменная кирка",
  "item.minecraft.stone_shovel": "Каменная лопата",
  "item.minecraft.stone_spear": "Каменное копьё",
  "item.minecraft.stone_sword": "Каменный мечъ",
  "item.minecraft.stray_spawn_egg": "Яйцо призыва зимогора",
  "item.minecraft.strider_spawn_egg": "Яйцо призыва лавомѣрки",
  "item.minecraft.string": "Нить",
  "item.minecraft.sugar": "Сахаръ",
  "item.minecraft.suspicious_stew": "Загадочное рагу",
  "item.minecraft.sweet_berries": "Сладкія ягоды",
  "item.minecraft.tadpole_bucket": "Головастикъ въ ведрѣ",
  "item.minecraft.tadpole_spawn_egg": "Яйцо призыва головастика",
  "item.minecraft.tide_armor_trim_smithing_template": "Кузнечное лекало",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Отдѣлка «Приливъ»",
  "item.minecraft.tipped_arrow": "Обработанная стрѣла",
  "item.minecraft.tipped_arrow.effect.awkward": "Обработанная стрѣла",
  "item.minecraft.tipped_arrow.effect.empty": "Обработанная несоздаваемымъ снадобьемъ стрѣла",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Стрѣла огнестойкости",
  "item.minecraft.tipped_arrow.effect.harming": "Стрѣла вреда",
  "item.minecraft.tipped_arrow.effect.healing": "Стрѣла исцѣленія",
  "item.minecraft.tipped_arrow.effect.infested": "Стрѣла зараженія",
  "item.minecraft.tipped_arrow.effect.invisibility": "Стрѣла незримости",
  "item.minecraft.tipped_arrow.effect.leaping": "Стрѣла прыгучести",
  "item.minecraft.tipped_arrow.effect.levitation": "Стрѣла воздухоплаванія",
  "item.minecraft.tipped_arrow.effect.luck": "Стрѣла везенія",
  "item.minecraft.tipped_arrow.effect.mundane": "Обработанная стрѣла",
  "item.minecraft.tipped_arrow.effect.night_vision": "Стрѣла ночного зрѣнія",
  "item.minecraft.tipped_arrow.effect.oozing": "Стрѣла слизистости",
  "item.minecraft.tipped_arrow.effect.poison": "Стрѣла отравленія",
  "item.minecraft.tipped_arrow.effect.regeneration": "Стрѣла возстановленія",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Стрѣла плавнаго паденія",
  "item.minecraft.tipped_arrow.effect.slowness": "Стрѣла замедленія",
  "item.minecraft.tipped_arrow.effect.strength": "Стрѣла силы",
  "item.minecraft.tipped_arrow.effect.swiftness": "Стрѣла рѣзвости",
  "item.minecraft.tipped_arrow.effect.thick": "Обработанная стрѣла",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Стрѣла черепашьей мощи",
  "item.minecraft.tipped_arrow.effect.water": "Взрывная стрѣла",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Стрѣла воднаго дыханія",
  "item.minecraft.tipped_arrow.effect.weakness": "Стрѣла слабости",
  "item.minecraft.tipped_arrow.effect.weaving": "Стрѣла плетенія",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Стрѣла вѣтрового заряда",
  "item.minecraft.tnt_minecart": "Вагонетка съ динамитомъ",
  "item.minecraft.torchflower_seeds": "Сѣмена факелоцвѣта",
  "item.minecraft.totem_of_undying": "Тотемъ безсмертія",
  "item.minecraft.trader_llama_spawn_egg": "Яйцо призыва ламы коробейника",
  "item.minecraft.trial_key": "Ключъ испытаній",
  "item.minecraft.trident": "Трезубецъ",
  "item.minecraft.tropical_fish": "Тропическая рыба",
  "item.minecraft.tropical_fish_bucket": "Тропическая рыба въ ведрѣ",
  "item.minecraft.tropical_fish_spawn_egg": "Яйцо призыва тропической рыбы",
  "item.minecraft.turtle_helmet": "Черепашій панцырь",
  "item.minecraft.turtle_scute": "Черепашій щитокъ",
  "item.minecraft.turtle_spawn_egg": "Яйцо призыва черепахи",
  "item.minecraft.vex_armor_trim_smithing_template": "Кузнечное лекало",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Отдѣлка «Вредина»",
  "item.minecraft.vex_spawn_egg": "Яйцо призыва вредины",
  "item.minecraft.villager_spawn_egg": "Яйцо призыва крестьянина",
  "item.minecraft.vindicator_spawn_egg": "Яйцо призыва воздаятеля",
  "item.minecraft.wandering_trader_spawn_egg": "Яйцо призыва коробейника",
  "item.minecraft.ward_armor_trim_smithing_template": "Кузнечное лекало",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Отдѣлка «Хранитель»",
  "item.minecraft.warden_spawn_egg": "Яйцо призыва хранителя",
  "item.minecraft.warped_fungus_on_a_stick": "Удочка съ искажённымъ грибомъ",
  "item.minecraft.water_bucket": "Ведро воды",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Кузнечное лекало",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Отдѣлка «Путникъ»",
  "item.minecraft.wheat": "Пшеница",
  "item.minecraft.wheat_seeds": "Сѣмена пшеницы",
  "item.minecraft.white_bundle": "Бѣлый мѣшокъ",
  "item.minecraft.white_dye": "Бѣлый краситель",
  "item.minecraft.white_harness": "Бѣлая упряжь",
  "item.minecraft.wild_armor_trim_smithing_template": "Кузнечное лекало",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Отдѣлка «Дебри»",
  "item.minecraft.wind_charge": "Зарядъ вѣтра",
  "item.minecraft.witch_spawn_egg": "Яйцо призыва вѣдьмы",
  "item.minecraft.wither_skeleton_spawn_egg": "Яйцо призыва визеръ-скелета",
  "item.minecraft.wither_spawn_egg": "Яйцо призыва визера",
  "item.minecraft.wolf_armor": "Волчья броня",
  "item.minecraft.wolf_spawn_egg": "Яйцо призыва волка",
  "item.minecraft.wooden_axe": "Деревянный топоръ",
  "item.minecraft.wooden_hoe": "Деревянная мотыга",
  "item.minecraft.wooden_pickaxe": "Деревянная кирка",
  "item.minecraft.wooden_shovel": "Деревянная лопата",
  "item.minecraft.wooden_spear": "Деревянное копьё",
  "item.minecraft.wooden_sword": "Деревянный мечъ",
  "item.minecraft.writable_book": "Книга и перо",
  "item.minecraft.written_book": "Завершённая книга",
  "item.minecraft.yellow_bundle": "Жёлтый мѣшокъ",
  "item.minecraft.yellow_dye": "Жёлтый краситель",
  "item.minecraft.yellow_harness": "Жёлтая упряжь",
  "item.minecraft.zoglin_spawn_egg": "Яйцо призыва зоглина",
  "item.minecraft.zombie_horse_spawn_egg": "Яйцо призыва лошади-мертвеца",
  "item.minecraft.zombie_nautilus_spawn_egg": "Яйцо призыва наутилуса-мертвеца",
  "item.minecraft.zombie_spawn_egg": "Яйцо призыва мертвеца",
  "item.minecraft.zombie_villager_spawn_egg": "Яйцо призыва крестьянина-мертвеца",
  "item.minecraft.zombified_piglin_spawn_egg": "Яйцо призыва пиглина-мертвеца"
}
export const rpr = items; 
